import './index.css';
var Sc = Object.defineProperty;
var Ac = (t, e, r) => e in t ? Sc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var ze = (t, e, r) => (Ac(t, typeof e != "symbol" ? e + "" : e, r), r);
import { RpcProvider as vs, Account as bs, constants as zt, CallData as go } from "starknet";
import * as at from "react";
import P, { useState as Te, useEffect as ae, useLayoutEffect as Dc, useRef as q, useMemo as ye, forwardRef as Lc, Fragment as Ze, isValidElement as $c, cloneElement as Pc, createElement as Rc, createContext as Xe, useContext as Oe, useReducer as zc, createRef as Fc, useCallback as Ft } from "react";
import { createPortal as Uc } from "react-dom";
var Zc = Object.defineProperty, Bc = (t, e, r) => e in t ? Zc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ut = (t, e, r) => (Bc(t, typeof e != "symbol" ? e + "" : e, r), r);
let we = class extends Error {
  constructor() {
    super(...arguments), ut(this, "name", "ConnectorNotConnectedError"), ut(this, "message", "Connector not connected");
  }
}, Zt = class extends Error {
  constructor() {
    super(...arguments), ut(this, "name", "ConnectorNotFoundError"), ut(this, "message", "Connector not found");
  }
}, yr = class extends Error {
  constructor() {
    super(...arguments), ut(this, "name", "UserRejectedRequestError"), ut(this, "message", "User rejected request");
  }
}, Pi = class extends Error {
  constructor() {
    super(...arguments), ut(this, "name", "UserNotConnectedError"), ut(this, "message", "User not connected");
  }
};
var Ur = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wc(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function _s(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      if (this instanceof n) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(e, i);
        return new o();
      }
      return e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var xs = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function i(c, l, u) {
    this.fn = c, this.context = l, this.once = u || !1;
  }
  function o(c, l, u, p, m) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, p || c, m), w = r ? r + l : l;
    return c._events[w] ? c._events[w].fn ? c._events[w] = [c._events[w], h] : c._events[w].push(h) : (c._events[w] = h, c._eventsCount++), c;
  }
  function s(c, l) {
    --c._eventsCount === 0 ? c._events = new n() : delete c._events[l];
  }
  function a() {
    this._events = new n(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var c = [], l, u;
    if (this._eventsCount === 0)
      return c;
    for (u in l = this._events)
      e.call(l, u) && c.push(r ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
  }, a.prototype.listeners = function(c) {
    var l = r ? r + c : c, u = this._events[l];
    if (!u)
      return [];
    if (u.fn)
      return [u.fn];
    for (var p = 0, m = u.length, h = new Array(m); p < m; p++)
      h[p] = u[p].fn;
    return h;
  }, a.prototype.listenerCount = function(c) {
    var l = r ? r + c : c, u = this._events[l];
    return u ? u.fn ? 1 : u.length : 0;
  }, a.prototype.emit = function(c, l, u, p, m, h) {
    var w = r ? r + c : c;
    if (!this._events[w])
      return !1;
    var f = this._events[w], g = arguments.length, y, b;
    if (f.fn) {
      switch (f.once && this.removeListener(c, f.fn, void 0, !0), g) {
        case 1:
          return f.fn.call(f.context), !0;
        case 2:
          return f.fn.call(f.context, l), !0;
        case 3:
          return f.fn.call(f.context, l, u), !0;
        case 4:
          return f.fn.call(f.context, l, u, p), !0;
        case 5:
          return f.fn.call(f.context, l, u, p, m), !0;
        case 6:
          return f.fn.call(f.context, l, u, p, m, h), !0;
      }
      for (b = 1, y = new Array(g - 1); b < g; b++)
        y[b - 1] = arguments[b];
      f.fn.apply(f.context, y);
    } else {
      var x = f.length, O;
      for (b = 0; b < x; b++)
        switch (f[b].once && this.removeListener(c, f[b].fn, void 0, !0), g) {
          case 1:
            f[b].fn.call(f[b].context);
            break;
          case 2:
            f[b].fn.call(f[b].context, l);
            break;
          case 3:
            f[b].fn.call(f[b].context, l, u);
            break;
          case 4:
            f[b].fn.call(f[b].context, l, u, p);
            break;
          default:
            if (!y)
              for (O = 1, y = new Array(g - 1); O < g; O++)
                y[O - 1] = arguments[O];
            f[b].fn.apply(f[b].context, y);
        }
    }
    return !0;
  }, a.prototype.on = function(c, l, u) {
    return o(this, c, l, u, !1);
  }, a.prototype.once = function(c, l, u) {
    return o(this, c, l, u, !0);
  }, a.prototype.removeListener = function(c, l, u, p) {
    var m = r ? r + c : c;
    if (!this._events[m])
      return this;
    if (!l)
      return s(this, m), this;
    var h = this._events[m];
    if (h.fn)
      h.fn === l && (!p || h.once) && (!u || h.context === u) && s(this, m);
    else {
      for (var w = 0, f = [], g = h.length; w < g; w++)
        (h[w].fn !== l || p && !h[w].once || u && h[w].context !== u) && f.push(h[w]);
      f.length ? this._events[m] = f.length === 1 ? f[0] : f : s(this, m);
    }
    return this;
  }, a.prototype.removeAllListeners = function(c) {
    var l;
    return c ? (l = r ? r + c : c, this._events[l] && s(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = r, a.EventEmitter = a, t.exports = a;
})(xs);
var Yc = xs.exports;
const Qc = /* @__PURE__ */ Wc(Yc);
let Ri = class extends Qc {
};
const Vc = (t) => {
  localStorage.setItem("starknetLastConnectedWallet", t);
}, Mn = () => {
  localStorage.removeItem("starknetLastConnectedWallet");
}, Hc = {
  mainnet: "https://starknet-mainnet.public.blastapi.io",
  testnet: "https://starknet-testnet.public.blastapi.io"
}, qc = {
  mainnet: "https://rpc.starknet.lava.build",
  testnet: "https://rpc.starknet-testnet.lava.build"
}, wo = [Hc, qc];
function Ms() {
  const t = Math.floor(Math.random() * wo.length);
  return wo[t];
}
var Gc = Object.defineProperty, Jc = (t, e, r) => e in t ? Gc(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, dr = (t, e, r) => (Jc(t, typeof e != "symbol" ? e + "" : e, r), r);
const zi = "https://web.argent.xyz", yo = `<svg
    width="32"
    height="28"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.5 0.4375C0.982233 0.4375 0.5625 0.857233 0.5625 1.375V12C0.5625 12.4144 0.72712 12.8118 1.02015 13.1049C1.31317 13.3979 1.7106 13.5625 2.125 13.5625H15.875C16.2894 13.5625 16.6868 13.3979 16.9799 13.1049C17.2729 12.8118 17.4375 12.4144 17.4375 12V1.375C17.4375 0.857233 17.0178 0.4375 16.5 0.4375H1.5ZM2.4375 3.50616V11.6875H15.5625V3.50616L9.63349 8.94108C9.27507 9.26964 8.72493 9.26964 8.36651 8.94108L2.4375 3.50616ZM14.0899 2.3125H3.91013L9 6.97822L14.0899 2.3125Z"
      fill="currentColor"
    />
  </svg>`;
function Kc(t) {
  return t;
}
function Xc(t) {
  return t.length === 0 ? Kc : t.length === 1 ? t[0] : function(e) {
    return t.reduce((r, n) => n(r), e);
  };
}
function el(t) {
  return typeof t == "object" && t !== null && "subscribe" in t;
}
function En(t) {
  const e = {
    subscribe(r) {
      let n = null, i = !1, o = !1, s = !1;
      function a() {
        if (n === null) {
          s = !0;
          return;
        }
        o || (o = !0, typeof n == "function" ? n() : n && n.unsubscribe());
      }
      return n = t({
        next(c) {
          var l;
          i || ((l = r.next) == null || l.call(r, c));
        },
        error(c) {
          var l;
          i || (i = !0, (l = r.error) == null || l.call(r, c), a());
        },
        complete() {
          var c;
          i || (i = !0, (c = r.complete) == null || c.call(r), a());
        }
      }), s && a(), {
        unsubscribe: a
      };
    },
    pipe(...r) {
      return Xc(r)(e);
    }
  };
  return e;
}
function Es(t) {
  return (e) => {
    let r = 0, n = null;
    const i = [];
    function o() {
      n || (n = e.subscribe({
        next(a) {
          var c;
          for (const l of i)
            (c = l.next) == null || c.call(l, a);
        },
        error(a) {
          var c;
          for (const l of i)
            (c = l.error) == null || c.call(l, a);
        },
        complete() {
          var a;
          for (const c of i)
            (a = c.complete) == null || a.call(c);
        }
      }));
    }
    function s() {
      if (r === 0 && n) {
        const a = n;
        n = null, a.unsubscribe();
      }
    }
    return {
      subscribe(a) {
        return r++, i.push(a), o(), {
          unsubscribe() {
            r--, s();
            const c = i.findIndex((l) => l === a);
            c > -1 && i.splice(c, 1);
          }
        };
      }
    };
  };
}
function tl(t) {
  return (e) => ({
    subscribe(r) {
      let n = 0;
      return e.subscribe({
        next(i) {
          var o;
          (o = r.next) == null || o.call(r, t(i, n++));
        },
        error(i) {
          var o;
          (o = r.error) == null || o.call(r, i);
        },
        complete() {
          var i;
          (i = r.complete) == null || i.call(r);
        }
      });
    }
  });
}
function ks(t) {
  return (e) => ({
    subscribe(r) {
      return e.subscribe({
        next(n) {
          var i, o;
          (i = t.next) == null || i.call(t, n), (o = r.next) == null || o.call(r, n);
        },
        error(n) {
          var i, o;
          (i = t.error) == null || i.call(t, n), (o = r.error) == null || o.call(r, n);
        },
        complete() {
          var n, i;
          (n = t.complete) == null || n.call(t), (i = r.complete) == null || i.call(r);
        }
      });
    }
  });
}
let rl = class Cs extends Error {
  constructor(e) {
    super(e), this.name = "ObservableAbortError", Object.setPrototypeOf(this, Cs.prototype);
  }
};
function Ts(t) {
  let e;
  return {
    promise: new Promise((r, n) => {
      let i = !1;
      function o() {
        i || (i = !0, n(new rl("This operation was aborted.")), s.unsubscribe());
      }
      const s = t.subscribe({
        next(a) {
          i = !0, r(a), o();
        },
        error(a) {
          i = !0, n(a), o();
        },
        complete() {
          i = !0, o();
        }
      });
      e = o;
    }),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    abort: e
  };
}
const nl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isObservable: el,
  map: tl,
  observable: En,
  observableToPromise: Ts,
  share: Es,
  tap: ks
}, Symbol.toStringTag, { value: "Module" }));
function Ns(t) {
  return En((e) => {
    function r(n = 0, i = t.op) {
      const o = t.links[n];
      if (!o)
        throw new Error("No more links to execute - did you forget to add an ending link?");
      return o({
        op: i,
        next(s) {
          return r(n + 1, s);
        }
      });
    }
    return r().subscribe(e);
  });
}
function vo(t) {
  return Array.isArray(t) ? t : [
    t
  ];
}
function il(t) {
  return (e) => {
    const r = vo(t.true).map((i) => i(e)), n = vo(t.false).map((i) => i(e));
    return (i) => En((o) => {
      const s = t.condition(i.op) ? r : n;
      return Ns({
        op: i.op,
        links: s
      }).subscribe(o);
    });
  };
}
function ol(t) {
  return t instanceof Is || /**
  * @deprecated
  * Delete in next major
  */
  t.name === "TRPCClientError";
}
let Is = class Hr extends Error {
  static from(e, r = {}) {
    return e instanceof Error ? ol(e) ? (r.meta && (e.meta = {
      ...e.meta,
      ...r.meta
    }), e) : new Hr(e.message, {
      ...r,
      cause: e,
      result: null
    }) : new Hr(e.error.message ?? "", {
      ...r,
      cause: void 0,
      result: e
    });
  }
  constructor(e, r) {
    var i, o;
    const n = r == null ? void 0 : r.cause;
    super(e, {
      cause: n
    }), this.meta = r == null ? void 0 : r.meta, this.cause = n, this.shape = (i = r == null ? void 0 : r.result) == null ? void 0 : i.error, this.data = (o = r == null ? void 0 : r.result) == null ? void 0 : o.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, Hr.prototype);
  }
};
function Os(t) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const r in t) {
    const n = t[r];
    e[n] = r;
  }
  return e;
}
const kn = {
  /**
  * Invalid JSON was received by the server.
  * An error occurred on the server while parsing the JSON text.
  */
  PARSE_ERROR: -32700,
  /**
  * The JSON sent is not a valid Request object.
  */
  BAD_REQUEST: -32600,
  // Internal JSON-RPC error
  INTERNAL_SERVER_ERROR: -32603,
  NOT_IMPLEMENTED: -32603,
  // Implementation specific errors
  UNAUTHORIZED: -32001,
  FORBIDDEN: -32003,
  NOT_FOUND: -32004,
  METHOD_NOT_SUPPORTED: -32005,
  TIMEOUT: -32008,
  CONFLICT: -32009,
  PRECONDITION_FAILED: -32012,
  PAYLOAD_TOO_LARGE: -32013,
  UNPROCESSABLE_CONTENT: -32022,
  TOO_MANY_REQUESTS: -32029,
  CLIENT_CLOSED_REQUEST: -32099
};
Os(kn);
Os(kn);
const sl = {
  PARSE_ERROR: 400,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  METHOD_NOT_SUPPORTED: 405,
  TIMEOUT: 408,
  CONFLICT: 409,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  UNPROCESSABLE_CONTENT: 422,
  TOO_MANY_REQUESTS: 429,
  CLIENT_CLOSED_REQUEST: 499,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501
};
function al(t) {
  return sl[t] ?? 500;
}
function js(t) {
  return al(t.code);
}
const Ss = () => {
};
function As(t, e) {
  return new Proxy(Ss, {
    get(r, n) {
      if (!(typeof n != "string" || n === "then"))
        return As(t, [
          ...e,
          n
        ]);
    },
    apply(r, n, i) {
      const o = e[e.length - 1] === "apply";
      return t({
        args: o ? i.length >= 2 ? i[1] : [] : i,
        path: o ? e.slice(0, -1) : e
      });
    }
  });
}
const Fi = (t) => As(t, []), Ui = (t) => new Proxy(Ss, {
  get(e, r) {
    if (!(typeof r != "string" || r === "then"))
      return t(r);
  }
});
function cl(t) {
  const { path: e, error: r, config: n } = t, { code: i } = t.error, o = {
    message: r.message,
    code: kn[i],
    data: {
      code: i,
      httpStatus: js(r)
    }
  };
  return n.isDev && typeof t.error.stack == "string" && (o.data.stack = t.error.stack), typeof e == "string" && (o.data.path = e), n.errorFormatter({
    ...t,
    shape: o
  });
}
function bo(t, e) {
  return "error" in e ? {
    ...e,
    error: t.transformer.output.serialize(e.error)
  } : "data" in e.result ? {
    ...e,
    result: {
      ...e.result,
      data: t.transformer.output.serialize(e.result.data)
    }
  } : e;
}
function ll(t, e) {
  return Array.isArray(e) ? e.map((r) => bo(t, r)) : bo(t, e);
}
const ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFlatProxy: Ui,
  createRecursiveProxy: Fi,
  getErrorShape: cl,
  transformTRPCResponse: ll
}, Symbol.toStringTag, { value: "Module" }));
function dl(t) {
  return typeof FormData > "u" ? !1 : t instanceof FormData;
}
const Bn = {
  css: {
    query: [
      "72e3ff",
      "3fb0d8"
    ],
    mutation: [
      "c5a3fc",
      "904dfc"
    ],
    subscription: [
      "ff49e1",
      "d83fbe"
    ]
  },
  ansi: {
    regular: {
      // Cyan background, black and white text respectively
      query: [
        "\x1B[30;46m",
        "\x1B[97;46m"
      ],
      // Magenta background, black and white text respectively
      mutation: [
        "\x1B[30;45m",
        "\x1B[97;45m"
      ],
      // Green background, black and white text respectively
      subscription: [
        "\x1B[30;42m",
        "\x1B[97;42m"
      ]
    },
    bold: {
      query: [
        "\x1B[1;30;46m",
        "\x1B[1;97;46m"
      ],
      mutation: [
        "\x1B[1;30;45m",
        "\x1B[1;97;45m"
      ],
      subscription: [
        "\x1B[1;30;42m",
        "\x1B[1;97;42m"
      ]
    }
  }
};
function pl(t) {
  const { direction: e, type: r, path: n, id: i, input: o } = t, s = [], a = [];
  if (t.colorMode === "ansi") {
    const [p, m] = Bn.ansi.regular[r], [h, w] = Bn.ansi.bold[r];
    return s.push(e === "up" ? p : m, e === "up" ? ">>" : "<<", r, e === "up" ? h : w, `#${i}`, n, "\x1B[0m"), e === "up" ? a.push({
      input: t.input
    }) : a.push({
      input: t.input,
      // strip context from result cause it's too noisy in terminal wihtout collapse mode
      result: "result" in t.result ? t.result.result : t.result,
      elapsedMs: t.elapsedMs
    }), {
      parts: s,
      args: a
    };
  }
  const [c, l] = Bn.css[r], u = `
    background-color: #${e === "up" ? c : l}; 
    color: ${e === "up" ? "black" : "white"};
    padding: 2px;
  `;
  return s.push("%c", e === "up" ? ">>" : "<<", r, `#${i}`, `%c${n}%c`, "%O"), a.push(u, `${u}; font-weight: bold;`, `${u}; font-weight: normal;`), e === "up" ? a.push({
    input: o,
    context: t.context
  }) : a.push({
    input: o,
    result: t.result,
    elapsedMs: t.elapsedMs,
    context: t.context
  }), {
    parts: s,
    args: a
  };
}
const fl = ({ c: t = console, colorMode: e = "css" }) => (r) => {
  const n = r.input, i = dl(n) ? Object.fromEntries(n) : n, { parts: o, args: s } = pl({
    ...r,
    colorMode: e,
    input: i
  }), a = r.direction === "down" && r.result && (r.result instanceof Error || "error" in r.result.result) ? "error" : "log";
  t[a].apply(null, [
    o.join(" ")
  ].concat(s));
};
function hl(t = {}) {
  const { enabled: e = () => !0 } = t, r = t.colorMode ?? (typeof window > "u" ? "ansi" : "css"), { logger: n = fl({
    c: t.console,
    colorMode: r
  }) } = t;
  return () => ({ op: i, next: o }) => En((s) => {
    e({
      ...i,
      direction: "up"
    }) && n({
      ...i,
      direction: "up"
    });
    const a = Date.now();
    function c(l) {
      const u = Date.now() - a;
      e({
        ...i,
        direction: "down",
        result: l
      }) && n({
        ...i,
        direction: "down",
        elapsedMs: u,
        result: l
      });
    }
    return o(i).pipe(ks({
      next(l) {
        c(l);
      },
      error(l) {
        c(l);
      }
    })).subscribe(s);
  });
}
let ml = class {
  $request({ type: t, input: e, path: r, context: n = {} }) {
    return Ns({
      links: this.links,
      op: {
        id: ++this.requestId,
        type: t,
        path: r,
        input: e,
        context: n
      }
    }).pipe(Es());
  }
  requestAsPromise(t) {
    const e = this.$request(t), { promise: r, abort: n } = Ts(e);
    return new Promise((i, o) => {
      var s;
      (s = t.signal) == null || s.addEventListener("abort", n), r.then((a) => {
        i(a.result.data);
      }).catch((a) => {
        o(Is.from(a));
      });
    });
  }
  query(t, e, r) {
    return this.requestAsPromise({
      type: "query",
      path: t,
      input: e,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  mutation(t, e, r) {
    return this.requestAsPromise({
      type: "mutation",
      path: t,
      input: e,
      context: r == null ? void 0 : r.context,
      signal: r == null ? void 0 : r.signal
    });
  }
  subscription(t, e, r) {
    return this.$request({
      type: "subscription",
      path: t,
      input: e,
      context: r == null ? void 0 : r.context
    }).subscribe({
      next(n) {
        var i, o, s;
        n.result.type === "started" ? (i = r.onStarted) == null || i.call(r) : n.result.type === "stopped" ? (o = r.onStopped) == null || o.call(r) : (s = r.onData) == null || s.call(r, n.result.data);
      },
      error(n) {
        var i;
        (i = r.onError) == null || i.call(r, n);
      },
      complete() {
        var n;
        (n = r.onComplete) == null || n.call(r);
      }
    });
  }
  constructor(t) {
    this.requestId = 0;
    const e = (() => {
      const r = t.transformer;
      return r ? "input" in r ? t.transformer : {
        input: r,
        output: r
      } : {
        input: {
          serialize: (n) => n,
          deserialize: (n) => n
        },
        output: {
          serialize: (n) => n,
          deserialize: (n) => n
        }
      };
    })();
    this.runtime = {
      transformer: {
        serialize: (r) => e.input.serialize(r),
        deserialize: (r) => e.output.deserialize(r)
      },
      combinedTransformer: e
    }, this.links = t.links.map((r) => r(this.runtime));
  }
};
const gl = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, wl = (t) => gl[t];
function yl(t) {
  return Ui((e) => t.hasOwnProperty(e) ? t[e] : e === "__untypedClient" ? t : Fi(({ path: r, args: n }) => {
    const i = [
      e,
      ...r
    ], o = wl(i.pop()), s = i.join(".");
    return t[o](s, ...n);
  }));
}
function vl(t) {
  const e = new ml(t);
  return yl(e);
}
function bl(t) {
  return !!t && !Array.isArray(t) && typeof t == "object";
}
function _l(t) {
  if (t instanceof Bt)
    return t;
  const e = new Bt({
    code: "INTERNAL_SERVER_ERROR",
    cause: t
  });
  return t instanceof Error && t.stack && (e.stack = t.stack), e;
}
class xl extends Error {
}
function Ml(t) {
  if (t instanceof Error)
    return t;
  const e = typeof t;
  if (!(e === "undefined" || e === "function" || t === null)) {
    if (e !== "object")
      return new Error(String(t));
    if (bl(t)) {
      const r = new xl();
      for (const n in t)
        r[n] = t[n];
      return r;
    }
  }
}
let Bt = class extends Error {
  constructor(e) {
    const r = Ml(e.cause), n = e.message ?? (r == null ? void 0 : r.message) ?? e.code;
    super(n, {
      cause: r
    }), this.code = e.code, this.name = this.constructor.name;
  }
};
function El(t) {
  return "input" in t ? t : {
    input: t,
    output: t
  };
}
const pr = {
  _default: !0,
  input: {
    serialize: (t) => t,
    deserialize: (t) => t
  },
  output: {
    serialize: (t) => t,
    deserialize: (t) => t
  }
}, fr = ({ shape: t }) => t;
function kl(t) {
  return Object.assign(/* @__PURE__ */ Object.create(null), t);
}
const Cl = [
  "query",
  "mutation",
  "subscription"
];
function Tl(t) {
  return "router" in t._def;
}
const Nl = {
  _ctx: null,
  _errorShape: null,
  _meta: null,
  queries: {},
  mutations: {},
  subscriptions: {},
  errorFormatter: fr,
  transformer: pr
}, Il = [
  /**
  * Then is a reserved word because otherwise we can't return a promise that returns a Proxy
  * since JS will think that `.then` is something that exists
  */
  "then"
];
function Ds(t) {
  return function(e) {
    const r = new Set(Object.keys(e).filter((s) => Il.includes(s)));
    if (r.size > 0)
      throw new Error("Reserved words used in `router({})` call: " + Array.from(r).join(", "));
    const n = kl({});
    function i(s, a = "") {
      for (const [c, l] of Object.entries(s ?? {})) {
        const u = `${a}${c}`;
        if (Tl(l)) {
          i(l._def.procedures, `${u}.`);
          continue;
        }
        if (n[u])
          throw new Error(`Duplicate key: ${u}`);
        n[u] = l;
      }
    }
    i(e);
    const o = {
      _config: t,
      router: !0,
      procedures: n,
      ...Nl,
      record: e,
      queries: Object.entries(n).filter((s) => s[1]._def.query).reduce((s, [a, c]) => ({
        ...s,
        [a]: c
      }), {}),
      mutations: Object.entries(n).filter((s) => s[1]._def.mutation).reduce((s, [a, c]) => ({
        ...s,
        [a]: c
      }), {}),
      subscriptions: Object.entries(n).filter((s) => s[1]._def.subscription).reduce((s, [a, c]) => ({
        ...s,
        [a]: c
      }), {})
    };
    return {
      ...e,
      _def: o,
      createCaller(s) {
        return Fi(({ path: a, args: c }) => {
          if (a.length === 1 && Cl.includes(a[0]))
            return Ol({
              procedures: o.procedures,
              path: c[0],
              rawInput: c[1],
              ctx: s,
              type: a[0]
            });
          const l = a.join("."), u = o.procedures[l];
          let p = "query";
          return u._def.mutation ? p = "mutation" : u._def.subscription && (p = "subscription"), u({
            path: l,
            rawInput: c[0],
            ctx: s,
            type: p
          });
        });
      },
      getErrorShape(s) {
        const { path: a, error: c } = s, { code: l } = s.error, u = {
          message: c.message,
          code: kn[l],
          data: {
            code: l,
            httpStatus: js(c)
          }
        };
        return t.isDev && typeof s.error.stack == "string" && (u.data.stack = s.error.stack), typeof a == "string" && (u.data.path = a), this._def._config.errorFormatter({
          ...s,
          shape: u
        });
      }
    };
  };
}
function Ol(t) {
  var i;
  const { type: e, path: r } = t;
  if (!(r in t.procedures) || !((i = t.procedures[r]) != null && i._def[e]))
    throw new Bt({
      code: "NOT_FOUND",
      message: `No "${e}"-procedure on path "${r}"`
    });
  const n = t.procedures[r];
  return n(t);
}
var fs, hs, ms, gs, ws, ys;
const _o = typeof window > "u" || "Deno" in window || ((hs = (fs = globalThis.process) == null ? void 0 : fs.env) == null ? void 0 : hs.NODE_ENV) === "test" || !!((gs = (ms = globalThis.process) == null ? void 0 : ms.env) != null && gs.JEST_WORKER_ID) || !!((ys = (ws = globalThis.process) == null ? void 0 : ws.env) != null && ys.VITEST_WORKER_ID);
function xo(t) {
  const e = t;
  if (typeof e == "function")
    return e;
  if (typeof e.parseAsync == "function")
    return e.parseAsync.bind(e);
  if (typeof e.parse == "function")
    return e.parse.bind(e);
  if (typeof e.validateSync == "function")
    return e.validateSync.bind(e);
  if (typeof e.create == "function")
    return e.create.bind(e);
  if (typeof e.assert == "function")
    return (r) => (e.assert(r), r);
  throw new Error("Could not find a validator fn");
}
function Ls(t, ...e) {
  const r = Object.assign(/* @__PURE__ */ Object.create(null), t);
  for (const n of e)
    for (const i in n) {
      if (i in r && r[i] !== n[i])
        throw new Error(`Duplicate key ${i}`);
      r[i] = n[i];
    }
  return r;
}
function jl() {
  function t(r) {
    return {
      _middlewares: r,
      unstable_pipe(n) {
        const i = "_middlewares" in n ? n._middlewares : [
          n
        ];
        return t([
          ...r,
          ...i
        ]);
      }
    };
  }
  function e(r) {
    return t([
      r
    ]);
  }
  return e;
}
function Mo(t) {
  return t && typeof t == "object" && !Array.isArray(t);
}
function Sl(t) {
  const e = async ({ next: r, rawInput: n, input: i }) => {
    let o;
    try {
      o = await t(n);
    } catch (a) {
      throw new Bt({
        code: "BAD_REQUEST",
        cause: a
      });
    }
    const s = Mo(i) && Mo(o) ? {
      ...i,
      ...o
    } : o;
    return r({
      input: s
    });
  };
  return e._type = "input", e;
}
function Al(t) {
  const e = async ({ next: r }) => {
    const n = await r();
    if (!n.ok)
      return n;
    try {
      const i = await t(n.data);
      return {
        ...n,
        data: i
      };
    } catch (i) {
      throw new Bt({
        message: "Output validation failed",
        code: "INTERNAL_SERVER_ERROR",
        cause: i
      });
    }
  };
  return e._type = "output", e;
}
const $s = "middlewareMarker";
function Lt(t, e) {
  const { middlewares: r = [], inputs: n, meta: i, ...o } = e;
  return Ps({
    ...Ls(t, o),
    inputs: [
      ...t.inputs,
      ...n ?? []
    ],
    middlewares: [
      ...t.middlewares,
      ...r
    ],
    meta: t.meta && i ? {
      ...t.meta,
      ...i
    } : i ?? t.meta
  });
}
function Ps(t = {}) {
  const e = {
    inputs: [],
    middlewares: [],
    ...t
  };
  return {
    _def: e,
    input(r) {
      const n = xo(r);
      return Lt(e, {
        inputs: [
          r
        ],
        middlewares: [
          Sl(n)
        ]
      });
    },
    output(r) {
      const n = xo(r);
      return Lt(e, {
        output: r,
        middlewares: [
          Al(n)
        ]
      });
    },
    meta(r) {
      return Lt(e, {
        meta: r
      });
    },
    /**
    * @deprecated
    * This functionality is deprecated and will be removed in the next major version.
    */
    unstable_concat(r) {
      return Lt(e, r._def);
    },
    use(r) {
      const n = "_middlewares" in r ? r._middlewares : [
        r
      ];
      return Lt(e, {
        middlewares: n
      });
    },
    query(r) {
      return Wn({
        ...e,
        query: !0
      }, r);
    },
    mutation(r) {
      return Wn({
        ...e,
        mutation: !0
      }, r);
    },
    subscription(r) {
      return Wn({
        ...e,
        subscription: !0
      }, r);
    }
  };
}
function Wn(t, e) {
  const r = Lt(t, {
    resolver: e,
    middlewares: [
      async function(n) {
        const i = await e(n);
        return {
          marker: $s,
          ok: !0,
          data: i,
          ctx: n.ctx
        };
      }
    ]
  });
  return Ll(r._def);
}
const Dl = `
If you want to call this function on the server, you do the following:
This is a client-only function.

const caller = appRouter.createCaller({
  /* ... your context */
});

const result = await caller.call('myProcedure', input);
`.trim();
function Ll(t) {
  const e = async function(r) {
    if (!r || !("rawInput" in r))
      throw new Error(Dl);
    const n = async (o = {
      index: 0,
      ctx: r.ctx
    }) => {
      try {
        const s = t.middlewares[o.index];
        return await s({
          ctx: o.ctx,
          type: r.type,
          path: r.path,
          rawInput: o.rawInput ?? r.rawInput,
          meta: t.meta,
          input: o.input,
          next(a) {
            const c = a;
            return n({
              index: o.index + 1,
              ctx: c && "ctx" in c ? {
                ...o.ctx,
                ...c.ctx
              } : o.ctx,
              input: c && "input" in c ? c.input : o.input,
              rawInput: c && "rawInput" in c ? c.rawInput : o.rawInput
            });
          }
        });
      } catch (s) {
        return {
          ok: !1,
          error: _l(s),
          marker: $s
        };
      }
    }, i = await n();
    if (!i)
      throw new Bt({
        code: "INTERNAL_SERVER_ERROR",
        message: "No result from middlewares - did you forget to `return next()`?"
      });
    if (!i.ok)
      throw i.error;
    return i.data;
  };
  return e._def = t, e.meta = t.meta, e;
}
function $l(...t) {
  var i;
  const e = Ls({}, ...t.map((o) => o._def.record)), r = t.reduce((o, s) => {
    if (s._def._config.errorFormatter && s._def._config.errorFormatter !== fr) {
      if (o !== fr && o !== s._def._config.errorFormatter)
        throw new Error("You seem to have several error formatters");
      return s._def._config.errorFormatter;
    }
    return o;
  }, fr), n = t.reduce((o, s) => {
    if (s._def._config.transformer && s._def._config.transformer !== pr) {
      if (o !== pr && o !== s._def._config.transformer)
        throw new Error("You seem to have several transformers");
      return s._def._config.transformer;
    }
    return o;
  }, pr);
  return Ds({
    errorFormatter: r,
    transformer: n,
    isDev: t.some((o) => o._def._config.isDev),
    allowOutsideOfServer: t.some((o) => o._def._config.allowOutsideOfServer),
    isServer: t.some((o) => o._def._config.isServer),
    $types: (i = t[0]) == null ? void 0 : i._def._config.$types
  })(e);
}
let Pl = class fi {
  context() {
    return new fi();
  }
  meta() {
    return new fi();
  }
  create(e) {
    return zl()(e);
  }
};
const Rl = new Pl();
function zl() {
  return function(t) {
    var n, i;
    const e = (t == null ? void 0 : t.errorFormatter) ?? fr, r = {
      transformer: El((t == null ? void 0 : t.transformer) ?? pr),
      isDev: (t == null ? void 0 : t.isDev) ?? ((i = (n = globalThis.process) == null ? void 0 : n.env) == null ? void 0 : i.NODE_ENV) !== "production",
      allowOutsideOfServer: (t == null ? void 0 : t.allowOutsideOfServer) ?? !1,
      errorFormatter: e,
      isServer: (t == null ? void 0 : t.isServer) ?? _o,
      /**
      * @internal
      */
      $types: Ui((o) => {
        throw new Error(`Tried to access "$types.${o}" which is not available at runtime`);
      })
    };
    if (!((t == null ? void 0 : t.isServer) ?? _o) && (t == null ? void 0 : t.allowOutsideOfServer) !== !0)
      throw new Error("You're trying to use @trpc/server in a non-server environment. This is not supported by default.");
    return {
      /**
      * These are just types, they can't be used
      * @internal
      */
      _config: r,
      /**
      * Builder object for creating procedures
      */
      procedure: Ps({
        meta: t == null ? void 0 : t.defaultMeta
      }),
      /**
      * Create reusable middlewares
      */
      middleware: jl(),
      /**
      * Create a router
      */
      router: Ds(r),
      /**
      * Merge Routers
      */
      mergeRouters: $l
    };
  };
}
var hi = {}, Cn = {}, Vt = {}, oe = {};
const Ht = /* @__PURE__ */ _s(nl);
var Zi = {}, Rs = Ht;
function zs(t) {
  return Rs.observable((e) => {
    function r(n = 0, i = t.op) {
      const o = t.links[n];
      if (!o)
        throw new Error("No more links to execute - did you forget to add an ending link?");
      return o({
        op: i,
        next(s) {
          return r(n + 1, s);
        }
      });
    }
    return r().subscribe(e);
  });
}
function Eo(t) {
  return Array.isArray(t) ? t : [
    t
  ];
}
function Fl(t) {
  return (e) => {
    const r = Eo(t.true).map((i) => i(e)), n = Eo(t.false).map((i) => i(e));
    return (i) => Rs.observable((o) => {
      const s = t.condition(i.op) ? r : n;
      return zs({
        op: i.op,
        links: s
      }).subscribe(o);
    });
  };
}
Zi.createChain = zs;
Zi.splitLink = Fl;
var qt = {};
function Ul(t) {
  return t instanceof Fs || /**
  * @deprecated
  * Delete in next major
  */
  t.name === "TRPCClientError";
}
let Fs = class qr extends Error {
  static from(e, r = {}) {
    return e instanceof Error ? Ul(e) ? (r.meta && (e.meta = {
      ...e.meta,
      ...r.meta
    }), e) : new qr(e.message, {
      ...r,
      cause: e,
      result: null
    }) : new qr(e.error.message ?? "", {
      ...r,
      cause: void 0,
      result: e
    });
  }
  constructor(e, r) {
    var i, o;
    const n = r == null ? void 0 : r.cause;
    super(e, {
      cause: n
    }), this.meta = r == null ? void 0 : r.meta, this.cause = n, this.shape = (i = r == null ? void 0 : r.result) == null ? void 0 : i.error, this.data = (o = r == null ? void 0 : r.result) == null ? void 0 : o.error.data, this.name = "TRPCClientError", Object.setPrototypeOf(this, qr.prototype);
  }
};
qt.TRPCClientError = Fs;
const Zl = /* @__PURE__ */ _s(ul);
var We = {}, Bl = qt;
const ko = (t) => typeof t == "function";
function Us(t) {
  if (t)
    return t;
  if (typeof window < "u" && ko(window.fetch))
    return window.fetch;
  if (typeof globalThis < "u" && ko(globalThis.fetch))
    return globalThis.fetch;
  throw new Error("No fetch implementation found");
}
function Wl(t) {
  return t || (typeof window < "u" && window.AbortController ? window.AbortController : typeof globalThis < "u" && globalThis.AbortController ? globalThis.AbortController : null);
}
function Yl(t) {
  return {
    url: t.url,
    fetch: t.fetch,
    AbortController: Wl(t.AbortController)
  };
}
function Ql(t) {
  const e = {};
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    e[r] = n;
  }
  return e;
}
const Vl = {
  query: "GET",
  mutation: "POST"
};
function Zs(t) {
  return "input" in t ? t.runtime.transformer.serialize(t.input) : Ql(t.inputs.map((e) => t.runtime.transformer.serialize(e)));
}
const Bs = (t) => {
  let e = t.url + "/" + t.path;
  const r = [];
  if ("inputs" in t && r.push("batch=1"), t.type === "query") {
    const n = Zs(t);
    n !== void 0 && r.push(`input=${encodeURIComponent(JSON.stringify(n))}`);
  }
  return r.length && (e += "?" + r.join("&")), e;
}, Ws = (t) => {
  if (t.type === "query")
    return;
  const e = Zs(t);
  return e !== void 0 ? JSON.stringify(e) : void 0;
}, Hl = (t) => Qs({
  ...t,
  contentTypeHeader: "application/json",
  getUrl: Bs,
  getBody: Ws
});
async function Ys(t, e) {
  const r = t.getUrl(t), n = t.getBody(t), { type: i } = t, o = await t.headers();
  /* istanbul ignore if -- @preserve */
  if (i === "subscription")
    throw new Error("Subscriptions should use wsLink");
  const s = {
    ...t.contentTypeHeader ? {
      "content-type": t.contentTypeHeader
    } : {},
    ...t.batchModeHeader ? {
      "trpc-batch-mode": t.batchModeHeader
    } : {},
    ...o
  };
  return Us(t.fetch)(r, {
    method: Vl[i],
    signal: e == null ? void 0 : e.signal,
    body: n,
    headers: s
  });
}
function Qs(t) {
  const e = t.AbortController ? new t.AbortController() : null, r = {};
  return {
    promise: new Promise((n, i) => {
      Ys(t, e).then((o) => (r.response = o, o.json())).then((o) => {
        r.responseJSON = o, n({
          json: o,
          meta: r
        });
      }).catch((o) => {
        i(Bl.TRPCClientError.from(o, {
          meta: r
        }));
      });
    }),
    cancel: () => {
      e == null || e.abort();
    }
  };
}
We.fetchHTTPResponse = Ys;
We.getBody = Ws;
We.getFetch = Us;
We.getUrl = Bs;
We.httpRequest = Qs;
We.jsonHttpRequester = Hl;
We.resolveHTTPLinkOptions = Yl;
var Bi = {}, Tn = {};
function Co(t) {
  return !!t && !Array.isArray(t) && typeof t == "object";
}
function ql(t, e) {
  if ("error" in t) {
    const r = e.transformer.deserialize(t.error);
    return {
      ok: !1,
      error: {
        ...t,
        error: r
      }
    };
  }
  return {
    ok: !0,
    result: {
      ...t.result,
      ...(!t.result.type || t.result.type === "data") && {
        type: "data",
        data: e.transformer.deserialize(t.result.data)
      }
    }
  };
}
let Yn = class extends Error {
  constructor() {
    super("Unable to transform response from server");
  }
};
function Gl(t, e) {
  let r;
  try {
    r = ql(t, e);
  } catch {
    throw new Yn();
  }
  if (!r.ok && (!Co(r.error.error) || typeof r.error.error.code != "number"))
    throw new Yn();
  if (r.ok && !Co(r.result))
    throw new Yn();
  return r;
}
Tn.transformResult = Gl;
var Jl = Ht, Kl = Tn, To = qt, mi = We;
const Qn = () => {
  throw new Error("Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new");
};
function Vn(t) {
  let e = null, r = null;
  const n = () => {
    clearTimeout(r), r = null, e = null;
  };
  function i(a) {
    var u, p;
    const c = [
      []
    ];
    let l = 0;
    for (; ; ) {
      const m = a[l];
      if (!m)
        break;
      const h = c[c.length - 1];
      if (m.aborted) {
        (u = m.reject) == null || u.call(m, new Error("Aborted")), l++;
        continue;
      }
      if (t.validate(h.concat(m).map((w) => w.key))) {
        h.push(m), l++;
        continue;
      }
      if (h.length === 0) {
        (p = m.reject) == null || p.call(m, new Error("Input is too big for a single dispatch")), l++;
        continue;
      }
      c.push([]);
    }
    return c;
  }
  function o() {
    const a = i(e);
    n();
    for (const c of a) {
      if (!c.length)
        continue;
      const l = {
        items: c,
        cancel: Qn
      };
      for (const h of c)
        h.batch = l;
      const u = (h, w) => {
        var g;
        const f = l.items[h];
        (g = f.resolve) == null || g.call(f, w), f.batch = null, f.reject = null, f.resolve = null;
      }, { promise: p, cancel: m } = t.fetch(l.items.map((h) => h.key), u);
      l.cancel = m, p.then((h) => {
        var w;
        for (let f = 0; f < h.length; f++) {
          const g = h[f];
          u(f, g);
        }
        for (const f of l.items)
          (w = f.reject) == null || w.call(f, new Error("Missing result")), f.batch = null;
      }).catch((h) => {
        var w;
        for (const f of l.items)
          (w = f.reject) == null || w.call(f, h), f.batch = null;
      });
    }
  }
  function s(a) {
    const c = {
      aborted: !1,
      key: a,
      batch: null,
      resolve: Qn,
      reject: Qn
    }, l = new Promise((u, p) => {
      c.reject = p, c.resolve = u, e || (e = []), e.push(c);
    });
    return r || (r = setTimeout(o)), {
      promise: l,
      cancel: () => {
        var u;
        c.aborted = !0, (u = c.batch) != null && u.items.every((p) => p.aborted) && (c.batch.cancel(), c.batch = null);
      }
    };
  }
  return {
    load: s
  };
}
function Vs(t) {
  return function(e) {
    const r = mi.resolveHTTPLinkOptions(e), n = e.maxURLLength ?? 1 / 0;
    return (i) => {
      const o = (u) => {
        const p = (h) => {
          if (n === 1 / 0)
            return !0;
          const w = h.map((g) => g.path).join(","), f = h.map((g) => g.input);
          return mi.getUrl({
            ...r,
            runtime: i,
            type: u,
            path: w,
            inputs: f
          }).length <= n;
        }, m = t({
          ...r,
          runtime: i,
          type: u,
          opts: e
        });
        return {
          validate: p,
          fetch: m
        };
      }, s = Vn(o("query")), a = Vn(o("mutation")), c = Vn(o("subscription")), l = {
        query: s,
        subscription: c,
        mutation: a
      };
      return ({ op: u }) => Jl.observable((p) => {
        const m = l[u.type], { promise: h, cancel: w } = m.load(u);
        let f;
        return h.then((g) => {
          f = g;
          const y = Kl.transformResult(g.json, i);
          if (!y.ok) {
            p.error(To.TRPCClientError.from(y.error, {
              meta: g.meta
            }));
            return;
          }
          p.next({
            context: g.meta,
            result: y.result
          }), p.complete();
        }).catch((g) => {
          p.error(To.TRPCClientError.from(g, {
            meta: f == null ? void 0 : f.meta
          }));
        }), () => {
          w();
        };
      });
    };
  };
}
const Xl = (t) => (e) => {
  const r = e.map((s) => s.path).join(","), n = e.map((s) => s.input), { promise: i, cancel: o } = mi.jsonHttpRequester({
    ...t,
    path: r,
    inputs: n,
    headers() {
      return t.opts.headers ? typeof t.opts.headers == "function" ? t.opts.headers({
        opList: e
      }) : t.opts.headers : {};
    }
  });
  return {
    promise: i.then((s) => (Array.isArray(s.json) ? s.json : e.map(() => s.json)).map((a) => ({
      meta: s.meta,
      json: a
    }))),
    cancel: o
  };
}, eu = Vs(Xl);
Bi.createHTTPBatchLink = Vs;
Bi.httpBatchLink = eu;
var Nn = {};
Object.defineProperty(Nn, "__esModule", { value: !0 });
var tu = Ht, ru = Tn, No = qt, Hs = We;
function qs(t) {
  return (e) => {
    const r = Hs.resolveHTTPLinkOptions(e);
    return (n) => ({ op: i }) => tu.observable((o) => {
      const { path: s, input: a, type: c } = i, { promise: l, cancel: u } = t.requester({
        ...r,
        runtime: n,
        type: c,
        path: s,
        input: a,
        headers() {
          return e.headers ? typeof e.headers == "function" ? e.headers({
            op: i
          }) : e.headers : {};
        }
      });
      let p;
      return l.then((m) => {
        p = m.meta;
        const h = ru.transformResult(m.json, n);
        if (!h.ok) {
          o.error(No.TRPCClientError.from(h.error, {
            meta: p
          }));
          return;
        }
        o.next({
          context: m.meta,
          result: h.result
        }), o.complete();
      }).catch((m) => {
        o.error(No.TRPCClientError.from(m, {
          meta: p
        }));
      }), () => {
        u();
      };
    });
  };
}
const nu = qs({
  requester: Hs.jsonHttpRequester
});
Nn.httpLink = nu;
Nn.httpLinkFactory = qs;
var Wi = {};
Object.defineProperty(Wi, "__esModule", { value: !0 });
var Io = Ht;
function iu(t) {
  return typeof FormData > "u" ? !1 : t instanceof FormData;
}
const Hn = {
  css: {
    query: [
      "72e3ff",
      "3fb0d8"
    ],
    mutation: [
      "c5a3fc",
      "904dfc"
    ],
    subscription: [
      "ff49e1",
      "d83fbe"
    ]
  },
  ansi: {
    regular: {
      // Cyan background, black and white text respectively
      query: [
        "\x1B[30;46m",
        "\x1B[97;46m"
      ],
      // Magenta background, black and white text respectively
      mutation: [
        "\x1B[30;45m",
        "\x1B[97;45m"
      ],
      // Green background, black and white text respectively
      subscription: [
        "\x1B[30;42m",
        "\x1B[97;42m"
      ]
    },
    bold: {
      query: [
        "\x1B[1;30;46m",
        "\x1B[1;97;46m"
      ],
      mutation: [
        "\x1B[1;30;45m",
        "\x1B[1;97;45m"
      ],
      subscription: [
        "\x1B[1;30;42m",
        "\x1B[1;97;42m"
      ]
    }
  }
};
function ou(t) {
  const { direction: e, type: r, path: n, id: i, input: o } = t, s = [], a = [];
  if (t.colorMode === "ansi") {
    const [p, m] = Hn.ansi.regular[r], [h, w] = Hn.ansi.bold[r];
    return s.push(e === "up" ? p : m, e === "up" ? ">>" : "<<", r, e === "up" ? h : w, `#${i}`, n, "\x1B[0m"), e === "up" ? a.push({
      input: t.input
    }) : a.push({
      input: t.input,
      // strip context from result cause it's too noisy in terminal wihtout collapse mode
      result: "result" in t.result ? t.result.result : t.result,
      elapsedMs: t.elapsedMs
    }), {
      parts: s,
      args: a
    };
  }
  const [c, l] = Hn.css[r], u = `
    background-color: #${e === "up" ? c : l}; 
    color: ${e === "up" ? "black" : "white"};
    padding: 2px;
  `;
  return s.push("%c", e === "up" ? ">>" : "<<", r, `#${i}`, `%c${n}%c`, "%O"), a.push(u, `${u}; font-weight: bold;`, `${u}; font-weight: normal;`), e === "up" ? a.push({
    input: o,
    context: t.context
  }) : a.push({
    input: o,
    result: t.result,
    elapsedMs: t.elapsedMs,
    context: t.context
  }), {
    parts: s,
    args: a
  };
}
const su = ({ c: t = console, colorMode: e = "css" }) => (r) => {
  const n = r.input, i = iu(n) ? Object.fromEntries(n) : n, { parts: o, args: s } = ou({
    ...r,
    colorMode: e,
    input: i
  }), a = r.direction === "down" && r.result && (r.result instanceof Error || "error" in r.result.result) ? "error" : "log";
  t[a].apply(null, [
    o.join(" ")
  ].concat(s));
};
function au(t = {}) {
  const { enabled: e = () => !0 } = t, r = t.colorMode ?? (typeof window > "u" ? "ansi" : "css"), { logger: n = su({
    c: t.console,
    colorMode: r
  }) } = t;
  return () => ({ op: i, next: o }) => Io.observable((s) => {
    e({
      ...i,
      direction: "up"
    }) && n({
      ...i,
      direction: "up"
    });
    const a = Date.now();
    function c(l) {
      const u = Date.now() - a;
      e({
        ...i,
        direction: "down",
        result: l
      }) && n({
        ...i,
        direction: "down",
        elapsedMs: u,
        result: l
      });
    }
    return o(i).pipe(Io.tap({
      next(l) {
        c(l);
      },
      error(l) {
        c(l);
      }
    })).subscribe(s);
  });
}
Wi.loggerLink = au;
var In = {};
Object.defineProperty(In, "__esModule", { value: !0 });
var cu = Ht, lu = Tn, Gs = qt;
/* istanbul ignore next -- @preserve */
const uu = (t) => t === 0 ? 0 : Math.min(1e3 * 2 ** t, 3e4);
function du(t) {
  const { url: e, WebSocket: r = WebSocket, retryDelayMs: n = uu, onOpen: i, onClose: o } = t;
  /* istanbul ignore next -- @preserve */
  if (!r)
    throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
  let s = [];
  const a = /* @__PURE__ */ Object.create(null);
  let c = 0, l = null, u = null, p = O(), m = "connecting";
  function h() {
    m !== "open" || l || (l = setTimeout(() => {
      l = null, s.length === 1 ? p.send(JSON.stringify(s.pop())) : p.send(JSON.stringify(s)), s = [];
    }));
  }
  function w() {
    if (u !== null || m === "closed")
      return;
    const S = n(c++);
    g(S);
  }
  function f() {
    m = "connecting";
    const S = p;
    p = O(), y(S);
  }
  function g(S) {
    u || (m = "connecting", u = setTimeout(f, S));
  }
  function y(S) {
    Object.values(a).some((W) => W.ws === S) || S.close();
  }
  function b() {
    Object.values(a).forEach((S) => {
      S.type === "subscription" && S.callbacks.complete();
    });
  }
  function x(S) {
    s.some((W) => W.id === S.op.id) || R(S.op, S.callbacks);
  }
  function O() {
    const S = typeof e == "function" ? e() : e, W = new r(S);
    clearTimeout(u), u = null, W.addEventListener("open", () => {
      /* istanbul ignore next -- @preserve */
      W === p && (c = 0, m = "open", i == null || i(), h());
    }), W.addEventListener("error", () => {
      W === p && w();
    });
    const he = (J) => {
      if (J.method === "reconnect" && W === p) {
        m === "open" && (o == null || o()), f();
        for (const U of Object.values(a))
          U.type === "subscription" && x(U);
      }
    }, le = (J) => {
      var ce, Y;
      const U = J.id !== null && a[J.id];
      if (U) {
        if ((Y = (ce = U.callbacks).next) == null || Y.call(ce, J), U.ws !== p && W === p) {
          const X = U.ws;
          U.ws = p, y(X);
        }
        "result" in J && J.result.type === "stopped" && W === p && U.callbacks.complete();
      }
    };
    return W.addEventListener("message", ({ data: J }) => {
      const U = JSON.parse(J);
      "method" in U ? he(U) : le(U), (W !== p || m === "closed") && y(W);
    }), W.addEventListener("close", ({ code: J }) => {
      var U, ce, Y, X;
      m === "open" && (o == null || o({
        code: J
      })), p === W && w();
      for (const [se, me] of Object.entries(a))
        if (me.ws === W) {
          if (m === "closed") {
            delete a[se], (ce = (U = me.callbacks).complete) == null || ce.call(U);
            continue;
          }
          me.type === "subscription" ? x(me) : (delete a[se], (X = (Y = me.callbacks).error) == null || X.call(Y, Gs.TRPCClientError.from(new pu("WebSocket closed prematurely"))));
        }
    }), W;
  }
  function R(S, W) {
    const { type: he, input: le, path: J, id: U } = S, ce = {
      id: U,
      method: he,
      params: {
        input: le,
        path: J
      }
    };
    return a[U] = {
      ws: p,
      type: he,
      callbacks: W,
      op: S
    }, s.push(ce), h(), () => {
      var X, se;
      const Y = (X = a[U]) == null ? void 0 : X.callbacks;
      delete a[U], s = s.filter((me) => me.id !== U), (se = Y == null ? void 0 : Y.complete) == null || se.call(Y), p.readyState === r.OPEN && S.type === "subscription" && (s.push({
        id: U,
        method: "subscription.stop"
      }), h());
    };
  }
  return {
    close: () => {
      m = "closed", o == null || o(), b(), y(p), clearTimeout(u), u = null;
    },
    request: R,
    getConnection() {
      return p;
    }
  };
}
let pu = class Js extends Error {
  constructor(e) {
    super(e), this.name = "TRPCWebSocketClosedError", Object.setPrototypeOf(this, Js.prototype);
  }
};
function fu(t) {
  return (e) => {
    const { client: r } = t;
    return ({ op: n }) => cu.observable((i) => {
      const { type: o, path: s, id: a, context: c } = n, l = e.transformer.serialize(n.input), u = r.request({
        type: o,
        path: s,
        input: l,
        id: a,
        context: c
      }, {
        error(p) {
          i.error(p), u();
        },
        complete() {
          i.complete();
        },
        next(p) {
          const m = lu.transformResult(p, e);
          if (!m.ok) {
            i.error(Gs.TRPCClientError.from(m.error));
            return;
          }
          i.next({
            result: m.result
          }), n.type !== "subscription" && (u(), i.complete());
        }
      });
      return () => {
        u();
      };
    });
  };
}
In.createWSClient = du;
In.wsLink = fu;
Object.defineProperty(oe, "__esModule", { value: !0 });
var Oo = Ht, Ks = Zi, Xs = qt, jo = Zl, hr = We, ea = Bi, Yi = Nn, hu = Wi, ta = In;
let On = class {
  $request({ type: e, input: r, path: n, context: i = {} }) {
    return Ks.createChain({
      links: this.links,
      op: {
        id: ++this.requestId,
        type: e,
        path: n,
        input: r,
        context: i
      }
    }).pipe(Oo.share());
  }
  requestAsPromise(e) {
    const r = this.$request(e), { promise: n, abort: i } = Oo.observableToPromise(r);
    return new Promise((o, s) => {
      var a;
      (a = e.signal) == null || a.addEventListener("abort", i), n.then((c) => {
        o(c.result.data);
      }).catch((c) => {
        s(Xs.TRPCClientError.from(c));
      });
    });
  }
  query(e, r, n) {
    return this.requestAsPromise({
      type: "query",
      path: e,
      input: r,
      context: n == null ? void 0 : n.context,
      signal: n == null ? void 0 : n.signal
    });
  }
  mutation(e, r, n) {
    return this.requestAsPromise({
      type: "mutation",
      path: e,
      input: r,
      context: n == null ? void 0 : n.context,
      signal: n == null ? void 0 : n.signal
    });
  }
  subscription(e, r, n) {
    return this.$request({
      type: "subscription",
      path: e,
      input: r,
      context: n == null ? void 0 : n.context
    }).subscribe({
      next(i) {
        var o, s, a;
        i.result.type === "started" ? (o = n.onStarted) == null || o.call(n) : i.result.type === "stopped" ? (s = n.onStopped) == null || s.call(n) : (a = n.onData) == null || a.call(n, i.result.data);
      },
      error(i) {
        var o;
        (o = n.onError) == null || o.call(n, i);
      },
      complete() {
        var i;
        (i = n.onComplete) == null || i.call(n);
      }
    });
  }
  constructor(e) {
    this.requestId = 0;
    const r = (() => {
      const n = e.transformer;
      return n ? "input" in n ? e.transformer : {
        input: n,
        output: n
      } : {
        input: {
          serialize: (i) => i,
          deserialize: (i) => i
        },
        output: {
          serialize: (i) => i,
          deserialize: (i) => i
        }
      };
    })();
    this.runtime = {
      transformer: {
        serialize: (n) => r.input.serialize(n),
        deserialize: (n) => r.output.deserialize(n)
      },
      combinedTransformer: r
    }, this.links = e.links.map((n) => n(this.runtime));
  }
};
function mu(t) {
  return new On(t);
}
function gu(t) {
  return new On(t);
}
const wu = {
  query: "query",
  mutate: "mutation",
  subscribe: "subscription"
}, ra = (t) => wu[t];
function na(t) {
  return jo.createFlatProxy((e) => t.hasOwnProperty(e) ? t[e] : e === "__untypedClient" ? t : jo.createRecursiveProxy(({ path: r, args: n }) => {
    const i = [
      e,
      ...r
    ], o = ra(i.pop()), s = i.join(".");
    return t[o](s, ...n);
  }));
}
function yu(t) {
  const e = new On(t);
  return na(e);
}
function vu(t) {
  return t.__untypedClient;
}
function bu(t) {
  if (t)
    return t;
  if (typeof window < "u" && window.TextDecoder)
    return new window.TextDecoder();
  if (typeof globalThis < "u" && globalThis.TextDecoder)
    return new globalThis.TextDecoder();
  throw new Error("No TextDecoder implementation found");
}
async function _u(t) {
  const e = t.parse ?? JSON.parse, r = (n) => {
    var a;
    if ((a = t.signal) != null && a.aborted || !n || n === "}")
      return;
    const i = n.indexOf(":"), o = n.substring(2, i - 1), s = n.substring(i + 1);
    t.onSingle(Number(o), e(s));
  };
  await xu(t.readableStream, r, t.textDecoder);
}
async function xu(t, e, r) {
  let n = "";
  const i = (o) => {
    const s = r.decode(o).split(`
`);
    if (s.length === 1)
      n += s[0];
    else if (s.length > 1) {
      e(n + s[0]);
      for (let a = 1; a < s.length - 1; a++)
        e(s[a]);
      n = s[s.length - 1];
    }
  };
  "getReader" in t ? await Eu(t, i) : await Mu(t, i), e(n);
}
function Mu(t, e) {
  return new Promise((r) => {
    t.on("data", e), t.on("end", r);
  });
}
async function Eu(t, e) {
  const r = t.getReader();
  let n = await r.read();
  for (; !n.done; )
    e(n.value), n = await r.read();
}
const ku = (t, e) => {
  const r = t.AbortController ? new t.AbortController() : null, n = hr.fetchHTTPResponse({
    ...t,
    contentTypeHeader: "application/json",
    batchModeHeader: "stream",
    getUrl: hr.getUrl,
    getBody: hr.getBody
  }, r), i = () => r == null ? void 0 : r.abort(), o = n.then(async (s) => {
    if (!s.body)
      throw new Error("Received response without body");
    const a = {
      response: s
    };
    return _u({
      readableStream: s.body,
      onSingle: e,
      parse: (c) => ({
        json: JSON.parse(c),
        meta: a
      }),
      signal: r == null ? void 0 : r.signal,
      textDecoder: t.textDecoder
    });
  });
  return {
    cancel: i,
    promise: o
  };
}, Cu = (t) => {
  const e = bu(t.opts.textDecoder);
  return (r, n) => {
    const i = r.map((c) => c.path).join(","), o = r.map((c) => c.input), { cancel: s, promise: a } = ku({
      ...t,
      textDecoder: e,
      path: i,
      inputs: o,
      headers() {
        return t.opts.headers ? typeof t.opts.headers == "function" ? t.opts.headers({
          opList: r
        }) : t.opts.headers : {};
      }
    }, (c, l) => {
      n(c, l);
    });
    return {
      /**
      * return an empty array because the batchLoader expects an array of results
      * but we've already called the `unitResolver` for each of them, there's
      * nothing left to do here.
      */
      promise: a.then(() => []),
      cancel: s
    };
  };
}, Tu = ea.createHTTPBatchLink(Cu), Nu = (t) => {
  if ("input" in t) {
    if (!(t.input instanceof FormData))
      throw new Error("Input is not FormData");
    return t.input;
  }
}, Iu = (t) => {
  if (t.type !== "mutation")
    throw new Error("We only handle mutations with formdata");
  return hr.httpRequest({
    ...t,
    getUrl() {
      return `${t.url}/${t.path}`;
    },
    getBody: Nu
  });
}, Ou = Yi.httpLinkFactory({
  requester: Iu
});
oe.splitLink = Ks.splitLink;
oe.TRPCClientError = Xs.TRPCClientError;
oe.getFetch = hr.getFetch;
oe.httpBatchLink = ea.httpBatchLink;
oe.httpLink = Yi.httpLink;
oe.httpLinkFactory = Yi.httpLinkFactory;
oe.loggerLink = hu.loggerLink;
oe.createWSClient = ta.createWSClient;
oe.wsLink = ta.wsLink;
oe.TRPCUntypedClient = On;
oe.clientCallTypeToProcedureType = ra;
oe.createTRPCClient = gu;
oe.createTRPCClientProxy = na;
oe.createTRPCProxyClient = yu;
oe.createTRPCUntypedClient = mu;
oe.experimental_formDataLink = Ou;
oe.getUntypedClient = vu;
oe.unstable_httpBatchStreamLink = Tu;
var pt = {}, Qi = {};
function ju(t) {
  return t;
}
function Su(t) {
  return t.length === 0 ? ju : t.length === 1 ? t[0] : function(e) {
    return t.reduce((r, n) => n(r), e);
  };
}
function Au(t) {
  return typeof t == "object" && t !== null && "subscribe" in t;
}
function Du(t) {
  const e = {
    subscribe(r) {
      let n = null, i = !1, o = !1, s = !1;
      function a() {
        if (n === null) {
          s = !0;
          return;
        }
        o || (o = !0, typeof n == "function" ? n() : n && n.unsubscribe());
      }
      return n = t({
        next(c) {
          var l;
          i || ((l = r.next) == null || l.call(r, c));
        },
        error(c) {
          var l;
          i || (i = !0, (l = r.error) == null || l.call(r, c), a());
        },
        complete() {
          var c;
          i || (i = !0, (c = r.complete) == null || c.call(r), a());
        }
      }), s && a(), {
        unsubscribe: a
      };
    },
    pipe(...r) {
      return Su(r)(e);
    }
  };
  return e;
}
Qi.isObservable = Au;
Qi.observable = Du;
Object.defineProperty(pt, "__esModule", { value: !0 });
var ia = Qi;
function Lu(t) {
  return (e) => {
    let r = 0, n = null;
    const i = [];
    function o() {
      n || (n = e.subscribe({
        next(a) {
          var c;
          for (const l of i)
            (c = l.next) == null || c.call(l, a);
        },
        error(a) {
          var c;
          for (const l of i)
            (c = l.error) == null || c.call(l, a);
        },
        complete() {
          var a;
          for (const c of i)
            (a = c.complete) == null || a.call(c);
        }
      }));
    }
    function s() {
      if (r === 0 && n) {
        const a = n;
        n = null, a.unsubscribe();
      }
    }
    return {
      subscribe(a) {
        return r++, i.push(a), o(), {
          unsubscribe() {
            r--, s();
            const c = i.findIndex((l) => l === a);
            c > -1 && i.splice(c, 1);
          }
        };
      }
    };
  };
}
function $u(t) {
  return (e) => ({
    subscribe(r) {
      let n = 0;
      return e.subscribe({
        next(i) {
          var o;
          (o = r.next) == null || o.call(r, t(i, n++));
        },
        error(i) {
          var o;
          (o = r.error) == null || o.call(r, i);
        },
        complete() {
          var i;
          (i = r.complete) == null || i.call(r);
        }
      });
    }
  });
}
function Pu(t) {
  return (e) => ({
    subscribe(r) {
      return e.subscribe({
        next(n) {
          var i, o;
          (i = t.next) == null || i.call(t, n), (o = r.next) == null || o.call(r, n);
        },
        error(n) {
          var i, o;
          (i = t.error) == null || i.call(t, n), (o = r.error) == null || o.call(r, n);
        },
        complete() {
          var n, i;
          (n = t.complete) == null || n.call(t), (i = r.complete) == null || i.call(r);
        }
      });
    }
  });
}
let Ru = class oa extends Error {
  constructor(e) {
    super(e), this.name = "ObservableAbortError", Object.setPrototypeOf(this, oa.prototype);
  }
};
function zu(t) {
  let e;
  return {
    promise: new Promise((r, n) => {
      let i = !1;
      function o() {
        i || (i = !0, n(new Ru("This operation was aborted.")), s.unsubscribe());
      }
      const s = t.subscribe({
        next(a) {
          i = !0, r(a), o();
        },
        error(a) {
          i = !0, n(a), o();
        },
        complete() {
          i = !0, o();
        }
      });
      e = o;
    }),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    abort: e
  };
}
pt.isObservable = ia.isObservable;
pt.observable = ia.observable;
pt.map = $u;
pt.observableToPromise = zu;
pt.share = Lu;
pt.tap = Pu;
var Ue = {};
Object.defineProperty(Ue, "__esModule", { value: !0 });
Ue.isTRPCRequestWithId = Ue.isTRPCRequest = Ue.isTRPCResponse = Ue.isTRPCMessage = void 0;
function So(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Fu(t) {
  return t == null;
}
function sa(t) {
  return !!(So(t) && "trpc" in t && So(t.trpc));
}
Ue.isTRPCMessage = sa;
function Vi(t) {
  return sa(t) && "id" in t.trpc && !Fu(t.trpc.id);
}
function Uu(t) {
  return Vi(t) && ("error" in t.trpc || "result" in t.trpc);
}
Ue.isTRPCResponse = Uu;
function aa(t) {
  return Vi(t) && "method" in t.trpc;
}
Ue.isTRPCRequest = aa;
function Zu(t) {
  return aa(t) && Vi(t);
}
Ue.isTRPCRequestWithId = Zu;
Object.defineProperty(Vt, "__esModule", { value: !0 });
Vt.createBaseLink = void 0;
const qn = oe, Bu = pt, Wu = Ue, Yu = (t) => (e) => ({ op: r }) => (0, Bu.observable)((n) => {
  const i = [], { id: o, type: s, path: a } = r;
  try {
    const c = e.transformer.serialize(r.input), l = () => {
      n.error(new qn.TRPCClientError("Port disconnected prematurely"));
    };
    t.addCloseListener(l), i.push(() => t.removeCloseListener(l));
    const u = (p) => {
      if (!(0, Wu.isTRPCResponse)(p))
        return;
      const { trpc: m } = p;
      if (o === m.id) {
        if ("error" in m) {
          const h = e.transformer.deserialize(m.error);
          n.error(qn.TRPCClientError.from(Object.assign(Object.assign({}, m), { error: h })));
          return;
        }
        n.next({
          result: Object.assign(Object.assign({}, m.result), (!m.result.type || m.result.type === "data") && {
            type: "data",
            data: e.transformer.deserialize(m.result.data)
          })
        }), (s !== "subscription" || m.result.type === "stopped") && n.complete();
      }
    };
    t.addMessageListener(u), i.push(() => t.removeMessageListener(u)), t.postMessage({
      trpc: {
        id: o,
        jsonrpc: void 0,
        method: s,
        params: { path: a, input: c }
      }
    });
  } catch (c) {
    n.error(new qn.TRPCClientError(c instanceof Error ? c.message : "Unknown error"));
  }
  return () => {
    s === "subscription" && t.postMessage({
      trpc: {
        id: o,
        jsonrpc: void 0,
        method: "subscription.stop"
      }
    }), i.forEach((c) => c());
  };
});
Vt.createBaseLink = Yu;
Object.defineProperty(Cn, "__esModule", { value: !0 });
Cn.chromeLink = void 0;
const Qu = Vt, Vu = (t) => (0, Qu.createBaseLink)({
  postMessage(e) {
    t.port.postMessage(e);
  },
  addMessageListener(e) {
    t.port.onMessage.addListener(e);
  },
  removeMessageListener(e) {
    t.port.onMessage.removeListener(e);
  },
  addCloseListener(e) {
    t.port.onDisconnect.addListener(e);
  },
  removeCloseListener(e) {
    t.port.onDisconnect.removeListener(e);
  }
});
Cn.chromeLink = Vu;
var jn = {};
Object.defineProperty(jn, "__esModule", { value: !0 });
jn.windowLink = void 0;
const Hu = Vt, qu = (t) => {
  var e;
  const r = /* @__PURE__ */ new Map(), n = t.window, i = (e = t.postWindow) !== null && e !== void 0 ? e : n;
  return (0, Hu.createBaseLink)({
    postMessage(o) {
      i.postMessage(o, {
        targetOrigin: t.postOrigin
      });
    },
    addMessageListener(o) {
      const s = (a) => {
        o(a.data);
      };
      r.set(o, s), n.addEventListener("message", s);
    },
    removeMessageListener(o) {
      const s = r.get(o);
      s && n.removeEventListener("message", s);
    },
    addCloseListener(o) {
      n.addEventListener("beforeunload", o);
    },
    removeCloseListener(o) {
      n.removeEventListener("beforeunload", o);
    }
  });
};
jn.windowLink = qu;
var Sn = {}, An = {};
Object.defineProperty(An, "__esModule", { value: !0 });
An.TRPC_BROWSER_LOADED_EVENT = void 0;
An.TRPC_BROWSER_LOADED_EVENT = "TRPC_BROWSER::POPUP_LOADED";
Object.defineProperty(Sn, "__esModule", { value: !0 });
Sn.popupLink = void 0;
const Gu = An, Ju = Vt, Ku = (t) => {
  const e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
  let n = null;
  async function i(o) {
    if (!n || n.closed) {
      n = t.createPopup(), await Promise.race([
        // wait til window is loaded (same origin)
        new Promise((s) => {
          var a;
          try {
            (a = n == null ? void 0 : n.addEventListener) === null || a === void 0 || a.call(n, "load", s);
          } catch {
          }
        }),
        // this is needed for cross-origin popups as they don't have a load event
        new Promise((s) => {
          o.addEventListener("message", (a) => {
            a.data === Gu.TRPC_BROWSER_LOADED_EVENT && s();
          });
        }),
        // expect the popup to load after 15s max, in case non of the above events fire
        new Promise((s) => {
          console.warn("Could not detect if popup loading succeeded after 15s timeout, continuing anyway"), setTimeout(s, 15e3);
        })
      ]);
      try {
        if (!n.addEventListener)
          throw new Error("popupWindow.addEventListener is not a function");
        n.addEventListener("beforeunload", () => {
          n = null;
        });
      } catch {
        const s = setInterval(() => {
          n && n.closed && (n = null, r.forEach((a) => {
            a();
          }), clearInterval(s));
        }, 1e3);
      }
    }
    return n;
  }
  return (0, Ju.createBaseLink)({
    async postMessage(o) {
      return (await i(t.listenWindow)).postMessage(o, {
        targetOrigin: t.postOrigin
      });
    },
    addMessageListener(o) {
      const s = (a) => {
        o(a.data);
      };
      e.set(o, s), t.listenWindow.addEventListener("message", s);
    },
    removeMessageListener(o) {
      const s = e.get(o);
      s && t.listenWindow.removeEventListener("message", s);
    },
    addCloseListener(o) {
      t.listenWindow.addEventListener("beforeunload", o), r.add(o);
    },
    removeCloseListener(o) {
      t.listenWindow.removeEventListener("beforeunload", o), r.delete(o);
    }
  });
};
Sn.popupLink = Ku;
(function(t) {
  var e = Ur && Ur.__createBinding || (Object.create ? function(n, i, o, s) {
    s === void 0 && (s = o);
    var a = Object.getOwnPropertyDescriptor(i, o);
    (!a || ("get" in a ? !i.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, s, a);
  } : function(n, i, o, s) {
    s === void 0 && (s = o), n[s] = i[o];
  }), r = Ur && Ur.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && e(i, n, o);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Cn, t), r(jn, t), r(Sn, t);
})(hi);
var B;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function r(i) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (i) => {
    const o = {};
    for (const s of i)
      o[s] = s;
    return o;
  }, t.getValidEnumValues = (i) => {
    const o = t.objectKeys(i).filter((a) => typeof i[i[a]] != "number"), s = {};
    for (const a of o)
      s[a] = i[a];
    return t.objectValues(s);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(o) {
    return i[o];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const o = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && o.push(s);
    return o;
  }, t.find = (i, o) => {
    for (const s of i)
      if (o(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, o = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(o);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (i, o) => typeof o == "bigint" ? o.toString() : o;
})(B || (B = {}));
const C = B.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), it = (t) => {
  switch (typeof t) {
    case "undefined":
      return C.undefined;
    case "string":
      return C.string;
    case "number":
      return isNaN(t) ? C.nan : C.number;
    case "boolean":
      return C.boolean;
    case "function":
      return C.function;
    case "bigint":
      return C.bigint;
    case "symbol":
      return C.symbol;
    case "object":
      return Array.isArray(t) ? C.array : t === null ? C.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? C.promise : typeof Map < "u" && t instanceof Map ? C.map : typeof Set < "u" && t instanceof Set ? C.set : typeof Date < "u" && t instanceof Date ? C.date : C.object;
    default:
      return C.unknown;
  }
}, M = B.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Xu = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let He = class extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(o) {
      return o.message;
    }, n = { _errors: [] }, i = (o) => {
      for (const s of o.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          n._errors.push(r(s));
        else {
          let a = n, c = 0;
          for (; c < s.path.length; ) {
            const l = s.path[c];
            c === s.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(r(s))) : a[l] = a[l] || { _errors: [] }, a = a[l], c++;
          }
        }
    };
    return i(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, B.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(e(i))) : n.push(e(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
He.create = (t) => new He(t);
const vr = (t, e) => {
  let r;
  switch (t.code) {
    case M.invalid_type:
      t.received === C.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case M.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, B.jsonStringifyReplacer)}`;
      break;
    case M.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${B.joinValues(t.keys, ", ")}`;
      break;
    case M.invalid_union:
      r = "Invalid input";
      break;
    case M.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${B.joinValues(t.options)}`;
      break;
    case M.invalid_enum_value:
      r = `Invalid enum value. Expected ${B.joinValues(t.options)}, received '${t.received}'`;
      break;
    case M.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case M.invalid_return_type:
      r = "Invalid function return type";
      break;
    case M.invalid_date:
      r = "Invalid date";
      break;
    case M.invalid_string:
      typeof t.validation == "object" ? "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : B.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case M.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(t.minimum)}` : r = "Invalid input";
      break;
    case M.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(t.maximum)}` : r = "Invalid input";
      break;
    case M.custom:
      r = "Invalid input";
      break;
    case M.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case M.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case M.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, B.assertNever(t);
  }
  return { message: r };
};
let ca = vr;
function ed(t) {
  ca = t;
}
function nn() {
  return ca;
}
const on = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: i } = t, o = [...r, ...i.path || []], s = {
    ...i,
    path: o
  };
  let a = "";
  const c = n.filter((l) => !!l).slice().reverse();
  for (const l of c)
    a = l(s, { data: e, defaultError: a }).message;
  return {
    ...i,
    path: o,
    message: i.message || a
  };
}, td = [];
function T(t, e) {
  const r = on({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      nn(),
      vr
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(r);
}
let be = class la {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return j;
      i.status === "dirty" && e.dirty(), n.push(i.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const i of r)
      n.push({
        key: await i.key,
        value: await i.value
      });
    return la.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const i of r) {
      const { key: o, value: s } = i;
      if (o.status === "aborted" || s.status === "aborted")
        return j;
      o.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), (typeof s.value < "u" || i.alwaysSet) && (n[o.value] = s.value);
    }
    return { status: e.value, value: n };
  }
};
const j = Object.freeze({
  status: "aborted"
}), ua = (t) => ({ status: "dirty", value: t }), de = (t) => ({ status: "valid", value: t }), gi = (t) => t.status === "aborted", wi = (t) => t.status === "dirty", sn = (t) => t.status === "valid", an = (t) => typeof Promise < "u" && t instanceof Promise;
var $;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})($ || ($ = {}));
let Be = class {
  constructor(e, r, n, i) {
    this.parent = e, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._path.concat(this._key);
  }
};
const Ao = (t, e) => {
  if (sn(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return { success: !1, error: new He(t.common.issues) };
};
function A(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: i } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (o, s) => o.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: n ?? s.defaultError } : { message: r ?? s.defaultError }, description: i };
}
let L = class {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return it(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: it(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new be(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: it(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (an(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: it(e)
    }, o = this._parseSync({ data: e, path: i.path, parent: i });
    return Ao(i, o);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: it(e)
    }, i = this._parse({ data: e, path: n.path, parent: n }), o = await (an(i) ? i : Promise.resolve(i));
    return Ao(n, o);
  }
  refine(e, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, o) => {
      const s = e(i), a = () => o.addIssue({
        code: M.custom,
        ...n(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((c) => c ? !0 : (a(), !1)) : s ? !0 : (a(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, i) => e(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(e) {
    return new $e({
      schema: this,
      typeName: N.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return qe.create(this, this._def);
  }
  nullable() {
    return Mt.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return xt.create(this, this._def);
  }
  promise() {
    return Qt.create(this, this._def);
  }
  or(e) {
    return Cr.create([this, e], this._def);
  }
  and(e) {
    return Tr.create(this, e, this._def);
  }
  transform(e) {
    return new $e({
      ...A(this._def),
      schema: this,
      typeName: N.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new jr({
      ...A(this._def),
      innerType: this,
      defaultValue: r,
      typeName: N.ZodDefault
    });
  }
  brand() {
    return new ya({
      typeName: N.ZodBranded,
      type: this,
      ...A(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new fn({
      ...A(this._def),
      innerType: this,
      catchValue: r,
      typeName: N.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Hi.create(this, e);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const rd = /^c[^\s-]{8,}$/i, nd = /^[a-z][a-z0-9]*$/, id = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, od = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|([^-]([a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}))$/, sd = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
let Wt = class yi extends L {
  constructor() {
    super(...arguments), this._regex = (e, r, n) => this.refinement((i) => e.test(i), {
      validation: r,
      code: M.invalid_string,
      ...$.errToObj(n)
    }), this.nonempty = (e) => this.min(1, $.errToObj(e)), this.trim = () => new yi({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== C.string) {
      const i = this._getOrReturnCtx(e);
      return T(
        i,
        {
          code: M.invalid_type,
          expected: C.string,
          received: i.parsedType
        }
        //
      ), j;
    }
    const r = new be();
    let n;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (n = this._getOrReturnCtx(e, n), T(n, {
          code: M.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (n = this._getOrReturnCtx(e, n), T(n, {
          code: M.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (n = this._getOrReturnCtx(e, n), o ? T(n, {
          code: M.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && T(n, {
          code: M.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        od.test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          validation: "email",
          code: M.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        id.test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          validation: "uuid",
          code: M.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        rd.test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          validation: "cuid",
          code: M.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        nd.test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          validation: "cuid2",
          code: M.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), T(n, {
            validation: "url",
            code: M.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          validation: "regex",
          code: M.invalid_string,
          message: i.message
        }), r.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (n = this._getOrReturnCtx(e, n), T(n, {
          code: M.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (n = this._getOrReturnCtx(e, n), T(n, {
          code: M.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "datetime" ? sd(i).test(e.data) || (n = this._getOrReturnCtx(e, n), T(n, {
          code: M.invalid_string,
          validation: "datetime",
          message: i.message
        }), r.dirty()) : B.assertNever(i);
    return { status: r.value, value: e.data };
  }
  _addCheck(e) {
    return new yi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...$.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...$.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...$.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...$.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...$.errToObj(e) });
  }
  datetime(e) {
    var r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      ...$.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...$.errToObj(r)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...$.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...$.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...$.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...$.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...$.errToObj(r)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
Wt.create = (t) => {
  var e;
  return new Wt({
    checks: [],
    typeName: N.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...A(t)
  });
};
function ad(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, i = r > n ? r : n, o = parseInt(t.toFixed(i).replace(".", "")), s = parseInt(e.toFixed(i).replace(".", ""));
  return o % s / Math.pow(10, i);
}
let br = class vi extends L {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== C.number) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: M.invalid_type,
        expected: C.number,
        received: i.parsedType
      }), j;
    }
    let r;
    const n = new be();
    for (const i of this._def.checks)
      i.kind === "int" ? B.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
        code: M.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), n.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), T(r, {
        code: M.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), T(r, {
        code: M.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), n.dirty()) : i.kind === "multipleOf" ? ad(e.data, i.value) !== 0 && (r = this._getOrReturnCtx(e, r), T(r, {
        code: M.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), n.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), T(r, {
        code: M.not_finite,
        message: i.message
      }), n.dirty()) : B.assertNever(i);
    return { status: n.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, $.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, $.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, $.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, $.toString(r));
  }
  setLimit(e, r, n, i) {
    return new vi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: $.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new vi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: $.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: $.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: $.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: $.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: $.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: $.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: $.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && B.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
br.create = (t) => new br({
  checks: [],
  typeName: N.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...A(t)
});
let _r = class extends L {
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== C.bigint) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.bigint,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
_r.create = (t) => {
  var e;
  return new _r({
    typeName: N.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...A(t)
  });
};
let xr = class extends L {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== C.boolean) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.boolean,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
xr.create = (t) => new xr({
  typeName: N.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...A(t)
});
let Mr = class da extends L {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== C.date) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: M.invalid_type,
        expected: C.date,
        received: i.parsedType
      }), j;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return T(i, {
        code: M.invalid_date
      }), j;
    }
    const r = new be();
    let n;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (n = this._getOrReturnCtx(e, n), T(n, {
        code: M.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (n = this._getOrReturnCtx(e, n), T(n, {
        code: M.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : B.assertNever(i);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new da({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: $.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: $.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
Mr.create = (t) => new Mr({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: N.ZodDate,
  ...A(t)
});
let cn = class extends L {
  _parse(e) {
    if (this._getType(e) !== C.symbol) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.symbol,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
cn.create = (t) => new cn({
  typeName: N.ZodSymbol,
  ...A(t)
});
let Er = class extends L {
  _parse(e) {
    if (this._getType(e) !== C.undefined) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.undefined,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
Er.create = (t) => new Er({
  typeName: N.ZodUndefined,
  ...A(t)
});
let kr = class extends L {
  _parse(e) {
    if (this._getType(e) !== C.null) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.null,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
kr.create = (t) => new kr({
  typeName: N.ZodNull,
  ...A(t)
});
let Yt = class extends L {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return de(e.data);
  }
};
Yt.create = (t) => new Yt({
  typeName: N.ZodAny,
  ...A(t)
});
let bt = class extends L {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return de(e.data);
  }
};
bt.create = (t) => new bt({
  typeName: N.ZodUnknown,
  ...A(t)
});
let Ke = class extends L {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return T(r, {
      code: M.invalid_type,
      expected: C.never,
      received: r.parsedType
    }), j;
  }
};
Ke.create = (t) => new Ke({
  typeName: N.ZodNever,
  ...A(t)
});
let ln = class extends L {
  _parse(e) {
    if (this._getType(e) !== C.undefined) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.void,
        received: r.parsedType
      }), j;
    }
    return de(e.data);
  }
};
ln.create = (t) => new ln({
  typeName: N.ZodVoid,
  ...A(t)
});
let xt = class Gr extends L {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), i = this._def;
    if (r.parsedType !== C.array)
      return T(r, {
        code: M.invalid_type,
        expected: C.array,
        received: r.parsedType
      }), j;
    if (i.exactLength !== null) {
      const s = r.data.length > i.exactLength.value, a = r.data.length < i.exactLength.value;
      (s || a) && (T(r, {
        code: s ? M.too_big : M.too_small,
        minimum: a ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (T(r, {
      code: M.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (T(r, {
      code: M.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((s, a) => i.type._parseAsync(new Be(r, s, r.path, a)))).then((s) => be.mergeArray(n, s));
    const o = [...r.data].map((s, a) => i.type._parseSync(new Be(r, s, r.path, a)));
    return be.mergeArray(n, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new Gr({
      ...this._def,
      minLength: { value: e, message: $.toString(r) }
    });
  }
  max(e, r) {
    return new Gr({
      ...this._def,
      maxLength: { value: e, message: $.toString(r) }
    });
  }
  length(e, r) {
    return new Gr({
      ...this._def,
      exactLength: { value: e, message: $.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
xt.create = (t, e) => new xt({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: N.ZodArray,
  ...A(e)
});
var un;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(un || (un = {}));
function $t(t) {
  if (t instanceof Ne) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = qe.create($t(n));
    }
    return new Ne({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof xt ? xt.create($t(t.element)) : t instanceof qe ? qe.create($t(t.unwrap())) : t instanceof Mt ? Mt.create($t(t.unwrap())) : t instanceof dt ? dt.create(t.items.map((e) => $t(e))) : t;
}
let Ne = class De extends L {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = B.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== C.object) {
      const c = this._getOrReturnCtx(e);
      return T(c, {
        code: M.invalid_type,
        expected: C.object,
        received: c.parsedType
      }), j;
    }
    const { status: r, ctx: n } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Ke && this._def.unknownKeys === "strip"))
      for (const c in n.data)
        o.includes(c) || s.push(c);
    const a = [];
    for (const c of o) {
      const l = i[c], u = n.data[c];
      a.push({
        key: { status: "valid", value: c },
        value: l._parse(new Be(n, u, n.path, c)),
        alwaysSet: c in n.data
      });
    }
    if (this._def.catchall instanceof Ke) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const l of s)
          a.push({
            key: { status: "valid", value: l },
            value: { status: "valid", value: n.data[l] }
          });
      else if (c === "strict")
        s.length > 0 && (T(n, {
          code: M.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (c !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const l of s) {
        const u = n.data[l];
        a.push({
          key: { status: "valid", value: l },
          value: c._parse(
            new Be(n, u, n.path, l)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: l in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const l of a) {
        const u = await l.key;
        c.push({
          key: u,
          value: await l.value,
          alwaysSet: l.alwaysSet
        });
      }
      return c;
    }).then((c) => be.mergeObjectSync(r, c)) : be.mergeObjectSync(r, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return $.errToObj, new De({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var i, o, s, a;
          const c = (s = (o = (i = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(i, r, n).message) !== null && s !== void 0 ? s : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (a = $.errToObj(e).message) !== null && a !== void 0 ? a : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new De({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new De({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new De({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new De({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => un.mergeShapes(this._def.shape(), e._def.shape()),
      typeName: N.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new De({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return B.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new De({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return B.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new De({
      ...this._def,
      shape: () => r
    });
  }
  deepPartial() {
    return $t(this);
  }
  partial(e) {
    const r = {};
    return B.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      e && !e[n] ? r[n] = i : r[n] = i.optional();
    }), new De({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return B.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof qe; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new De({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return wa(B.objectKeys(this.shape));
  }
};
Ne.create = (t, e) => new Ne({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Ke.create(),
  typeName: N.ZodObject,
  ...A(e)
});
Ne.strictCreate = (t, e) => new Ne({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Ke.create(),
  typeName: N.ZodObject,
  ...A(e)
});
Ne.lazycreate = (t, e) => new Ne({
  shape: t,
  unknownKeys: "strip",
  catchall: Ke.create(),
  typeName: N.ZodObject,
  ...A(e)
});
let Cr = class extends L {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function i(o) {
      for (const a of o)
        if (a.result.status === "valid")
          return a.result;
      for (const a of o)
        if (a.result.status === "dirty")
          return r.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((a) => new He(a.ctx.common.issues));
      return T(r, {
        code: M.invalid_union,
        unionErrors: s
      }), j;
    }
    if (r.common.async)
      return Promise.all(n.map(async (o) => {
        const s = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: r.data,
            path: r.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let o;
      const s = [];
      for (const c of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !o && (o = { result: u, ctx: l }), l.common.issues.length && s.push(l.common.issues);
      }
      if (o)
        return r.common.issues.push(...o.ctx.common.issues), o.result;
      const a = s.map((c) => new He(c));
      return T(r, {
        code: M.invalid_union,
        unionErrors: a
      }), j;
    }
  }
  get options() {
    return this._def.options;
  }
};
Cr.create = (t, e) => new Cr({
  options: t,
  typeName: N.ZodUnion,
  ...A(e)
});
const Jr = (t) => t instanceof Nr ? Jr(t.schema) : t instanceof $e ? Jr(t.innerType()) : t instanceof Ir ? [t.value] : t instanceof Dr ? t.options : t instanceof Or ? Object.keys(t.enum) : t instanceof jr ? Jr(t._def.innerType) : t instanceof Er ? [void 0] : t instanceof kr ? [null] : null;
let pa = class fa extends L {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== C.object)
      return T(r, {
        code: M.invalid_type,
        expected: C.object,
        received: r.parsedType
      }), j;
    const n = this.discriminator, i = r.data[n], o = this.optionsMap.get(i);
    return o ? r.common.async ? o._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : o._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (T(r, {
      code: M.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), j);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const i = /* @__PURE__ */ new Map();
    for (const o of r) {
      const s = Jr(o.shape[e]);
      if (!s)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const a of s) {
        if (i.has(a))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(a)}`);
        i.set(a, o);
      }
    }
    return new fa({
      typeName: N.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: i,
      ...A(n)
    });
  }
};
function bi(t, e) {
  const r = it(t), n = it(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === C.object && n === C.object) {
    const i = B.objectKeys(e), o = B.objectKeys(t).filter((a) => i.indexOf(a) !== -1), s = { ...t, ...e };
    for (const a of o) {
      const c = bi(t[a], e[a]);
      if (!c.valid)
        return { valid: !1 };
      s[a] = c.data;
    }
    return { valid: !0, data: s };
  } else if (r === C.array && n === C.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let o = 0; o < t.length; o++) {
      const s = t[o], a = e[o], c = bi(s, a);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else
    return r === C.date && n === C.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let Tr = class extends L {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = (o, s) => {
      if (gi(o) || gi(s))
        return j;
      const a = bi(o.value, s.value);
      return a.valid ? ((wi(o) || wi(s)) && r.dirty(), { status: r.value, value: a.data }) : (T(n, {
        code: M.invalid_intersection_types
      }), j);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([o, s]) => i(o, s)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
Tr.create = (t, e, r) => new Tr({
  left: t,
  right: e,
  typeName: N.ZodIntersection,
  ...A(r)
});
let dt = class ha extends L {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== C.array)
      return T(n, {
        code: M.invalid_type,
        expected: C.array,
        received: n.parsedType
      }), j;
    if (n.data.length < this._def.items.length)
      return T(n, {
        code: M.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), j;
    !this._def.rest && n.data.length > this._def.items.length && (T(n, {
      code: M.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const a = this._def.items[s] || this._def.rest;
      return a ? a._parse(new Be(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => be.mergeArray(r, o)) : be.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ha({
      ...this._def,
      rest: e
    });
  }
};
dt.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new dt({
    items: t,
    typeName: N.ZodTuple,
    rest: null,
    ...A(e)
  });
};
let ma = class _i extends L {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== C.object)
      return T(n, {
        code: M.invalid_type,
        expected: C.object,
        received: n.parsedType
      }), j;
    const i = [], o = this._def.keyType, s = this._def.valueType;
    for (const a in n.data)
      i.push({
        key: o._parse(new Be(n, a, n.path, a)),
        value: s._parse(new Be(n, n.data[a], n.path, a))
      });
    return n.common.async ? be.mergeObjectAsync(r, i) : be.mergeObjectSync(r, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof L ? new _i({
      keyType: e,
      valueType: r,
      typeName: N.ZodRecord,
      ...A(n)
    }) : new _i({
      keyType: Wt.create(),
      valueType: e,
      typeName: N.ZodRecord,
      ...A(r)
    });
  }
}, dn = class extends L {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== C.map)
      return T(n, {
        code: M.invalid_type,
        expected: C.map,
        received: n.parsedType
      }), j;
    const i = this._def.keyType, o = this._def.valueType, s = [...n.data.entries()].map(([a, c], l) => ({
      key: i._parse(new Be(n, a, n.path, [l, "key"])),
      value: o._parse(new Be(n, c, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of s) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return j;
          (l.status === "dirty" || u.status === "dirty") && r.dirty(), a.set(l.value, u.value);
        }
        return { status: r.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const c of s) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return j;
        (l.status === "dirty" || u.status === "dirty") && r.dirty(), a.set(l.value, u.value);
      }
      return { status: r.value, value: a };
    }
  }
};
dn.create = (t, e, r) => new dn({
  valueType: e,
  keyType: t,
  typeName: N.ZodMap,
  ...A(r)
});
let pn = class xi extends L {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== C.set)
      return T(n, {
        code: M.invalid_type,
        expected: C.set,
        received: n.parsedType
      }), j;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (T(n, {
      code: M.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (T(n, {
      code: M.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const o = this._def.valueType;
    function s(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return j;
        u.status === "dirty" && r.dirty(), l.add(u.value);
      }
      return { status: r.value, value: l };
    }
    const a = [...n.data.values()].map((c, l) => o._parse(new Be(n, c, n.path, l)));
    return n.common.async ? Promise.all(a).then((c) => s(c)) : s(a);
  }
  min(e, r) {
    return new xi({
      ...this._def,
      minSize: { value: e, message: $.toString(r) }
    });
  }
  max(e, r) {
    return new xi({
      ...this._def,
      maxSize: { value: e, message: $.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
pn.create = (t, e) => new pn({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: N.ZodSet,
  ...A(e)
});
let ga = class Kr extends L {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== C.function)
      return T(r, {
        code: M.invalid_type,
        expected: C.function,
        received: r.parsedType
      }), j;
    function n(a, c) {
      return on({
        data: a,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          nn(),
          vr
        ].filter((l) => !!l),
        issueData: {
          code: M.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(a, c) {
      return on({
        data: a,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          nn(),
          vr
        ].filter((l) => !!l),
        issueData: {
          code: M.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const o = { errorMap: r.common.contextualErrorMap }, s = r.data;
    return this._def.returns instanceof Qt ? de(async (...a) => {
      const c = new He([]), l = await this._def.args.parseAsync(a, o).catch((p) => {
        throw c.addIssue(n(a, p)), c;
      }), u = await s(...l);
      return await this._def.returns._def.type.parseAsync(u, o).catch((p) => {
        throw c.addIssue(i(u, p)), c;
      });
    }) : de((...a) => {
      const c = this._def.args.safeParse(a, o);
      if (!c.success)
        throw new He([n(a, c.error)]);
      const l = s(...c.data), u = this._def.returns.safeParse(l, o);
      if (!u.success)
        throw new He([i(l, u.error)]);
      return u.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Kr({
      ...this._def,
      args: dt.create(e).rest(bt.create())
    });
  }
  returns(e) {
    return new Kr({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new Kr({
      args: e || dt.create([]).rest(bt.create()),
      returns: r || bt.create(),
      typeName: N.ZodFunction,
      ...A(n)
    });
  }
}, Nr = class extends L {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
Nr.create = (t, e) => new Nr({
  getter: t,
  typeName: N.ZodLazy,
  ...A(e)
});
let Ir = class extends L {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        received: r.data,
        code: M.invalid_literal,
        expected: this._def.value
      }), j;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
Ir.create = (t, e) => new Ir({
  value: t,
  typeName: N.ZodLiteral,
  ...A(e)
});
function wa(t, e) {
  return new Dr({
    values: t,
    typeName: N.ZodEnum,
    ...A(e)
  });
}
let Dr = class Mi extends L {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return T(r, {
        expected: B.joinValues(n),
        received: r.parsedType,
        code: M.invalid_type
      }), j;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return T(r, {
        received: r.data,
        code: M.invalid_enum_value,
        options: n
      }), j;
    }
    return de(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e) {
    return Mi.create(e);
  }
  exclude(e) {
    return Mi.create(this.options.filter((r) => !e.includes(r)));
  }
};
Dr.create = wa;
let Or = class extends L {
  _parse(e) {
    const r = B.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== C.string && n.parsedType !== C.number) {
      const i = B.objectValues(r);
      return T(n, {
        expected: B.joinValues(i),
        received: n.parsedType,
        code: M.invalid_type
      }), j;
    }
    if (r.indexOf(e.data) === -1) {
      const i = B.objectValues(r);
      return T(n, {
        received: n.data,
        code: M.invalid_enum_value,
        options: i
      }), j;
    }
    return de(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
Or.create = (t, e) => new Or({
  values: t,
  typeName: N.ZodNativeEnum,
  ...A(e)
});
let Qt = class extends L {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== C.promise && r.common.async === !1)
      return T(r, {
        code: M.invalid_type,
        expected: C.promise,
        received: r.parsedType
      }), j;
    const n = r.parsedType === C.promise ? r.data : Promise.resolve(r.data);
    return de(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
Qt.create = (t, e) => new Qt({
  type: t,
  typeName: N.ZodPromise,
  ...A(e)
});
let $e = class extends L {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === N.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = this._def.effect || null;
    if (i.type === "preprocess") {
      const s = i.transform(n.data);
      return n.common.async ? Promise.resolve(s).then((a) => this._def.schema._parseAsync({
        data: a,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: s,
        path: n.path,
        parent: n
      });
    }
    const o = {
      addIssue: (s) => {
        T(n, s), s.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), i.type === "refinement") {
      const s = (a) => {
        const c = i.refinement(a, o);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? j : (a.status === "dirty" && r.dirty(), s(a.value), { status: r.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => a.status === "aborted" ? j : (a.status === "dirty" && r.dirty(), s(a.value).then(() => ({ status: r.value, value: a.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!sn(s))
          return s;
        const a = i.transform(s.value, o);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => sn(s) ? Promise.resolve(i.transform(s.value, o)).then((a) => ({ status: r.value, value: a })) : s);
    B.assertNever(i);
  }
};
$e.create = (t, e, r) => new $e({
  schema: t,
  typeName: N.ZodEffects,
  effect: e,
  ...A(r)
});
$e.createWithPreprocess = (t, e, r) => new $e({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: N.ZodEffects,
  ...A(r)
});
let qe = class extends L {
  _parse(e) {
    return this._getType(e) === C.undefined ? de(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
qe.create = (t, e) => new qe({
  innerType: t,
  typeName: N.ZodOptional,
  ...A(e)
});
let Mt = class extends L {
  _parse(e) {
    return this._getType(e) === C.null ? de(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Mt.create = (t, e) => new Mt({
  innerType: t,
  typeName: N.ZodNullable,
  ...A(e)
});
let jr = class extends L {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === C.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
jr.create = (t, e) => new jr({
  innerType: t,
  typeName: N.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...A(e)
});
let fn = class extends L {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r,
        common: {
          ...r.common,
          issues: []
          // don't collect issues from inner type
        }
      }
    });
    return an(n) ? n.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue()
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue()
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
fn.create = (t, e) => new fn({
  innerType: t,
  typeName: N.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...A(e)
});
let hn = class extends L {
  _parse(e) {
    if (this._getType(e) !== C.nan) {
      const r = this._getOrReturnCtx(e);
      return T(r, {
        code: M.invalid_type,
        expected: C.nan,
        received: r.parsedType
      }), j;
    }
    return { status: "valid", value: e.data };
  }
};
hn.create = (t) => new hn({
  typeName: N.ZodNaN,
  ...A(t)
});
const cd = Symbol("zod_brand");
class ya extends L {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
let Hi = class va extends L {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? j : i.status === "dirty" ? (r.dirty(), ua(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? j : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new va({
      in: e,
      out: r,
      typeName: N.ZodPipeline
    });
  }
};
const ba = (t, e = {}, r) => t ? Yt.create().superRefine((n, i) => {
  if (!t(n)) {
    const o = typeof e == "function" ? e(n) : e, s = typeof o == "string" ? { message: o } : o;
    i.addIssue({ code: "custom", ...s, fatal: r });
  }
}) : Yt.create(), ld = {
  object: Ne.lazycreate
};
var N;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline";
})(N || (N = {}));
const ud = (t, e = {
  message: `Input not instance of ${t.name}`
}) => ba((r) => r instanceof t, e, !0), _a = Wt.create, xa = br.create, dd = hn.create, pd = _r.create, Ma = xr.create, fd = Mr.create, hd = cn.create, md = Er.create, gd = kr.create, wd = Yt.create, yd = bt.create, vd = Ke.create, bd = ln.create, _d = xt.create, xd = Ne.create, Md = Ne.strictCreate, Ed = Cr.create, kd = pa.create, Cd = Tr.create, Td = dt.create, Nd = ma.create, Id = dn.create, Od = pn.create, jd = ga.create, Sd = Nr.create, Ad = Ir.create, Dd = Dr.create, Ld = Or.create, $d = Qt.create, Do = $e.create, Pd = qe.create, Rd = Mt.create, zd = $e.createWithPreprocess, Fd = Hi.create, Ud = () => _a().optional(), Zd = () => xa().optional(), Bd = () => Ma().optional(), Wd = {
  string: (t) => Wt.create({ ...t, coerce: !0 }),
  number: (t) => br.create({ ...t, coerce: !0 }),
  boolean: (t) => xr.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => _r.create({ ...t, coerce: !0 }),
  date: (t) => Mr.create({ ...t, coerce: !0 })
}, Yd = j;
var k = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: vr,
  setErrorMap: ed,
  getErrorMap: nn,
  makeIssue: on,
  EMPTY_PATH: td,
  addIssueToContext: T,
  ParseStatus: be,
  INVALID: j,
  DIRTY: ua,
  OK: de,
  isAborted: gi,
  isDirty: wi,
  isValid: sn,
  isAsync: an,
  get util() {
    return B;
  },
  ZodParsedType: C,
  getParsedType: it,
  ZodType: L,
  ZodString: Wt,
  ZodNumber: br,
  ZodBigInt: _r,
  ZodBoolean: xr,
  ZodDate: Mr,
  ZodSymbol: cn,
  ZodUndefined: Er,
  ZodNull: kr,
  ZodAny: Yt,
  ZodUnknown: bt,
  ZodNever: Ke,
  ZodVoid: ln,
  ZodArray: xt,
  get objectUtil() {
    return un;
  },
  ZodObject: Ne,
  ZodUnion: Cr,
  ZodDiscriminatedUnion: pa,
  ZodIntersection: Tr,
  ZodTuple: dt,
  ZodRecord: ma,
  ZodMap: dn,
  ZodSet: pn,
  ZodFunction: ga,
  ZodLazy: Nr,
  ZodLiteral: Ir,
  ZodEnum: Dr,
  ZodNativeEnum: Or,
  ZodPromise: Qt,
  ZodEffects: $e,
  ZodTransformer: $e,
  ZodOptional: qe,
  ZodNullable: Mt,
  ZodDefault: jr,
  ZodCatch: fn,
  ZodNaN: hn,
  BRAND: cd,
  ZodBranded: ya,
  ZodPipeline: Hi,
  custom: ba,
  Schema: L,
  ZodSchema: L,
  late: ld,
  get ZodFirstPartyTypeKind() {
    return N;
  },
  coerce: Wd,
  any: wd,
  array: _d,
  bigint: pd,
  boolean: Ma,
  date: fd,
  discriminatedUnion: kd,
  effect: Do,
  enum: Dd,
  function: jd,
  instanceof: ud,
  intersection: Cd,
  lazy: Sd,
  literal: Ad,
  map: Id,
  nan: dd,
  nativeEnum: Ld,
  never: vd,
  null: gd,
  nullable: Rd,
  number: xa,
  object: xd,
  oboolean: Bd,
  onumber: Zd,
  optional: Pd,
  ostring: Ud,
  pipeline: Fd,
  preprocess: zd,
  promise: $d,
  record: Nd,
  set: Od,
  strictObject: Md,
  string: _a,
  symbol: hd,
  transformer: Do,
  tuple: Td,
  undefined: md,
  union: Ed,
  unknown: yd,
  void: bd,
  NEVER: Yd,
  ZodIssueCode: M,
  quotelessJson: Xu,
  ZodError: He
});
const Ea = /^0x[0-9a-f]+$/i, ka = /^\d+$/, Qd = k.string().nonempty("The short string cannot be empty").max(31, "The short string cannot exceed 31 characters").refine(
  (t) => !Ea.test(t),
  "The shortString should not be a hex string"
).refine(
  (t) => !ka.test(t),
  "The shortString should not be an integer string"
), Xr = k.union([
  k.string().regex(
    Ea,
    "Only hex, integers and bigint are supported in calldata"
  ),
  k.string().regex(
    ka,
    "Only hex, integers and bigint are supported in calldata"
  ),
  Qd,
  k.number().int("Only hex, integers and bigint are supported in calldata"),
  k.bigint()
]), Lo = k.object({
  contractAddress: k.string(),
  entrypoint: k.string(),
  calldata: k.array(Xr).optional()
}), Vd = k.object({
  types: k.record(
    k.array(
      k.union([
        k.object({
          name: k.string(),
          type: k.string()
        }),
        k.object({
          name: k.string(),
          type: k.literal("merkletree"),
          contains: k.string()
        })
      ])
    )
  ),
  primaryType: k.string(),
  domain: k.record(k.unknown()),
  message: k.record(k.unknown())
}), $o = {
  enable: k.tuple([
    k.object({
      starknetVersion: k.union([k.literal("v4"), k.literal("v5")]).optional()
    }).optional()
  ]).or(k.tuple([])),
  addStarknetChain: k.tuple([
    k.object({
      id: k.string(),
      chainId: k.string(),
      chainName: k.string(),
      rpcUrls: k.array(k.string()).optional(),
      nativeCurrency: k.object({
        name: k.string(),
        symbol: k.string(),
        decimals: k.number()
      }).optional(),
      blockExplorerUrls: k.array(k.string()).optional()
    })
  ]),
  switchStarknetChain: k.tuple([
    k.object({
      chainId: k.string()
    })
  ]),
  watchAsset: k.tuple([
    k.object({
      type: k.literal("ERC20"),
      options: k.object({
        address: k.string(),
        symbol: k.string().optional(),
        decimals: k.number().optional(),
        image: k.string().optional(),
        name: k.string().optional()
      })
    })
  ]),
  execute: k.tuple([
    k.array(Lo).nonempty().or(Lo),
    k.array(k.any()).optional(),
    k.object({
      nonce: Xr.optional(),
      maxFee: Xr.optional(),
      version: Xr.optional()
    }).optional()
  ]),
  signMessage: k.tuple([Vd])
}, Ae = Rl.create({
  isServer: !1,
  allowOutsideOfServer: !0
});
let Ei = zi, ki = "", Ca = "";
const mr = ({
  width: t = 775,
  height: e = 385,
  origin: r,
  location: n,
  atLeftBottom: i = !1
}) => {
  const o = (window == null ? void 0 : window.outerWidth) ?? (window == null ? void 0 : window.innerWidth) ?? (window == null ? void 0 : window.screen.width) ?? 0, s = (window == null ? void 0 : window.outerHeight) ?? (window == null ? void 0 : window.innerHeight) ?? (window == null ? void 0 : window.screen.height) ?? 0, a = (window == null ? void 0 : window.screenLeft) ?? (window == null ? void 0 : window.screenX) ?? 0, c = (window == null ? void 0 : window.screenTop) ?? (window == null ? void 0 : window.screenY) ?? 0, l = i ? 0 : a + o / 2 - t / 2, u = i ? window.screen.availHeight + 10 : c + s / 2 - e / 2;
  Ei = r ?? Ei, ki = n ?? ki, Ca = `width=${t},height=${e},top=${u},left=${l},toolbar=no,menubar=no,scrollbars=no,location=no,status=no,popup=1`;
};
Ae.router({
  authorize: Ae.procedure.output(k.boolean()).mutation(async () => !0),
  connect: Ae.procedure.mutation(async () => ""),
  enable: Ae.procedure.output(k.string()).mutation(async () => ""),
  execute: Ae.procedure.input($o.execute).output(k.string()).mutation(async () => ""),
  signMessage: Ae.procedure.input($o.signMessage).output(k.string().array()).mutation(async () => []),
  getLoginStatus: Ae.procedure.output(
    k.object({
      isLoggedIn: k.boolean(),
      hasSession: k.boolean().optional(),
      isPreauthorized: k.boolean().optional()
    })
  ).mutation(async () => ({
    isLoggedIn: !0
  })),
  addStarknetChain: Ae.procedure.mutation((t) => {
    throw Error("not implemented");
  }),
  switchStarknetChain: Ae.procedure.mutation((t) => {
    throw Error("not implemented");
  }),
  watchAsset: Ae.procedure.mutation((t) => {
    throw Error("not implemented");
  }),
  updateModal: Ae.procedure.subscription(async () => {
  })
});
const Hd = ({
  iframe: t
}) => vl({
  links: [
    hl({
      enabled: (e) => process.env.NODE_ENV === "development" && typeof window < "u" || process.env.NODE_ENV === "development" && e.direction === "down" && e.result instanceof Error
    }),
    il({
      condition(e) {
        if (!t && e.type === "subscription")
          throw new Error(
            "subscription is not supported without an iframe window"
          );
        return !!t;
      },
      true: hi.windowLink({
        window,
        postWindow: t,
        postOrigin: "*"
      }),
      false: hi.popupLink({
        listenWindow: window,
        createPopup: () => {
          let e = null;
          const r = document.createElement("button");
          if (r.style.display = "none", r.addEventListener("click", () => {
            e = window.open(
              `${Ei}${ki}`,
              "popup",
              Ca
            );
          }), r.click(), (async () => {
            for (; !e; )
              await new Promise((n) => setTimeout(n, 100));
          })(), !e)
            throw new Error("Could not open popup");
          return e;
        },
        postOrigin: "*"
      })
    })
  ]
});
function qd(t) {
  const e = Ms();
  try {
    const { origin: r } = new URL(t);
    if (r.includes("localhost") || r.includes("127.0.0.1") || r.includes("hydrogen"))
      return e.testnet;
    if (r.includes("staging") || r.includes("argent.xyz"))
      return e.mainnet;
  } catch {
    console.warn(
      "Could not determine rpc nodeUrl from target URL, defaulting to mainnet"
    );
  }
  return e.mainnet;
}
const Gd = 385, Jd = 775, Kd = 385, Xd = 440, ep = 886, tp = 562;
let Po = class {
  async getPubKey() {
    throw new Error("Method not implemented");
  }
  async signMessage() {
    throw new Error("Method not implemented");
  }
  async signTransaction() {
    throw new Error("Method not implemented");
  }
  async signDeclareTransaction() {
    throw new Error("Method not implemented");
  }
  async signDeployAccountTransaction() {
    throw new Error("Method not implemented");
  }
};
class rp extends bs {
  constructor(e, r, n) {
    super(e, r, new Po()), dr(this, "signer", new Po()), dr(this, "execute", async (i, o, s) => {
      try {
        return mr({
          width: Gd,
          height: Jd,
          location: "/review"
        }), Array.isArray(i) && i[0] && i[0].entrypoint === "use_offchain_session" && mr({
          width: 1,
          height: 1,
          location: "/executeSessionTx",
          atLeftBottom: !0
        }), {
          transaction_hash: await this.proxyLink.execute.mutate([
            i,
            o,
            s
          ])
        };
      } catch (a) {
        throw a instanceof Error ? new Error(a.message) : new Error("Error while execute a transaction");
      }
    }), dr(this, "signMessage", async (i) => {
      try {
        return mr({
          width: Kd,
          height: Xd,
          location: "/signMessage"
        }), await this.proxyLink.signMessage.mutate([i]);
      } catch (o) {
        throw o instanceof Error ? new Error(o.message) : new Error("Error while sign a message");
      }
    }), this.address = r, this.proxyLink = n;
  }
}
const Zr = [], np = (t, e, r) => {
  const n = {
    ...t,
    isConnected: !1,
    provider: e,
    getLoginStatus: () => r.getLoginStatus.mutate(),
    async request(i) {
      switch (i.type) {
        case "wallet_addStarknetChain":
          return await r.addStarknetChain.mutate();
        case "wallet_switchStarknetChain":
          return await r.switchStarknetChain.mutate();
        case "wallet_watchAsset":
          return await r.watchAsset.mutate();
        default:
          throw new Error("not implemented");
      }
    },
    async enable(i) {
      if ((i == null ? void 0 : i.starknetVersion) !== "v4")
        throw Error("not implemented");
      try {
        mr({
          width: ep,
          height: tp,
          location: "/interstitialLogin"
        });
        const o = await r.enable.mutate();
        return await ip(
          n,
          e,
          r,
          o
        ), [o];
      } catch (o) {
        throw o instanceof Error ? new Error(o.message) : new Error("Unknow error on enable wallet");
      }
    },
    async isPreauthorized() {
      const { isLoggedIn: i, isPreauthorized: o } = await r.getLoginStatus.mutate();
      return !!(i && o);
    },
    on: (i, o) => {
      if (i === "accountsChanged")
        Zr.push({
          type: i,
          handler: o
        });
      else if (i === "networkChanged")
        Zr.push({
          type: i,
          handler: o
        });
      else
        throw new Error(`Unknwown event: ${i}`);
    },
    off: (i, o) => {
      if (i !== "accountsChanged" && i !== "networkChanged")
        throw new Error(`Unknwown event: ${i}`);
      const s = Zr.findIndex(
        (a) => a.type === i && a.handler === o
      );
      s >= 0 && Zr.splice(s, 1);
    }
  };
  return n;
};
async function ip(t, e, r, n) {
  if (t.isConnected)
    return t;
  const i = {
    isConnected: !0,
    chainId: await e.getChainId(),
    selectedAddress: n,
    account: new rp(e, n, r),
    provider: e
  };
  return Object.assign(t, i);
}
const op = async (t, e, r) => {
  const n = typeof window < "u" ? window : void 0;
  if (!n)
    throw new Error("window is not defined");
  const i = qd(t), o = r ?? new vs({ nodeUrl: i });
  return np(
    {
      host: n.location.origin,
      id: "argentWebWallet",
      icon: "https://www.argent.xyz/favicon.ico",
      name: "Argent Web Wallet",
      version: "1.0.0"
    },
    o,
    e
  );
};
let ke = null;
class Ta extends Ri {
  constructor(e = {}) {
    super(), dr(this, "_wallet", null), dr(this, "_options"), this._options = e;
  }
  available() {
    return !0;
  }
  async ready() {
    return ke ? (this._wallet = ke, this._wallet.isPreauthorized()) : (this._wallet = null, !1);
  }
  get id() {
    var e;
    return this._wallet = ke, ((e = this._wallet) == null ? void 0 : e.id) || "argentWebWallet";
  }
  get name() {
    var e;
    return this._wallet = ke, ((e = this._wallet) == null ? void 0 : e.name) || "Argent Web Wallet";
  }
  get icon() {
    return {
      light: yo,
      dark: yo
    };
  }
  get wallet() {
    if (!this._wallet)
      throw new we();
    return this._wallet;
  }
  get title() {
    return "Email";
  }
  get subtitle() {
    return "Powered by Argent";
  }
  async connect() {
    if (await this.ensureWallet(), !this._wallet)
      throw new Zt();
    try {
      await this._wallet.enable({ starknetVersion: "v4" });
    } catch {
      throw new yr();
    }
    if (!this._wallet.isConnected)
      throw new yr();
    const e = this._wallet.account, r = await this.chainId();
    return {
      account: e.address,
      chainId: r
    };
  }
  async disconnect() {
    var e;
    if (!this.available() && !this._wallet)
      throw new Zt();
    if (!((e = this._wallet) != null && e.isConnected))
      throw new Pi();
    ke = null, this._wallet = ke, Mn();
  }
  async account() {
    if (this._wallet = ke, !this._wallet || !this._wallet.account)
      throw new we();
    return this._wallet.account;
  }
  async chainId() {
    if (!this._wallet || !this.wallet.account || !this._wallet.provider)
      throw new we();
    const e = await this._wallet.provider.getChainId();
    return BigInt(e);
  }
  async initEventListener(e) {
    if (this._wallet = ke, !this._wallet)
      throw new we();
    this._wallet.on("accountsChanged", e);
  }
  async removeEventListener(e) {
    if (this._wallet = ke, !this._wallet)
      throw new we();
    this._wallet.off("accountsChanged", e), ke = null, this._wallet = null;
  }
  async ensureWallet() {
    const e = this._options.url || zi, r = this._options.provider;
    mr({
      origin: e,
      location: "/interstitialLogin"
    }), ke = await op(
      e,
      Hd({}),
      r
    ) ?? null, this._wallet = ke;
  }
}
var sp = Object.defineProperty, ap = (t, e, r) => e in t ? sp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ro = (t, e, r) => (ap(t, typeof e != "symbol" ? e + "" : e, r), r);
const zo = "f2e613881f7a0e811295cdd57999e31b", Fo = `<svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="#FF875B" />
    <path
      d="M18.316 8H13.684C13.5292 8 13.4052 8.1272 13.4018 8.28531C13.3082 12.7296 11.0323 16.9477 7.11513 19.9355C6.99077 20.0303 6.96243 20.2085 7.05335 20.3369L9.76349 24.1654C9.85569 24.2957 10.0353 24.3251 10.1618 24.2294C12.6111 22.3734 14.5812 20.1345 16 17.6529C17.4187 20.1345 19.389 22.3734 21.8383 24.2294C21.9646 24.3251 22.1443 24.2957 22.2366 24.1654L24.9467 20.3369C25.0375 20.2085 25.0092 20.0303 24.885 19.9355C20.9676 16.9477 18.6918 12.7296 18.5983 8.28531C18.5949 8.1272 18.4708 8 18.316 8Z"
      fill="white"
    />
  </svg>`, cp = () => Object.keys(localStorage).some(
  (t) => t === "walletconnect" || t.startsWith("wc@2:")
), Uo = () => {
  if (cp()) {
    delete localStorage.walletconnect;
    for (const t in localStorage)
      t.startsWith("wc@2:") && delete localStorage[t];
  }
};
let Na = class extends Ri {
  constructor(e = {}) {
    super(), Ro(this, "_wallet", null), Ro(this, "_options"), this._options = e;
  }
  available() {
    return !0;
  }
  async ready() {
    return await this.ensureWallet(), this._wallet ? this._wallet.isPreauthorized() : !1;
  }
  get id() {
    return "argentMobile";
  }
  get name() {
    return "Argent (mobile)";
  }
  get icon() {
    return {
      dark: Fo,
      light: Fo
    };
  }
  get wallet() {
    if (!this._wallet)
      throw new we();
    return this._wallet;
  }
  async connect() {
    if (await this.ensureWallet(), !this._wallet)
      throw new Zt();
    const e = this._wallet.account, r = await this.chainId();
    return {
      account: e.address,
      chainId: r
    };
  }
  async disconnect() {
    var e;
    if (await this._wallet.disable(), Uo(), !this.available() && !this._wallet)
      throw new Zt();
    if (!((e = this._wallet) != null && e.isConnected))
      throw new Pi();
    this._wallet = null;
  }
  async account() {
    if (!this._wallet || !this._wallet.account)
      throw new we();
    return this._wallet.account;
  }
  async chainId() {
    if (!this._wallet || !this.wallet.account || !this._wallet.provider)
      throw new we();
    const e = await this._wallet.provider.getChainId();
    return BigInt(e);
  }
  // needed, methods required by starknet-react. Otherwise an exception is throwd
  async initEventListener(e) {
    if (!this._wallet)
      throw new we();
    this._wallet.on("accountsChanged", e);
  }
  // needed, methods required by starknet-react. Otherwise an exception is throwd
  async removeEventListener(e) {
    if (!this._wallet)
      throw new we();
    this._wallet.off("accountsChanged", e), this._wallet = null;
  }
  async ensureWallet() {
    const { getStarknetWindowObject: e } = await import("./index-8e228000-yc7Iq3D1.js"), {
      chainId: r,
      projectId: n,
      dappName: i,
      description: o,
      url: s,
      icons: a,
      provider: c,
      rpcUrl: l
    } = this._options, u = Ms(), p = l ?? (!r || r === zt.NetworkName.SN_MAIN ? u.mainnet : u.testnet), m = {
      chainId: r ?? zt.NetworkName.SN_MAIN,
      name: i,
      projectId: n ?? zo,
      description: o,
      url: s,
      icons: a,
      provider: c,
      rpcUrl: p
    };
    n === zo && (console.log("========= NOTICE ========="), console.log(
      "While your application will continue to function, we highly recommended"
    ), console.log("signing up for your own API keys."), console.log(
      "Go to WalletConnect Cloud (https://cloud.walletconnect.com) and create a new account."
    ), console.log(
      "Once your account is created, create a new project and collect the Project ID"
    ), console.log("=========================="));
    const h = await e(m);
    if (!h)
      throw new yr();
    this._wallet = h;
    const w = this._wallet;
    await w.enable(), w.client.on("session_delete", () => {
      Uo(), this._wallet = null, Mn(), document.dispatchEvent(new Event("wallet_disconnected"));
    });
  }
};
var lp = Object.defineProperty, up = (t, e, r) => e in t ? lp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Zo = (t, e, r) => (up(t, typeof e != "symbol" ? e + "" : e, r), r);
const Bo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjQwMTggNy41NTU1NkgxMy41OTgyQzEzLjQzNzcgNy41NTU1NiAxMy4zMDkxIDcuNjg3NDcgMTMuMzA1NiA3Ljg1MTQzQzEzLjIwODUgMTIuNDYwMyAxMC44NDg0IDE2LjgzNDcgNi43ODYwOCAxOS45MzMxQzYuNjU3MTEgMjAuMDMxNCA2LjYyNzczIDIwLjIxNjIgNi43MjIwMiAyMC4zNDkzTDkuNTMyNTMgMjQuMzE5NkM5LjYyODE1IDI0LjQ1NDggOS44MTQ0NCAyNC40ODUzIDkuOTQ1NTggMjQuMzg2QzEyLjQ4NTYgMjIuNDYxMyAxNC41Mjg3IDIwLjEzOTUgMTYgMTcuNTY2QzE3LjQ3MTMgMjAuMTM5NSAxOS41MTQ1IDIyLjQ2MTMgMjIuMDU0NSAyNC4zODZDMjIuMTg1NiAyNC40ODUzIDIyLjM3MTkgMjQuNDU0OCAyMi40Njc2IDI0LjMxOTZMMjUuMjc4MSAyMC4zNDkzQzI1LjM3MjMgMjAuMjE2MiAyNS4zNDI5IDIwLjAzMTQgMjUuMjE0IDE5LjkzMzFDMjEuMTUxNiAxNi44MzQ3IDE4Ljc5MTUgMTIuNDYwMyAxOC42OTQ2IDcuODUxNDNDMTguNjkxMSA3LjY4NzQ3IDE4LjU2MjMgNy41NTU1NiAxOC40MDE4IDcuNTU1NTZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjQuNzIzNiAxMC40OTJMMjQuMjIzMSA4LjkyNDM5QzI0LjEyMTMgOC42MDYxNCAyMy44NzM0IDguMzU4MjQgMjMuNTU3NyA4LjI2MDIzTDIyLjAwMzkgNy43NzU5NUMyMS43ODk1IDcuNzA5MDYgMjEuNzg3MyA3LjQwMTc3IDIyLjAwMTEgNy4zMzIwMUwyMy41NDY5IDYuODI0NjZDMjMuODYwOSA2LjcyMTQ2IDI0LjEwNiA2LjQ2OTUyIDI0LjIwMjcgNi4xNTAxMUwyNC42Nzk4IDQuNTc1MDJDMjQuNzQ1OCA0LjM1NzA5IDI1LjA0ODkgNC4zNTQ3NyAyNS4xMTgzIDQuNTcxNTZMMjUuNjE4OCA2LjEzOTE1QzI1LjcyMDYgNi40NTc0IDI1Ljk2ODYgNi43MDUzMSAyNi4yODQyIDYuODAzOUwyNy44MzggNy4yODc2MUMyOC4wNTI0IDcuMzU0NSAyOC4wNTQ3IDcuNjYxNzkgMjcuODQwOCA3LjczMjEzTDI2LjI5NSA4LjIzOTQ4QzI1Ljk4MTEgOC4zNDIxIDI1LjczNiA4LjU5NDA0IDI1LjYzOTMgOC45MTQwMkwyNS4xNjIxIDEwLjQ4ODVDMjUuMDk2MSAxMC43MDY1IDI0Ljc5MyAxMC43MDg4IDI0LjcyMzYgMTAuNDkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==", dp = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZT0iYmxhY2siPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuODc5IDcuNTE5YzEuMTcxLTEuMDI1IDMuMDcxLTEuMDI1IDQuMjQyIDAgMS4xNzIgMS4wMjUgMS4xNzIgMi42ODcgMCAzLjcxMi0uMjAzLjE3OS0uNDMuMzI2LS42Ny40NDItLjc0NS4zNjEtMS40NS45OTktMS40NSAxLjgyN3YuNzVNMjEgMTJhOSA5IDAgMTEtMTggMCA5IDkgMCAwMTE4IDB6bS05IDUuMjVoLjAwOHYuMDA4SDEydi0uMDA4eiIgLz4KPC9zdmc+", pp = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZT0id2hpdGUiPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuODc5IDcuNTE5YzEuMTcxLTEuMDI1IDMuMDcxLTEuMDI1IDQuMjQyIDAgMS4xNzIgMS4wMjUgMS4xNzIgMi42ODcgMCAzLjcxMi0uMjAzLjE3OS0uNDMuMzI2LS42Ny40NDItLjc0NS4zNjEtMS40NS45OTktMS40NSAxLjgyN3YuNzVNMjEgMTJhOSA5IDAgMTEtMTggMCA5IDkgMCAwMTE4IDB6bS05IDUuMjVoLjAwOHYuMDA4SDEydi0uMDA4eiIgLz4KPC9zdmc+Cg==";
let mn = class extends Ri {
  constructor({ options: e }) {
    super(), Zo(this, "_wallet"), Zo(this, "_options"), this._options = e;
  }
  available() {
    return this.ensureWallet(), this._wallet !== void 0;
  }
  async ready() {
    return this.ensureWallet(), this._wallet ? await this._wallet.isPreauthorized() : !1;
  }
  async chainId() {
    if (this.ensureWallet(), !this._wallet)
      throw new we();
    const e = await this._wallet.provider.getChainId();
    return BigInt(e);
  }
  async onAccountsChanged(e) {
    let r;
    if (typeof e == "string" ? r = e : r = e[0], r) {
      const n = await this.chainId();
      this.emit("change", { account: r, chainId: n });
    } else
      this.emit("disconnect");
  }
  onNetworkChanged(e) {
    switch (e) {
      case "SN_MAIN":
        this.emit("change", {
          chainId: BigInt(zt.StarknetChainId.SN_MAIN)
        });
        break;
      case "SN_GOERLI":
        this.emit("change", {
          chainId: BigInt(zt.StarknetChainId.SN_GOERLI)
        });
        break;
      case "mainnet-alpha":
        this.emit("change", {
          chainId: BigInt(zt.StarknetChainId.SN_MAIN)
        });
        break;
      case "goerli-alpha":
        this.emit("change", {
          chainId: BigInt(zt.StarknetChainId.SN_GOERLI)
        });
        break;
      default:
        this.emit("change", {});
        break;
    }
  }
  async connect() {
    if (this.ensureWallet(), !this._wallet)
      throw new Zt();
    let e;
    try {
      e = await this._wallet.enable({ starknetVersion: "v5" });
    } catch {
      throw new yr();
    }
    if (!this._wallet.isConnected || !e)
      throw new yr();
    this._wallet.on("accountsChanged", async (i) => {
      await this.onAccountsChanged(i);
    }), this._wallet.on("networkChanged", (i) => {
      this.onNetworkChanged(i);
    }), await this.onAccountsChanged(e);
    const r = this._wallet.account.address, n = await this.chainId();
    return this.emit("connect", { account: r, chainId: n }), {
      account: r,
      chainId: n
    };
  }
  async disconnect() {
    var e;
    if (this.ensureWallet(), Mn(), !this.available())
      throw new Zt();
    if (!((e = this._wallet) != null && e.isConnected))
      throw new Pi();
  }
  async account() {
    if (this.ensureWallet(), !this._wallet || !this._wallet.account)
      throw new we();
    return this._wallet.account;
  }
  get id() {
    return this._options.id;
  }
  get name() {
    if (!this._wallet)
      throw new we();
    return this._wallet.name;
  }
  get icon() {
    var e;
    return this._options.icon ? this._options.icon : (e = this._wallet) != null && e.icon ? {
      dark: this._wallet.icon,
      light: this._wallet.icon
    } : {
      dark: pp,
      light: dp
    };
  }
  get wallet() {
    if (!this._wallet)
      throw new we();
    return this._wallet;
  }
  ensureWallet() {
    const e = fp(globalThis).filter((r) => r.id === this._options.id)[0];
    if (e) {
      const { provider: r } = this._options;
      r && Object.assign(e, {
        provider: r
      }), this._wallet = e;
    }
  }
};
function fp(t) {
  return Object.values(
    Object.getOwnPropertyNames(t).reduce((e, r) => {
      if (r.startsWith("starknet")) {
        const n = t[r];
        hp(n) && !e[n.id] && (e[n.id] = n);
      }
      return e;
    }, {})
  );
}
function hp(t) {
  try {
    return t && [
      // wallet's must have methods/members, see IStarknetWindowObject
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((e) => e in t);
  } catch {
  }
  return !1;
}
var mp = Object.defineProperty, gp = (t, e, r) => e in t ? mp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Wo = (t, e, r) => (gp(t, typeof e != "symbol" ? e + "" : e, r), r), wp = Object.defineProperty, yp = (t, e, r) => e in t ? wp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, vp = (t, e, r) => (yp(t, typeof e != "symbol" ? e + "" : e, r), r), qi = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
}, Le = (t, e, r) => (qi(t, e, "read from private field"), r ? r.call(t) : e.get(t)), rr = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, gn = (t, e, r, n) => (qi(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r), Br = (t, e, r) => (qi(t, e, "access private method"), r);
const bp = [
  {
    id: "argentX",
    name: "Argent X",
    icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
    }
  },
  {
    id: "braavos",
    name: "Braavos",
    icon: "data:image/svg+xml;base64,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",
    downloads: {
      chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
      edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
    }
  }
], _p = () => `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, Yo = (t) => {
  for (let e = t.length - 1; e > 0; e--) {
    const r = Math.floor(Math.random() * (e + 1));
    [t[e], t[r]] = [t[r], t[e]];
  }
  return t;
};
function Gn(...t) {
  return (e) => t.reduce((r, n) => r.then(n), Promise.resolve(e));
}
var wt, Ve, gr, Ci, Ia, lr, en;
class xp {
  constructor(e) {
    rr(this, Ci), rr(this, lr), rr(this, wt, !1), rr(this, Ve, void 0), rr(this, gr, void 0), vp(this, "value"), gn(this, gr, e), Br(this, lr, en).call(this);
  }
  set(e) {
    return !Le(this, wt) && !Br(this, lr, en).call(this) ? !1 : (this.delete(), this.value = e, e && (gn(this, Ve, `${Le(this, gr)}-${_p()}`), localStorage.setItem(Le(this, Ve), e)), !0);
  }
  get() {
    return Br(this, Ci, Ia).call(this), this.value;
  }
  delete() {
    return !Le(this, wt) && !Br(this, lr, en).call(this) ? !1 : (this.value = null, Le(this, Ve) && localStorage.removeItem(Le(this, Ve)), !0);
  }
}
wt = /* @__PURE__ */ new WeakMap(), Ve = /* @__PURE__ */ new WeakMap(), gr = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakSet(), Ia = function() {
  this.value && this.set(this.value);
}, lr = /* @__PURE__ */ new WeakSet(), en = function() {
  try {
    !Le(this, wt) && typeof window < "u" && (gn(this, Ve, Object.keys(localStorage).find(
      (t) => t.startsWith(Le(this, gr))
    )), gn(this, wt, !0), Le(this, Ve) && this.set(localStorage.getItem(Le(this, Ve))));
  } catch (t) {
    console.warn(t);
  }
  return Le(this, wt);
};
function Jn(t, e) {
  var r, n;
  if ((r = e == null ? void 0 : e.include) != null && r.length) {
    const i = new Set(e.include);
    return t.filter((o) => i.has(o.id));
  }
  if ((n = e == null ? void 0 : e.exclude) != null && n.length) {
    const i = new Set(e.exclude);
    return t.filter((o) => !i.has(o.id));
  }
  return t;
}
const Qo = async (t) => {
  const e = await Promise.all(
    t.map((r) => r.isPreauthorized().catch(() => !1))
  );
  return t.filter((r, n) => e[n]);
}, Mp = (t) => {
  try {
    return t && [
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((e) => e in t);
  } catch {
  }
  return !1;
};
function Kn(t, e) {
  return Object.values(
    Object.getOwnPropertyNames(t).reduce((r, n) => {
      if (n.startsWith("starknet")) {
        const i = t[n];
        e(i) && !r[i.id] && (r[i.id] = i);
      }
      return r;
    }, {})
  );
}
const Xn = (t, e) => {
  if (e && Array.isArray(e)) {
    t.sort((n, i) => e.indexOf(n.id) - e.indexOf(i.id));
    const r = t.length - e.length;
    return [
      ...t.slice(r),
      ...Yo(t.slice(0, r))
    ];
  } else
    return Yo(t);
}, Ep = typeof window < "u" ? window : {}, kp = {
  windowObject: Ep,
  isWalletObject: Mp,
  storageFactoryImplementation: (t) => new xp(t)
};
function Cp(t = {}) {
  const { storageFactoryImplementation: e, windowObject: r, isWalletObject: n } = {
    ...kp,
    ...t
  }, i = e("gsw-last");
  return {
    getAvailableWallets: async (o = {}) => {
      const s = Kn(
        r,
        n
      );
      return Gn(
        (a) => Jn(a, o),
        (a) => Xn(a, o.sort)
      )(s);
    },
    getPreAuthorizedWallets: async (o = {}) => {
      const s = Kn(
        r,
        n
      );
      return Gn(
        (a) => Qo(a),
        (a) => Jn(a, o),
        (a) => Xn(a, o.sort)
      )(s);
    },
    getDiscoveryWallets: async (o = {}) => Gn(
      (s) => Jn(s, o),
      (s) => Xn(s, o.sort)
    )(bp),
    getLastConnectedWallet: async () => {
      const o = i.get(), s = Kn(r, n).find(
        (c) => c.id === o
      ), [a] = await Qo(
        s ? [s] : []
      );
      return a || (i.delete(), null);
    },
    enable: async (o, s) => {
      if (await o.enable(s ?? { starknetVersion: "v5" }), !o.isConnected)
        throw new Error("Failed to connect to wallet");
      return i.set(o.id), o;
    },
    disconnect: async ({ clearLastWallet: o } = {}) => {
      o && i.delete();
    }
  };
}
const ei = Cp(), Tp = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, Oa = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, te = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, fe = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, nt = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
let v = class Pt {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(e, r) {
    const n = r.match(e);
    return n && n.length > 0 && n[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(e, r) {
    const n = r.match(e);
    return n && n.length > 1 && n[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(e, r, n) {
    if (e.test(r))
      return n;
  }
  static getWindowsVersionName(e) {
    switch (e) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(e) {
    const r = e.split(".").splice(0, 2).map((n) => parseInt(n, 10) || 0);
    if (r.push(0), r[0] === 10)
      switch (r[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(e) {
    const r = e.split(".").splice(0, 2).map((n) => parseInt(n, 10) || 0);
    if (r.push(0), !(r[0] === 1 && r[1] < 5)) {
      if (r[0] === 1 && r[1] < 6)
        return "Cupcake";
      if (r[0] === 1 && r[1] >= 6)
        return "Donut";
      if (r[0] === 2 && r[1] < 2)
        return "Eclair";
      if (r[0] === 2 && r[1] === 2)
        return "Froyo";
      if (r[0] === 2 && r[1] > 2)
        return "Gingerbread";
      if (r[0] === 3)
        return "Honeycomb";
      if (r[0] === 4 && r[1] < 1)
        return "Ice Cream Sandwich";
      if (r[0] === 4 && r[1] < 4)
        return "Jelly Bean";
      if (r[0] === 4 && r[1] >= 4)
        return "KitKat";
      if (r[0] === 5)
        return "Lollipop";
      if (r[0] === 6)
        return "Marshmallow";
      if (r[0] === 7)
        return "Nougat";
      if (r[0] === 8)
        return "Oreo";
      if (r[0] === 9)
        return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(e) {
    return e.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(e, r, n = !1) {
    const i = Pt.getVersionPrecision(e), o = Pt.getVersionPrecision(r);
    let s = Math.max(i, o), a = 0;
    const c = Pt.map([e, r], (l) => {
      const u = s - Pt.getVersionPrecision(l), p = l + new Array(u + 1).join(".0");
      return Pt.map(p.split("."), (m) => new Array(20 - m.length).join("0") + m).reverse();
    });
    for (n && (a = s - Math.min(i, o)), s -= 1; s >= a; ) {
      if (c[0][s] > c[1][s])
        return 1;
      if (c[0][s] === c[1][s]) {
        if (s === a)
          return 0;
        s -= 1;
      } else if (c[0][s] < c[1][s])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(e, r) {
    const n = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(e, r);
    for (i = 0; i < e.length; i += 1)
      n.push(r(e[i]));
    return n;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(e, r) {
    let n, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(e, r);
    for (n = 0, i = e.length; n < i; n += 1) {
      const o = e[n];
      if (r(o, n))
        return o;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(e, ...r) {
    const n = e;
    let i, o;
    if (Object.assign)
      return Object.assign(e, ...r);
    for (i = 0, o = r.length; i < o; i += 1) {
      const s = r[i];
      typeof s == "object" && s !== null && Object.keys(s).forEach((a) => {
        n[a] = s[a];
      });
    }
    return e;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(e) {
    return Tp[e];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(e) {
    return Oa[e] || "";
  }
};
const V = /version\/(\d+(\.?_?\d+)+)/i, Np = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(t) {
      const e = {
        name: "Googlebot"
      }, r = v.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, r = v.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(t) {
      const e = {
        name: "Samsung Internet for Android"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Whale/i],
    describe(t) {
      const e = {
        name: "NAVER Whale Browser"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(t) {
      const e = {
        name: "MZ Browser"
      }, r = v.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/focus/i],
    describe(t) {
      const e = {
        name: "Focus"
      }, r = v.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/swing/i],
    describe(t) {
      const e = {
        name: "Swing"
      }, r = v.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const e = {
        name: "Opera Coast"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const e = {
        name: "Opera Touch"
      }, r = v.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const e = {
        name: "Yandex Browser"
      }, r = v.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const e = {
        name: "UC Browser"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const e = {
        name: "Maxthon"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/epiphany/i],
    describe(t) {
      const e = {
        name: "Epiphany"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/puffin/i],
    describe(t) {
      const e = {
        name: "Puffin"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sleipnir/i],
    describe(t) {
      const e = {
        name: "Sleipnir"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/k-meleon/i],
    describe(t) {
      const e = {
        name: "K-Meleon"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/micromessenger/i],
    describe(t) {
      const e = {
        name: "WeChat"
      }, r = v.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const e = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, r = v.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const e = {
        name: "Internet Explorer"
      }, r = v.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = v.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, r = v.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/vivaldi/i],
    describe(t) {
      const e = {
        name: "Vivaldi"
      }, r = v.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/seamonkey/i],
    describe(t) {
      const e = {
        name: "SeaMonkey"
      }, r = v.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/sailfish/i],
    describe(t) {
      const e = {
        name: "Sailfish"
      }, r = v.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/silk/i],
    describe(t) {
      const e = {
        name: "Amazon Silk"
      }, r = v.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/phantom/i],
    describe(t) {
      const e = {
        name: "PhantomJS"
      }, r = v.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/slimerjs/i],
    describe(t) {
      const e = {
        name: "SlimerJS"
      }, r = v.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = {
        name: "BlackBerry"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = {
        name: "WebOS Browser"
      }, r = v.getFirstMatch(V, t) || v.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = {
        name: "Bada"
      }, r = v.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = {
        name: "Tizen"
      }, r = v.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/qupzilla/i],
    describe(t) {
      const e = {
        name: "QupZilla"
      }, r = v.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const e = {
        name: "Firefox"
      }, r = v.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const e = {
        name: "Electron"
      }, r = v.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(t) {
      const e = {
        name: "Miui"
      }, r = v.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const e = {
        name: "Chromium"
      }, r = v.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const e = {
        name: "Chrome"
      }, r = v.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  {
    test: [/GSA/i],
    describe(t) {
      const e = {
        name: "Google Search"
      }, r = v.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Android Browser */
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = {
        name: "Android Browser"
      }, r = v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(t) {
      const e = {
        name: "PlayStation 4"
      }, r = v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const e = {
        name: "Safari"
      }, r = v.getFirstMatch(V, t);
      return r && (e.version = r), e;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(t) {
      const e = /^(.*)\/(.*) /, r = /^(.*)\/(.*)[ \t]\((.*)/, n = t.search("\\(") !== -1 ? r : e;
      return {
        name: v.getFirstMatch(n, t),
        version: v.getSecondMatch(n, t)
      };
    }
  }
], Ip = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(t) {
      const e = v.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, t);
      return {
        name: fe.Roku,
        version: e
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(t) {
      const e = v.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, t);
      return {
        name: fe.WindowsPhone,
        version: e
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(t) {
      const e = v.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, t), r = v.getWindowsVersionName(e);
      return {
        name: fe.Windows,
        version: e,
        versionName: r
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(t) {
      const e = {
        name: fe.iOS
      }, r = v.getSecondMatch(/(Version\/)(\d[\d.]+)/, t);
      return r && (e.version = r), e;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(t) {
      const e = v.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, t).replace(/[_\s]/g, "."), r = v.getMacOSVersionName(e), n = {
        name: fe.MacOS,
        version: e
      };
      return r && (n.versionName = r), n;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(t) {
      const e = v.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, t).replace(/[_\s]/g, ".");
      return {
        name: fe.iOS,
        version: e
      };
    }
  },
  /* Android */
  {
    test(t) {
      const e = !t.test(/like android/i), r = t.test(/android/i);
      return e && r;
    },
    describe(t) {
      const e = v.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, t), r = v.getAndroidVersionName(e), n = {
        name: fe.Android,
        version: e
      };
      return r && (n.versionName = r), n;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = v.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, t), r = {
        name: fe.WebOS
      };
      return e && e.length && (r.version = e), r;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = v.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, t) || v.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, t) || v.getFirstMatch(/\bbb(\d+)/i, t);
      return {
        name: fe.BlackBerry,
        version: e
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(t) {
      const e = v.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, t);
      return {
        name: fe.Bada,
        version: e
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(t) {
      const e = v.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: fe.Tizen,
        version: e
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: fe.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: fe.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(t) {
      const e = v.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: fe.PlayStation4,
        version: e
      };
    }
  }
], Op = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(t) {
      const e = v.getFirstMatch(/(can-l01)/i, t) && "Nova", r = {
        type: te.mobile,
        vendor: "Huawei"
      };
      return e && (r.model = e), r;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: te.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: te.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: te.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: te.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: te.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: te.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(t) {
      const e = t.test(/ipod|iphone/i), r = t.test(/like (ipod|iphone)/i);
      return e && !r;
    },
    describe(t) {
      const e = v.getFirstMatch(/(ipod|iphone)/i, t);
      return {
        type: te.mobile,
        vendor: "Apple",
        model: e
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: te.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: te.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(t) {
      return t.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: te.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(t) {
      return t.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: te.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(t) {
      return t.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: te.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(t) {
      const e = Number(String(t.getOSVersion()).split(".")[0]);
      return t.getOSName(!0) === "android" && e >= 3;
    },
    describe() {
      return {
        type: te.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(t) {
      return t.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: te.mobile
      };
    }
  },
  /* desktop */
  {
    test(t) {
      return t.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: te.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(t) {
      return t.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: te.desktop
      };
    }
  },
  /* Linux */
  {
    test(t) {
      return t.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: te.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(t) {
      return t.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: te.tv
      };
    }
  },
  /* Roku */
  {
    test(t) {
      return t.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: te.tv
      };
    }
  }
], jp = [
  /* EdgeHTML */
  {
    test(t) {
      return t.getBrowserName(!0) === "microsoft edge";
    },
    describe(t) {
      if (/\sedg\//i.test(t))
        return {
          name: nt.Blink
        };
      const e = v.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, t);
      return {
        name: nt.EdgeHTML,
        version: e
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(t) {
      const e = {
        name: nt.Trident
      }, r = v.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Presto */
  {
    test(t) {
      return t.test(/presto/i);
    },
    describe(t) {
      const e = {
        name: nt.Presto
      }, r = v.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Gecko */
  {
    test(t) {
      const e = t.test(/gecko/i), r = t.test(/like gecko/i);
      return e && !r;
    },
    describe(t) {
      const e = {
        name: nt.Gecko
      }, r = v.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: nt.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(t) {
      const e = {
        name: nt.WebKit
      }, r = v.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, t);
      return r && (e.version = r), e;
    }
  }
];
class Vo {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(e, r = !1) {
    if (e == null || e === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = e, this.parsedResult = {}, r !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(e) {
    return e.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const e = v.find(Np, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.browser = e.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(e) {
    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const e = v.find(Ip, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(e) {
    const { name: r } = this.getOS();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(e = !1) {
    const { type: r } = this.getPlatform();
    return e ? String(r).toLowerCase() || "" : r || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const e = v.find(Op, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(e) {
    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const e = v.find(jp, (r) => {
      if (typeof r.test == "function")
        return r.test(this);
      if (r.test instanceof Array)
        return r.test.some((n) => this.test(n));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return v.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(e) {
    const r = {};
    let n = 0;
    const i = {};
    let o = 0;
    if (Object.keys(e).forEach((s) => {
      const a = e[s];
      typeof a == "string" ? (i[s] = a, o += 1) : typeof a == "object" && (r[s] = a, n += 1);
    }), n > 0) {
      const s = Object.keys(r), a = v.find(s, (l) => this.isOS(l));
      if (a) {
        const l = this.satisfies(r[a]);
        if (l !== void 0)
          return l;
      }
      const c = v.find(
        s,
        (l) => this.isPlatform(l)
      );
      if (c) {
        const l = this.satisfies(r[c]);
        if (l !== void 0)
          return l;
      }
    }
    if (o > 0) {
      const s = Object.keys(i), a = v.find(s, (c) => this.isBrowser(c, !0));
      if (a !== void 0)
        return this.compareVersion(i[a]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(e, r = !1) {
    const n = this.getBrowserName().toLowerCase();
    let i = e.toLowerCase();
    const o = v.getBrowserTypeByAlias(i);
    return r && o && (i = o.toLowerCase()), i === n;
  }
  compareVersion(e) {
    let r = [0], n = e, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return e[0] === ">" || e[0] === "<" ? (n = e.substr(1), e[1] === "=" ? (i = !0, n = e.substr(2)) : r = [], e[0] === ">" ? r.push(1) : r.push(-1)) : e[0] === "=" ? n = e.substr(1) : e[0] === "~" && (i = !0, n = e.substr(1)), r.indexOf(
        v.compareVersions(o, n, i)
      ) > -1;
  }
  isOS(e) {
    return this.getOSName(!0) === String(e).toLowerCase();
  }
  isPlatform(e) {
    return this.getPlatformType(!0) === String(e).toLowerCase();
  }
  isEngine(e) {
    return this.getEngineName(!0) === String(e).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(e, r = !1) {
    return this.isBrowser(e, r) || this.isOS(e) || this.isPlatform(e);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(e = []) {
    return e.some((r) => this.is(r));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Sp {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(e, r = !1) {
    if (typeof e != "string")
      throw new Error("UserAgent should be a string");
    return new Vo(e, r);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(e) {
    return new Vo(e).getResult();
  }
  static get BROWSER_MAP() {
    return Oa;
  }
  static get ENGINE_MAP() {
    return nt;
  }
  static get OS_MAP() {
    return fe;
  }
  static get PLATFORMS_MAP() {
    return te;
  }
}
const Ho = typeof window < "u" ? window : null;
function Ap() {
  var t;
  if (!Ho)
    return null;
  switch ((t = Sp.getParser(Ho.navigator.userAgent).getBrowserName()) == null ? void 0 : t.toLowerCase()) {
    case "firefox":
      return "firefox";
    case "microsoft edge":
      return "edge";
    case "android browser":
    case "chrome":
    case "chromium":
    case "electron":
    case "opera":
    case "vivaldi":
      return "chrome";
    default:
      return null;
  }
}
const Dp = ({
  argentMobileOptions: t,
  webWalletUrl: e,
  provider: r
}) => {
  const n = typeof window < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1, i = [];
  return n || (i.push(
    new mn({ options: { id: "argentX", provider: r } })
  ), i.push(
    new mn({ options: { id: "braavos", provider: r } })
  )), i.push(
    new Na({ ...t, provider: r })
  ), i.push(
    new Ta({ url: e, provider: r })
  ), i;
};
var Lp = typeof global == "object" && global && global.Object === Object && global;
const $p = Lp;
var Pp = typeof self == "object" && self && self.Object === Object && self, Rp = $p || Pp || Function("return this")();
const zp = Rp;
var Fp = zp.Symbol;
const wn = Fp;
var ja = Object.prototype, Up = ja.hasOwnProperty, Zp = ja.toString, nr = wn ? wn.toStringTag : void 0;
function Bp(t) {
  var e = Up.call(t, nr), r = t[nr];
  try {
    t[nr] = void 0;
    var n = !0;
  } catch {
  }
  var i = Zp.call(t);
  return n && (e ? t[nr] = r : delete t[nr]), i;
}
var Wp = Object.prototype, Yp = Wp.toString;
function Qp(t) {
  return Yp.call(t);
}
var Vp = "[object Null]", Hp = "[object Undefined]", qo = wn ? wn.toStringTag : void 0;
function qp(t) {
  return t == null ? t === void 0 ? Hp : Vp : qo && qo in Object(t) ? Bp(t) : Qp(t);
}
function Gp(t) {
  return t != null && typeof t == "object";
}
var Jp = Array.isArray;
const Kp = Jp;
var Xp = "[object String]";
function Go(t) {
  return typeof t == "string" || !Kp(t) && Gp(t) && qp(t) == Xp;
}
const ef = ({
  availableConnectors: t,
  installedWallets: e,
  discoveryWallets: r,
  storeVersion: n
}) => {
  var o;
  if ((o = window == null ? void 0 : window.starknet_argentX) != null && o.isInAppBrowser)
    return [];
  const i = e.map(
    (s) => t.find((a) => a.id === s.id)
  );
  return [
    ...t.filter((s) => i.includes(s)),
    ...t.filter((s) => !i.includes(s))
  ].map((s) => {
    const a = e.find((l) => l.id === s.id);
    if (a) {
      const l = a.id === "argentX" ? Bo : a.icon;
      return {
        name: a.name,
        id: a.id,
        icon: { light: l, dark: l },
        connector: s
      };
    }
    const c = r.filter(
      (l) => !!l.downloads[n]
    ).find((l) => l.id === s.id);
    if (c) {
      const { downloads: l } = c, u = c.id === "argentX" ? Bo : c.icon;
      return {
        name: c.name,
        id: c.id,
        icon: { light: u, dark: u },
        connector: s,
        download: l[n]
      };
    }
    return !s || !s.id || !s.name ? null : {
      name: s.name,
      id: s.id,
      icon: s.icon,
      connector: s,
      title: "title" in s && Go(s.title) ? s.title : void 0,
      subtitle: "subtitle" in s && Go(s.subtitle) ? s.subtitle : void 0
    };
  }).filter((s) => s !== null);
};
function Et() {
}
function Sa(t) {
  return t();
}
function Jo() {
  return /* @__PURE__ */ Object.create(null);
}
function ft(t) {
  t.forEach(Sa);
}
function Aa(t) {
  return typeof t == "function";
}
function Da(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let Wr;
function La(t, e) {
  return Wr || (Wr = document.createElement("a")), Wr.href = e, t === Wr.href;
}
function tf(t) {
  return Object.keys(t).length === 0;
}
function H(t, e) {
  t.appendChild(e);
}
function ht(t, e, r) {
  t.insertBefore(e, r || null);
}
function et(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function rf(t, e) {
  for (let r = 0; r < t.length; r += 1)
    t[r] && t[r].d(e);
}
function ie(t) {
  return document.createElement(t);
}
function kt(t) {
  return document.createTextNode(t);
}
function ct() {
  return kt(" ");
}
function $a() {
  return kt("");
}
function Fe(t, e, r, n) {
  return t.addEventListener(e, r, n), () => t.removeEventListener(e, r, n);
}
function D(t, e, r) {
  r == null ? t.removeAttribute(e) : t.getAttribute(e) !== r && t.setAttribute(e, r);
}
function nf(t) {
  return Array.from(t.childNodes);
}
function yn(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function Pa(t, e, r, n) {
  r == null ? t.style.removeProperty(e) : t.style.setProperty(e, r, n ? "important" : "");
}
let Sr;
function wr(t) {
  Sr = t;
}
function of() {
  if (!Sr)
    throw new Error("Function called outside component initialization");
  return Sr;
}
function sf(t) {
  of().$$.on_mount.push(t);
}
const Rt = [], Ko = [];
let Ut = [];
const Xo = [], af = /* @__PURE__ */ Promise.resolve();
let Ti = !1;
function cf() {
  Ti || (Ti = !0, af.then(Ra));
}
function Ni(t) {
  Ut.push(t);
}
const ti = /* @__PURE__ */ new Set();
let Dt = 0;
function Ra() {
  if (Dt !== 0)
    return;
  const t = Sr;
  do {
    try {
      for (; Dt < Rt.length; ) {
        const e = Rt[Dt];
        Dt++, wr(e), lf(e.$$);
      }
    } catch (e) {
      throw Rt.length = 0, Dt = 0, e;
    }
    for (wr(null), Rt.length = 0, Dt = 0; Ko.length; )
      Ko.pop()();
    for (let e = 0; e < Ut.length; e += 1) {
      const r = Ut[e];
      ti.has(r) || (ti.add(r), r());
    }
    Ut.length = 0;
  } while (Rt.length);
  for (; Xo.length; )
    Xo.pop()();
  Ti = !1, ti.clear(), wr(t);
}
function lf(t) {
  if (t.fragment !== null) {
    t.update(), ft(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(Ni);
  }
}
function uf(t) {
  const e = [], r = [];
  Ut.forEach((n) => t.indexOf(n) === -1 ? e.push(n) : r.push(n)), r.forEach((n) => n()), Ut = e;
}
const tn = /* @__PURE__ */ new Set();
let yt;
function za() {
  yt = {
    r: 0,
    c: [],
    p: yt
    // parent group
  };
}
function Fa() {
  yt.r || ft(yt.c), yt = yt.p;
}
function lt(t, e) {
  t && t.i && (tn.delete(t), t.i(e));
}
function Ar(t, e, r, n) {
  if (t && t.o) {
    if (tn.has(t))
      return;
    tn.add(t), yt.c.push(() => {
      tn.delete(t), n && (r && t.d(1), n());
    }), t.o(e);
  } else
    n && n();
}
function es(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function df(t) {
  t && t.c();
}
function Ua(t, e, r) {
  const { fragment: n, after_update: i } = t.$$;
  n && n.m(e, r), Ni(() => {
    const o = t.$$.on_mount.map(Sa).filter(Aa);
    t.$$.on_destroy ? t.$$.on_destroy.push(...o) : ft(o), t.$$.on_mount = [];
  }), i.forEach(Ni);
}
function Za(t, e) {
  const r = t.$$;
  r.fragment !== null && (uf(r.after_update), ft(r.on_destroy), r.fragment && r.fragment.d(e), r.on_destroy = r.fragment = null, r.ctx = []);
}
function pf(t, e) {
  t.$$.dirty[0] === -1 && (Rt.push(t), cf(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function Ba(t, e, r, n, i, o, s, a = [-1]) {
  const c = Sr;
  wr(t);
  const l = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: Et,
    not_equal: i,
    bound: Jo(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (c ? c.$$.context : [])),
    // everything else
    callbacks: Jo(),
    dirty: a,
    skip_bound: !1,
    root: e.target || c.$$.root
  };
  s && s(l.root);
  let u = !1;
  if (l.ctx = r ? r(t, e.props || {}, (p, m, ...h) => {
    const w = h.length ? h[0] : m;
    return l.ctx && i(l.ctx[p], l.ctx[p] = w) && (!l.skip_bound && l.bound[p] && l.bound[p](w), u && pf(t, p)), m;
  }) : [], l.update(), u = !0, ft(l.before_update), l.fragment = n ? n(l.ctx) : !1, e.target) {
    if (e.hydrate) {
      const p = nf(e.target);
      l.fragment && l.fragment.l(p), p.forEach(et);
    } else
      l.fragment && l.fragment.c();
    e.intro && lt(t.$$.fragment), Ua(t, e.target, e.anchor), Ra();
  }
  wr(c);
}
let Wa = class {
  constructor() {
    Wo(this, "$$"), Wo(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Za(this, 1), this.$destroy = Et;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, r) {
    if (!Aa(r))
      return Et;
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return n.push(r), () => {
      const i = n.indexOf(r);
      i !== -1 && n.splice(i, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !tf(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
};
const ff = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(ff);
function hf(t) {
  let e, r, n, i, o, s = (
    /*wallet*/
    (t[0].title ?? /*wallet*/
    t[0].name) + ""
  ), a, c, l, u = (
    /*wallet*/
    (t[0].subtitle ?? "") + ""
  ), p, m, h, w;
  function f(b, x) {
    var O;
    return (
      /*loadingItem*/
      b[2] === /*wallet*/
      ((O = b[0]) == null ? void 0 : O.id) ? yf : (
        /*isSvg*/
        b[4] ? wf : gf
      )
    );
  }
  let g = f(t), y = g(t);
  return {
    c() {
      e = ie("li"), r = ie("span"), n = ct(), i = ie("div"), o = ie("p"), a = kt(s), c = ct(), l = ie("p"), p = kt(u), m = ct(), y.c(), D(r, "class", "w-8 h-8"), D(o, "class", "font-semibold text-base p"), D(l, "class", "l2 p"), Pa(l, "text-align", "center"), D(i, "class", "flex flex-col justify-center items-center"), D(e, "class", `flex flex-row-reverse justify-between items-center 
            p-3 rounded-md cursor-pointer shadow-list-item 
            dark:shadow-none dark:bg-neutral-800 dark:text-white 
          hover:bg-neutral-100 dark:hover:bg-neutral-700 
          focus:outline-none focus:ring-2 
        focus:ring-neutral-200 dark:focus:ring-neutral-700 
          transition-colors`), D(e, "role", "button"), D(e, "tabindex", "0");
    },
    m(b, x) {
      ht(b, e, x), H(e, r), H(e, n), H(e, i), H(i, o), H(o, a), H(i, c), H(i, l), H(l, p), H(e, m), y.m(e, null), h || (w = [
        Fe(
          e,
          "click",
          /*click_handler_1*/
          t[8]
        ),
        Fe(
          e,
          "keyup",
          /*keyup_handler_1*/
          t[9]
        )
      ], h = !0);
    },
    p(b, x) {
      x & /*wallet*/
      1 && s !== (s = /*wallet*/
      (b[0].title ?? /*wallet*/
      b[0].name) + "") && yn(a, s), x & /*wallet*/
      1 && u !== (u = /*wallet*/
      (b[0].subtitle ?? "") + "") && yn(p, u), g === (g = f(b)) && y ? y.p(b, x) : (y.d(1), y = g(b), y && (y.c(), y.m(e, null)));
    },
    d(b) {
      b && et(e), y.d(), h = !1, ft(w);
    }
  };
}
function mf(t) {
  let e, r, n, i, o, s, a = (
    /*wallet*/
    t[0].name + ""
  ), c, l, u, p, m, h, w, f, g;
  return {
    c() {
      e = ie("a"), r = ie("li"), n = ie("span"), i = ct(), o = ie("p"), s = kt("Install "), c = kt(a), l = ct(), u = ie("img"), D(n, "class", "w-8 h-8"), D(o, "class", "font-semibold text-base p"), D(u, "alt", p = /*wallet*/
      t[0].name), La(u.src, m = /*icon*/
      t[3]) || D(u, "src", m), D(u, "class", "w-8 h-8 rounded-full"), D(r, "class", `flex flex-row-reverse justify-between items-center 
              p-3 rounded-md cursor-pointer shadow-list-item 
              dark:shadow-none dark:bg-neutral-800 dark:text-white 
            hover:bg-neutral-100 dark:hover:bg-neutral-700`), D(e, "aria-label", h = /*wallet*/
      t[0].name + " download link"), D(e, "href", w = /*wallet*/
      t[0].download), D(e, "target", "_blank"), D(e, "rel", "noopener noreferrer"), D(e, "class", `rounded-md focus:outline-none  focus:ring-2 
    focus:ring-neutral-200  dark:focus:ring-neutral-700 transition-colors`);
    },
    m(y, b) {
      ht(y, e, b), H(e, r), H(r, n), H(r, i), H(r, o), H(o, s), H(o, c), H(r, l), H(r, u), f || (g = [
        Fe(
          r,
          "click",
          /*click_handler*/
          t[6]
        ),
        Fe(
          r,
          "keyup",
          /*keyup_handler*/
          t[7]
        )
      ], f = !0);
    },
    p(y, b) {
      b & /*wallet*/
      1 && a !== (a = /*wallet*/
      y[0].name + "") && yn(c, a), b & /*wallet*/
      1 && p !== (p = /*wallet*/
      y[0].name) && D(u, "alt", p), b & /*wallet*/
      1 && h !== (h = /*wallet*/
      y[0].name + " download link") && D(e, "aria-label", h), b & /*wallet*/
      1 && w !== (w = /*wallet*/
      y[0].download) && D(e, "href", w);
    },
    d(y) {
      y && et(e), f = !1, ft(g);
    }
  };
}
function gf(t) {
  let e, r, n;
  return {
    c() {
      var i;
      e = ie("img"), D(e, "alt", r = /*wallet*/
      (i = t[0]) == null ? void 0 : i.name), La(e.src, n = /*icon*/
      t[3]) || D(e, "src", n), D(e, "class", "w-8 h-8 rounded");
    },
    m(i, o) {
      ht(i, e, o);
    },
    p(i, o) {
      var s;
      o & /*wallet*/
      1 && r !== (r = /*wallet*/
      (s = i[0]) == null ? void 0 : s.name) && D(e, "alt", r);
    },
    d(i) {
      i && et(e);
    }
  };
}
function wf(t) {
  let e;
  return {
    c() {
      e = ie("div"), Pa(e, "position", "relative");
    },
    m(r, n) {
      ht(r, e, n), e.innerHTML = /*icon*/
      t[3];
    },
    p: Et,
    d(r) {
      r && et(e);
    }
  };
}
function yf(t) {
  let e;
  return {
    c() {
      e = ie("div"), e.innerHTML = '<svg aria-hidden="true" class="w-8 h-8 text-neutral-300 animate-spin dark:text-neutral-600 fill-neutral-600 dark:fill-neutral-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path></svg> <span class="sr-only">Loading...</span>', D(e, "role", "status");
    },
    m(r, n) {
      ht(r, e, n);
    },
    p: Et,
    d(r) {
      r && et(e);
    }
  };
}
function vf(t) {
  let e;
  function r(o, s) {
    return (
      /*wallet*/
      o[0].download ? mf : hf
    );
  }
  let n = r(t), i = n(t);
  return {
    c() {
      i.c(), e = $a();
    },
    m(o, s) {
      i.m(o, s), ht(o, e, s);
    },
    p(o, [s]) {
      n === (n = r(o)) && i ? i.p(o, s) : (i.d(1), i = n(o), i && (i.c(), i.m(e.parentNode, e)));
    },
    i: Et,
    o: Et,
    d(o) {
      o && et(e), i.d(o);
    }
  };
}
function bf(t, e, r) {
  let { wallet: n } = e, { theme: i = null } = e, { cb: o = async () => {
  } } = e, { loadingItem: s = !1 } = e;
  const a = i === "dark" ? n.icon.dark : n.icon.light, c = a == null ? void 0 : a.startsWith("<svg"), l = () => {
    o(null);
  }, u = (h) => {
    h.key === "Enter" && o(null);
  }, p = async () => {
    o(n.connector);
  }, m = async (h) => {
    h.key === "Enter" && o(n.connector);
  };
  return t.$$set = (h) => {
    "wallet" in h && r(0, n = h.wallet), "theme" in h && r(5, i = h.theme), "cb" in h && r(1, o = h.cb), "loadingItem" in h && r(2, s = h.loadingItem);
  }, [
    n,
    o,
    s,
    a,
    c,
    i,
    l,
    u,
    p,
    m
  ];
}
class _f extends Wa {
  constructor(e) {
    super(), Ba(this, e, bf, vf, Da, {
      wallet: 0,
      theme: 5,
      cb: 1,
      loadingItem: 2
    });
  }
}
function ts(t, e, r) {
  const n = t.slice();
  return n[14] = e[r], n;
}
function rs(t) {
  let e, r, n, i, o, s, a, c, l, u, p, m, h, w, f, g = es(
    /*modalWallets*/
    t[1]
  ), y = [];
  for (let x = 0; x < g.length; x += 1)
    y[x] = ns(ts(t, g, x));
  const b = (x) => Ar(y[x], 1, 1, () => {
    y[x] = null;
  });
  return {
    c() {
      e = ie("div"), r = ie("main"), n = ie("header"), i = ie("h2"), i.textContent = "Connect to", o = ct(), s = ie("h1"), a = kt(
        /*dappName*/
        t[0]
      ), c = ct(), l = ie("span"), l.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.77275 3.02275C9.99242 2.80308 9.99242 2.44692 9.77275 2.22725C9.55308 2.00758 9.19692 2.00758 8.97725 2.22725L6 5.20451L3.02275 2.22725C2.80308 2.00758 2.44692 2.00758 2.22725 2.22725C2.00758 2.44692 2.00758 2.80308 2.22725 3.02275L5.20451 6L2.22725 8.97725C2.00758 9.19692 2.00758 9.55308 2.22725 9.77275C2.44692 9.99242 2.80308 9.99242 3.02275 9.77275L6 6.79549L8.97725 9.77275C9.19692 9.99242 9.55308 9.99242 9.77275 9.77275C9.99242 9.55308 9.99242 9.19692 9.77275 8.97725L6.79549 6L9.77275 3.02275Z" fill="currentColor"></path></svg>', u = ct(), p = ie("ul");
      for (let x = 0; x < y.length; x += 1)
        y[x].c();
      D(i, "class", "text-sm text-gray-400 font-semibold"), D(s, "class", `text-xl font-semibold mb-6 
                  max-w-[240px] overflow-hidden 
                  whitespace-nowrap text-ellipsis`), D(l, "class", `absolute top-0 right-0 p-2 cursor-pointer
                  rounded-full bg-neutral-100 dark:bg-neutral-800
                  text-neutral-400 dark:text-white
                  hover:bg-neutral-100 dark:hover:bg-neutral-700
                  focus:outline-none focus:ring-2
                focus:ring-neutral-200 dark:focus:ring-neutral-700
                  transition-colors`), D(l, "role", "button"), D(l, "tabindex", "0"), D(l, "aria-label", "Close"), D(n, "class", "flex items-center justify-center flex-col mb-2 relative"), D(p, "class", "flex flex-col gap-3"), D(r, "role", "dialog"), D(r, "class", `rounded-3xl shadow-modal dark:shadow-none 
              w-full max-w-[380px] z-50 
              mx-6 p-6 pb-8 text-center 
              bg-slate-50 dark:bg-neutral-900 
            text-neutral-900 dark:text-white`), D(e, "part", "starknetkit-modal"), D(e, "class", m = `modal-font backdrop-blur-sm fixed inset-0 flex items-center 
            justify-center bg-black/25 z-[9999] ${/*darkModeControlClass*/
      t[4]}`);
    },
    m(x, O) {
      ht(x, e, O), H(e, r), H(r, n), H(n, i), H(n, o), H(n, s), H(s, a), H(n, c), H(n, l), H(r, u), H(r, p);
      for (let R = 0; R < y.length; R += 1)
        y[R] && y[R].m(p, null);
      h = !0, w || (f = [
        Fe(
          l,
          "click",
          /*click_handler*/
          t[8]
        ),
        Fe(
          l,
          "keyup",
          /*keyup_handler*/
          t[9]
        ),
        Fe(r, "click", Mf),
        Fe(r, "keyup", Ef),
        Fe(
          e,
          "click",
          /*click_handler_2*/
          t[10]
        ),
        Fe(
          e,
          "keyup",
          /*keyup_handler_2*/
          t[11]
        )
      ], w = !0);
    },
    p(x, O) {
      if ((!h || O & /*dappName*/
      1) && yn(
        a,
        /*dappName*/
        x[0]
      ), O & /*modalWallets, loadingItem, cb, theme*/
      78) {
        g = es(
          /*modalWallets*/
          x[1]
        );
        let R;
        for (R = 0; R < g.length; R += 1) {
          const S = ts(x, g, R);
          y[R] ? (y[R].p(S, O), lt(y[R], 1)) : (y[R] = ns(S), y[R].c(), lt(y[R], 1), y[R].m(p, null));
        }
        for (za(), R = g.length; R < y.length; R += 1)
          b(R);
        Fa();
      }
      (!h || O & /*darkModeControlClass*/
      16 && m !== (m = `modal-font backdrop-blur-sm fixed inset-0 flex items-center 
            justify-center bg-black/25 z-[9999] ${/*darkModeControlClass*/
      x[4]}`)) && D(e, "class", m);
    },
    i(x) {
      if (!h) {
        for (let O = 0; O < g.length; O += 1)
          lt(y[O]);
        h = !0;
      }
    },
    o(x) {
      y = y.filter(Boolean);
      for (let O = 0; O < y.length; O += 1)
        Ar(y[O]);
      h = !1;
    },
    d(x) {
      x && et(e), rf(y, x), w = !1, ft(f);
    }
  };
}
function ns(t) {
  let e, r;
  return e = new _f({
    props: {
      wallet: (
        /*wallet*/
        t[14]
      ),
      loadingItem: (
        /*loadingItem*/
        t[3]
      ),
      cb: (
        /*cb*/
        t[6]
      ),
      theme: (
        /*theme*/
        t[2]
      )
    }
  }), {
    c() {
      df(e.$$.fragment);
    },
    m(n, i) {
      Ua(e, n, i), r = !0;
    },
    p(n, i) {
      const o = {};
      i & /*modalWallets*/
      2 && (o.wallet = /*wallet*/
      n[14]), i & /*loadingItem*/
      8 && (o.loadingItem = /*loadingItem*/
      n[3]), i & /*theme*/
      4 && (o.theme = /*theme*/
      n[2]), e.$set(o);
    },
    i(n) {
      r || (lt(e.$$.fragment, n), r = !0);
    },
    o(n) {
      Ar(e.$$.fragment, n), r = !1;
    },
    d(n) {
      Za(e, n);
    }
  };
}
function xf(t) {
  let e, r, n = !/*isInAppBrowser*/
  t[5] && /*modalWallets*/
  t[1].length > 1 && rs(t);
  return {
    c() {
      n && n.c(), e = $a();
    },
    m(i, o) {
      n && n.m(i, o), ht(i, e, o), r = !0;
    },
    p(i, [o]) {
      !/*isInAppBrowser*/
      i[5] && /*modalWallets*/
      i[1].length > 1 ? n ? (n.p(i, o), o & /*modalWallets*/
      2 && lt(n, 1)) : (n = rs(i), n.c(), lt(n, 1), n.m(e.parentNode, e)) : n && (za(), Ar(n, 1, 1, () => {
        n = null;
      }), Fa());
    },
    i(i) {
      r || (lt(n), r = !0);
    },
    o(i) {
      Ar(n), r = !1;
    },
    d(i) {
      i && et(e), n && n.d(i);
    }
  };
}
const Mf = (t) => t.stopPropagation(), Ef = (t) => {
  t.stopPropagation();
};
function kf(t, e, r) {
  var g;
  let { dappName: n = (window == null ? void 0 : window.document.title) ?? "" } = e, { modalWallets: i } = e, { callback: o = async () => {
  } } = e, { theme: s = null } = e, a = !1, c = (g = window == null ? void 0 : window.starknet_argentX) == null ? void 0 : g.isInAppBrowser;
  const l = (y) => {
    r(3, a = y);
  };
  let u = async (y) => {
    l((y == null ? void 0 : y.id) ?? !1);
    try {
      await o(y ?? null);
    } finally {
      l(!1);
    }
  }, p = s === "dark" ? "dark" : "";
  sf(async () => {
    if (s === "dark" || s === null && window.matchMedia("(prefers-color-scheme: dark)").matches ? r(4, p = "dark") : r(4, p = ""), c && (window == null ? void 0 : window.starknet_argentX)) {
      try {
        o(new mn({ options: { id: "argentX" } }));
      } catch {
      }
      return;
    }
    if (i.length === 1)
      try {
        const [y] = i;
        await o(y.connector);
      } catch (y) {
        console.error(y);
      }
  });
  const m = () => u(null), h = (y) => {
    y.key === "Enter" && u(null);
  }, w = () => u(null), f = (y) => {
    y.key === "Escape" && u(null);
  };
  return t.$$set = (y) => {
    "dappName" in y && r(0, n = y.dappName), "modalWallets" in y && r(1, i = y.modalWallets), "callback" in y && r(7, o = y.callback), "theme" in y && r(2, s = y.theme);
  }, [
    n,
    i,
    s,
    a,
    p,
    c,
    u,
    o,
    m,
    h,
    w,
    f
  ];
}
class Cf extends Wa {
  constructor(e) {
    super(), Ba(this, e, kf, xf, Da, {
      dappName: 0,
      modalWallets: 1,
      callback: 7,
      theme: 2
    });
  }
}
const Tf = `@import"https://fonts.googleapis.com/css2?family=Barlow:wght@500;600&display=swap";.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{inset:0}.top-0{top:0}.right-0{right:0}.z-\\[9999\\]{z-index:9999}.z-50{z-index:50}.mx-6{margin-left:1.5rem;margin-right:1.5rem}.mb-2{margin-bottom:.5rem}.mb-6{margin-bottom:1.5rem}.inline{display:inline}.flex{display:flex}.h-8{height:2rem}.w-8{width:2rem}.w-full{width:100%}.max-w-\\[380px\\]{max-width:380px}.max-w-\\[240px\\]{max-width:240px}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-pointer{cursor:pointer}.flex-row-reverse{flex-direction:row-reverse}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-3{gap:.75rem}.overflow-hidden{overflow:hidden}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.rounded-md{border-radius:.375rem}.rounded-full{border-radius:9999px}.rounded{border-radius:.25rem}.rounded-3xl{border-radius:1.5rem}.border{border-width:1px}.bg-black\\/25{background-color:#00000040}.bg-slate-50{--tw-bg-opacity: 1;background-color:rgb(248 250 252 / var(--tw-bg-opacity))}.bg-neutral-100{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.fill-neutral-600{fill:#525252}.p-3{padding:.75rem}.p-6{padding:1.5rem}.p-2{padding:.5rem}.pb-8{padding-bottom:2rem}.text-center{text-align:center}.text-base{font-size:1rem;line-height:1.5rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.font-semibold{font-weight:600}.text-neutral-300{--tw-text-opacity: 1;color:rgb(212 212 212 / var(--tw-text-opacity))}.text-neutral-900{--tw-text-opacity: 1;color:rgb(23 23 23 / var(--tw-text-opacity))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}.text-neutral-400{--tw-text-opacity: 1;color:rgb(163 163 163 / var(--tw-text-opacity))}.shadow-list-item{--tw-shadow: 0px 2px 12px rgba(0, 0, 0, .12);--tw-shadow-colored: 0px 2px 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-modal{--tw-shadow: 0px 4px 20px rgba(0, 0, 0, .5);--tw-shadow-colored: 0px 4px 20px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline{outline-style:solid}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-sm{--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition-colors{transition-property:color,background-color,border-color,fill,stroke,-webkit-text-decoration-color;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,-webkit-text-decoration-color;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.modal-font{font-family:Barlow,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;text-size-adjust:100%;font-feature-settings:"kern"}.l2{color:#8c8c8c;font-size:12px;font-weight:500;line-height:14px;letter-spacing:0em;text-align:left}.p{margin:0}.hover\\:bg-neutral-100:hover{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-neutral-200:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(229 229 229 / var(--tw-ring-opacity))}.dark .dark\\:bg-neutral-800{--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}.dark .dark\\:bg-neutral-900{--tw-bg-opacity: 1;background-color:rgb(23 23 23 / var(--tw-bg-opacity))}.dark .dark\\:fill-neutral-300{fill:#d4d4d4}.dark .dark\\:text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.dark .dark\\:text-neutral-600{--tw-text-opacity: 1;color:rgb(82 82 82 / var(--tw-text-opacity))}.dark .dark\\:shadow-none{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.dark .dark\\:hover\\:bg-neutral-700:hover{--tw-bg-opacity: 1;background-color:rgb(64 64 64 / var(--tw-bg-opacity))}.dark .dark\\:focus\\:ring-neutral-700:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(64 64 64 / var(--tw-ring-opacity))}
`;
let Yr = null;
const ri = async ({
  modalMode: t = "canAsk",
  storeVersion: e = Ap(),
  modalTheme: r,
  dappName: n,
  webWalletUrl: i = zi,
  argentMobileOptions: o,
  connectors: s = [],
  resultType: a = "wallet",
  provider: c,
  ...l
} = {}) => {
  Yr = null;
  const u = !s || s.length === 0 ? Dp({
    argentMobileOptions: o,
    webWalletUrl: i,
    provider: c
  }) : s, p = localStorage.getItem("starknetLastConnectedWallet");
  if (t === "neverAsk")
    try {
      const f = u.find((g) => g.id === p);
      return a === "wallet" && await (f == null ? void 0 : f.connect()), Yr = f ?? null, {
        connector: f,
        wallet: (f == null ? void 0 : f.wallet) ?? null
      };
    } catch (f) {
      throw Mn(), new Error(f);
    }
  const m = await ei.getAvailableWallets(l);
  if (t === "canAsk" && p && (((await ei.getPreAuthorizedWallets({
    ...l
  })).find((f) => f.id === p) ?? m.length === 1) && m[0])) {
    const f = u.find((g) => g.id === p);
    return a === "wallet" && await (f == null ? void 0 : f.connect()), f && (Yr = f), {
      connector: f,
      wallet: (f == null ? void 0 : f.wallet) ?? null
    };
  }
  const h = ef({
    availableConnectors: u,
    installedWallets: m,
    discoveryWallets: await ei.getDiscoveryWallets(l),
    storeVersion: e
  }), w = () => {
    const f = "starknetkit-modal-container", g = document.getElementById(f);
    if (g) {
      if (g.shadowRoot)
        return g.shadowRoot;
      g.remove();
    }
    const y = document.createElement("div");
    y.id = f, document.body.appendChild(y);
    const b = y.attachShadow({ mode: "open" });
    return b.innerHTML = `<style>${Tf}</style>`, b;
  };
  return new Promise((f, g) => {
    const y = new Cf({
      target: w(),
      props: {
        dappName: n,
        callback: async (b) => {
          try {
            Yr = b, a === "wallet" ? (await (b == null ? void 0 : b.connect()), b !== null && b.id !== "argentWebWallet" && Vc(b.id), f({
              connector: b,
              wallet: (b == null ? void 0 : b.wallet) ?? null
            })) : f({
              connector: b
            });
          } catch (x) {
            g(x);
          } finally {
            setTimeout(() => y.$destroy());
          }
        },
        theme: r === "system" ? null : r ?? null,
        modalWallets: h
      }
    });
  });
};
function Nf(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ya = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function i(c, l, u) {
    this.fn = c, this.context = l, this.once = u || !1;
  }
  function o(c, l, u, p, m) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, p || c, m), w = r ? r + l : l;
    return c._events[w] ? c._events[w].fn ? c._events[w] = [c._events[w], h] : c._events[w].push(h) : (c._events[w] = h, c._eventsCount++), c;
  }
  function s(c, l) {
    --c._eventsCount === 0 ? c._events = new n() : delete c._events[l];
  }
  function a() {
    this._events = new n(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var l = [], u, p;
    if (this._eventsCount === 0)
      return l;
    for (p in u = this._events)
      e.call(u, p) && l.push(r ? p.slice(1) : p);
    return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
  }, a.prototype.listeners = function(l) {
    var u = r ? r + l : l, p = this._events[u];
    if (!p)
      return [];
    if (p.fn)
      return [p.fn];
    for (var m = 0, h = p.length, w = new Array(h); m < h; m++)
      w[m] = p[m].fn;
    return w;
  }, a.prototype.listenerCount = function(l) {
    var u = r ? r + l : l, p = this._events[u];
    return p ? p.fn ? 1 : p.length : 0;
  }, a.prototype.emit = function(l, u, p, m, h, w) {
    var f = r ? r + l : l;
    if (!this._events[f])
      return !1;
    var g = this._events[f], y = arguments.length, b, x;
    if (g.fn) {
      switch (g.once && this.removeListener(l, g.fn, void 0, !0), y) {
        case 1:
          return g.fn.call(g.context), !0;
        case 2:
          return g.fn.call(g.context, u), !0;
        case 3:
          return g.fn.call(g.context, u, p), !0;
        case 4:
          return g.fn.call(g.context, u, p, m), !0;
        case 5:
          return g.fn.call(g.context, u, p, m, h), !0;
        case 6:
          return g.fn.call(g.context, u, p, m, h, w), !0;
      }
      for (x = 1, b = new Array(y - 1); x < y; x++)
        b[x - 1] = arguments[x];
      g.fn.apply(g.context, b);
    } else {
      var O = g.length, R;
      for (x = 0; x < O; x++)
        switch (g[x].once && this.removeListener(l, g[x].fn, void 0, !0), y) {
          case 1:
            g[x].fn.call(g[x].context);
            break;
          case 2:
            g[x].fn.call(g[x].context, u);
            break;
          case 3:
            g[x].fn.call(g[x].context, u, p);
            break;
          case 4:
            g[x].fn.call(g[x].context, u, p, m);
            break;
          default:
            if (!b)
              for (R = 1, b = new Array(y - 1); R < y; R++)
                b[R - 1] = arguments[R];
            g[x].fn.apply(g[x].context, b);
        }
    }
    return !0;
  }, a.prototype.on = function(l, u, p) {
    return o(this, l, u, p, !1);
  }, a.prototype.once = function(l, u, p) {
    return o(this, l, u, p, !0);
  }, a.prototype.removeListener = function(l, u, p, m) {
    var h = r ? r + l : l;
    if (!this._events[h])
      return this;
    if (!u)
      return s(this, h), this;
    var w = this._events[h];
    if (w.fn)
      w.fn === u && (!m || w.once) && (!p || w.context === p) && s(this, h);
    else {
      for (var f = 0, g = [], y = w.length; f < y; f++)
        (w[f].fn !== u || m && !w[f].once || p && w[f].context !== p) && g.push(w[f]);
      g.length ? this._events[h] = g.length === 1 ? g[0] : g : s(this, h);
    }
    return this;
  }, a.prototype.removeAllListeners = function(l) {
    var u;
    return l ? (u = r ? r + l : l, this._events[u] && s(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = r, a.EventEmitter = a, t.exports = a;
})(Ya);
var If = Ya.exports;
const Of = /* @__PURE__ */ Nf(If);
class jf extends Of {
}
class ir extends Error {
  constructor() {
    super(...arguments);
    ze(this, "name", "ConnectorNotConnectedError");
    ze(this, "message", "Connector not connected");
  }
}
class is extends Error {
  constructor() {
    super(...arguments);
    ze(this, "name", "ConnectorNotFoundError");
    ze(this, "message", "Connector not found");
  }
}
class os extends Error {
  constructor() {
    super(...arguments);
    ze(this, "name", "UserRejectedRequestError");
    ze(this, "message", "User rejected request");
  }
}
const ni = "data:image/png;base64,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";
class Sf extends bs {
  constructor(r, n, i) {
    super(r, n, i.signer);
    ze(this, "execute", async (r) => {
      try {
        const i = (Array.isArray(r) ? r : [r]).map((s) => ({
          contractAddress: s.contractAddress,
          entrypoint: s.entrypoint,
          calldata: Array.isArray(s.calldata) && "__compiled__" in s.calldata ? s.calldata : go.compile(s.calldata)
        }));
        let o = {
          contractAddress: this.address,
          entrypoint: "__execute__",
          calldata: go.compile({ txns: i })
        };
        return await this.parentAccount.execute(o);
      } catch (n) {
        throw console.log(n), new Error("Error while executing a transaction");
      }
    });
    this.address = n, this.parentAccount = i;
  }
}
const Af = {
  mainnet: "https://starknet-mainnet.public.blastapi.io",
  testnet: "https://starknet-testnet.public.blastapi.io"
}, Df = {
  mainnet: "https://rpc.starknet.lava.build",
  testnet: "https://rpc.starknet-testnet.lava.build"
}, ss = [Af, Df];
function Lf() {
  const t = Math.floor(Math.random() * ss.length);
  return ss[t];
}
function $f(t) {
  const e = Lf();
  return t == "SN_MAIN" ? e.mainnet : e.testnet;
}
const ii = [], Pf = (t, e, r, n) => {
  const i = $f("SN_MAIN"), o = n ?? new vs({ nodeUrl: i }), s = {
    ...t,
    isConnected: !1,
    provider: n,
    async request() {
      throw new Error("not implemented");
    },
    async enable(a) {
      if ((a == null ? void 0 : a.starknetVersion) !== "v4")
        throw Error("not implemented");
      try {
        return await Rf(
          s,
          o,
          e,
          r
        ), [e];
      } catch (c) {
        throw c instanceof Error ? new Error(c.message) : new Error("Unknown error on enable wallet");
      }
    },
    async isPreauthorized() {
      throw new Error("not implemented");
    },
    on: (a, c) => {
      if (a === "accountsChanged")
        ii.push({
          type: a,
          handler: c
        });
      else
        throw new Error(`Unknown event: ${a}`);
    },
    off: (a, c) => {
      if (a !== "accountsChanged" && a !== "networkChanged")
        throw new Error(`Unknown event: ${a}`);
      const l = ii.findIndex(
        (u) => u.type === a && u.handler === c
      );
      l >= 0 && ii.splice(l, 1);
    }
  };
  return s;
};
async function Rf(t, e, r, n) {
  const o = {
    id: "TBA",
    name: "Tokenbound Account",
    icon: "https://tokenbound.org/_next/image?url=%2Ftb-mark.svg&w=96&q=75",
    version: "1.0.0",
    isConnected: !0,
    chainId: await e.getChainId(),
    selectedAddress: r,
    account: new Sf(e, r, n),
    provider: e
  };
  return Object.assign(t, o);
}
let Ce = null;
class Mg extends jf {
  constructor(r) {
    super();
    ze(this, "_wallet", null);
    ze(this, "_options");
    this._options = r;
  }
  available() {
    return !0;
  }
  async ready() {
    return Ce ? (this._wallet = Ce, this._wallet.isPreauthorized()) : (this._wallet = null, !1);
  }
  get id() {
    var r;
    return this._wallet = Ce, ((r = this._wallet) == null ? void 0 : r.id) || "TBA";
  }
  get name() {
    var r;
    return this._wallet = Ce, ((r = this._wallet) == null ? void 0 : r.name) || "Tokenbound Account";
  }
  get icon() {
    return {
      light: ni,
      dark: ni
    };
  }
  get wallet() {
    if (!this._wallet)
      throw new ir();
    return this._wallet;
  }
  get subtitle() {
    return "Powered by Starknet Africa";
  }
  async connect() {
    if (await this.ensureWallet(), !this._wallet)
      throw new is();
    try {
      await this._wallet.enable({ starknetVersion: "v4" });
    } catch {
      throw new os();
    }
    if (!this._wallet.isConnected)
      throw new os();
    return this._wallet;
  }
  async disconnect() {
    if (!this.available() && !this._wallet)
      throw new is();
    Ce = null, this._wallet = Ce;
  }
  async account() {
    if (this._wallet = Ce, !this._wallet || !this._wallet.account)
      throw new ir();
    return this._wallet.account;
  }
  async chainId() {
    if (!this._wallet || !this.wallet.account || !this._wallet.provider)
      throw new ir();
    const r = await this._wallet.provider.getChainId();
    return BigInt(r);
  }
  async initEventListener(r) {
    if (this._wallet = Ce, !this._wallet)
      throw new ir();
    this._wallet.on("accountsChanged", r);
  }
  async removeEventListener(r) {
    if (this._wallet = Ce, !this._wallet)
      throw new ir();
    this._wallet.off("accountsChanged", r), Ce = null, this._wallet = null;
  }
  async connectParentAccount(r) {
    let n;
    if (r == "argentMobile") {
      const { wallet: i } = await ri({
        connectors: [
          new Na()
        ]
      });
      n = i;
    } else if (r == "argentWebWallet") {
      const { wallet: i } = await ri({
        connectors: [
          new Ta({
            url: "https://web.argent.xyz"
          })
        ]
      });
      n = i;
    } else {
      const { wallet: i } = await ri({
        connectors: [
          new mn({
            options: { id: r }
          })
        ]
      });
      n = i;
    }
    return n == null ? void 0 : n.account;
  }
  async ensureWallet() {
    const r = this._options.tokenboundAddress, n = await this.connectParentAccount(this._options.parentAccountId), i = this._options.provider;
    Ce = await Pf(
      {
        id: "TBA",
        icon: ni,
        name: "Tokenbound Account",
        version: "1.0.0"
      },
      r,
      n,
      i
    ) ?? null, this._wallet = Ce;
  }
}
function Eg() {
  const [t, e] = Te(!1), [r, n] = Te(""), [i, o] = Te("");
  return {
    isOpen: t,
    openModal: () => {
      e(!t);
    },
    closeModal: () => {
      e(!1);
    },
    value: r,
    selectedOption: i,
    handleChange: (p) => {
      o(p.target.value);
    },
    handleChangeInput: (p) => {
      n(p.target.value);
    },
    resetInputValues: () => {
      n(""), o("");
    }
  };
}
var Ii = { exports: {} }, or = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var as;
function zf() {
  if (as)
    return or;
  as = 1;
  var t = P, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, c, l) {
    var u, p = {}, m = null, h = null;
    l !== void 0 && (m = "" + l), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      n.call(c, u) && !o.hasOwnProperty(u) && (p[u] = c[u]);
    if (a && a.defaultProps)
      for (u in c = a.defaultProps, c)
        p[u] === void 0 && (p[u] = c[u]);
    return { $$typeof: e, type: a, key: m, ref: h, props: p, _owner: i.current };
  }
  return or.Fragment = r, or.jsx = s, or.jsxs = s, or;
}
var sr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cs;
function Ff() {
  return cs || (cs = 1, process.env.NODE_ENV !== "production" && function() {
    var t = P, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), w = Symbol.iterator, f = "@@iterator";
    function g(d) {
      if (d === null || typeof d != "object")
        return null;
      var _ = w && d[w] || d[f];
      return typeof _ == "function" ? _ : null;
    }
    var y = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(d) {
      {
        for (var _ = arguments.length, E = new Array(_ > 1 ? _ - 1 : 0), I = 1; I < _; I++)
          E[I - 1] = arguments[I];
        x("error", d, E);
      }
    }
    function x(d, _, E) {
      {
        var I = y.ReactDebugCurrentFrame, Z = I.getStackAddendum();
        Z !== "" && (_ += "%s", E = E.concat([Z]));
        var Q = E.map(function(F) {
          return String(F);
        });
        Q.unshift("Warning: " + _), Function.prototype.apply.call(console[d], console, Q);
      }
    }
    var O = !1, R = !1, S = !1, W = !1, he = !1, le;
    le = Symbol.for("react.module.reference");
    function J(d) {
      return !!(typeof d == "string" || typeof d == "function" || d === n || d === o || he || d === i || d === l || d === u || W || d === h || O || R || S || typeof d == "object" && d !== null && (d.$$typeof === m || d.$$typeof === p || d.$$typeof === s || d.$$typeof === a || d.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      d.$$typeof === le || d.getModuleId !== void 0));
    }
    function U(d, _, E) {
      var I = d.displayName;
      if (I)
        return I;
      var Z = _.displayName || _.name || "";
      return Z !== "" ? E + "(" + Z + ")" : E;
    }
    function ce(d) {
      return d.displayName || "Context";
    }
    function Y(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case a:
            var _ = d;
            return ce(_) + ".Consumer";
          case s:
            var E = d;
            return ce(E._context) + ".Provider";
          case c:
            return U(d, d.render, "ForwardRef");
          case p:
            var I = d.displayName || null;
            return I !== null ? I : Y(d.type) || "Memo";
          case m: {
            var Z = d, Q = Z._payload, F = Z._init;
            try {
              return Y(F(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, se = 0, me, Re, mt, Tt, Ye, tt, Se;
    function Kt() {
    }
    Kt.__reactDisabledLog = !0;
    function xe() {
      {
        if (se === 0) {
          me = console.log, Re = console.info, mt = console.warn, Tt = console.error, Ye = console.group, tt = console.groupCollapsed, Se = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: Kt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        se++;
      }
    }
    function to() {
      {
        if (se--, se === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, d, {
              value: me
            }),
            info: X({}, d, {
              value: Re
            }),
            warn: X({}, d, {
              value: mt
            }),
            error: X({}, d, {
              value: Tt
            }),
            group: X({}, d, {
              value: Ye
            }),
            groupCollapsed: X({}, d, {
              value: tt
            }),
            groupEnd: X({}, d, {
              value: Se
            })
          });
        }
        se < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xt = y.ReactCurrentDispatcher, er;
    function Nt(d, _, E) {
      {
        if (er === void 0)
          try {
            throw Error();
          } catch (Z) {
            var I = Z.stack.trim().match(/\n( *(at )?)/);
            er = I && I[1] || "";
          }
        return `
` + er + d;
      }
    }
    var It = !1, Ot;
    {
      var K = typeof WeakMap == "function" ? WeakMap : Map;
      Ot = new K();
    }
    function Me(d, _) {
      if (!d || It)
        return "";
      {
        var E = Ot.get(d);
        if (E !== void 0)
          return E;
      }
      var I;
      It = !0;
      var Z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Xt.current, Xt.current = null, xe();
      try {
        if (_) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (Qe) {
              I = Qe;
            }
            Reflect.construct(d, [], F);
          } else {
            try {
              F.call();
            } catch (Qe) {
              I = Qe;
            }
            d.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qe) {
            I = Qe;
          }
          d();
        }
      } catch (Qe) {
        if (Qe && I && typeof Qe.stack == "string") {
          for (var z = Qe.stack.split(`
`), pe = I.stack.split(`
`), ee = z.length - 1, re = pe.length - 1; ee >= 1 && re >= 0 && z[ee] !== pe[re]; )
            re--;
          for (; ee >= 1 && re >= 0; ee--, re--)
            if (z[ee] !== pe[re]) {
              if (ee !== 1 || re !== 1)
                do
                  if (ee--, re--, re < 0 || z[ee] !== pe[re]) {
                    var Ee = `
` + z[ee].replace(" at new ", " at ");
                    return d.displayName && Ee.includes("<anonymous>") && (Ee = Ee.replace("<anonymous>", d.displayName)), typeof d == "function" && Ot.set(d, Ee), Ee;
                  }
                while (ee >= 1 && re >= 0);
              break;
            }
        }
      } finally {
        It = !1, Xt.current = Q, to(), Error.prepareStackTrace = Z;
      }
      var At = d ? d.displayName || d.name : "", mo = At ? Nt(At) : "";
      return typeof d == "function" && Ot.set(d, mo), mo;
    }
    function ge(d, _, E) {
      return Me(d, !1);
    }
    function jt(d) {
      var _ = d.prototype;
      return !!(_ && _.isReactComponent);
    }
    function Rr(d, _, E) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return Me(d, jt(d));
      if (typeof d == "string")
        return Nt(d);
      switch (d) {
        case l:
          return Nt("Suspense");
        case u:
          return Nt("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case c:
            return ge(d.render);
          case p:
            return Rr(d.type, _, E);
          case m: {
            var I = d, Z = I._payload, Q = I._init;
            try {
              return Rr(Q(Z), _, E);
            } catch {
            }
          }
        }
      return "";
    }
    var zr = Object.prototype.hasOwnProperty, ro = {}, no = y.ReactDebugCurrentFrame;
    function Fr(d) {
      if (d) {
        var _ = d._owner, E = Rr(d.type, d._source, _ ? _.type : null);
        no.setExtraStackFrame(E);
      } else
        no.setExtraStackFrame(null);
    }
    function pc(d, _, E, I, Z) {
      {
        var Q = Function.call.bind(zr);
        for (var F in d)
          if (Q(d, F)) {
            var z = void 0;
            try {
              if (typeof d[F] != "function") {
                var pe = Error((I || "React class") + ": " + E + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw pe.name = "Invariant Violation", pe;
              }
              z = d[F](_, F, I, E, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ee) {
              z = ee;
            }
            z && !(z instanceof Error) && (Fr(Z), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", E, F, typeof z), Fr(null)), z instanceof Error && !(z.message in ro) && (ro[z.message] = !0, Fr(Z), b("Failed %s type: %s", E, z.message), Fr(null));
          }
      }
    }
    var fc = Array.isArray;
    function Rn(d) {
      return fc(d);
    }
    function hc(d) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, E = _ && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return E;
      }
    }
    function mc(d) {
      try {
        return io(d), !1;
      } catch {
        return !0;
      }
    }
    function io(d) {
      return "" + d;
    }
    function oo(d) {
      if (mc(d))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hc(d)), io(d);
    }
    var tr = y.ReactCurrentOwner, gc = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, so, ao, zn;
    zn = {};
    function wc(d) {
      if (zr.call(d, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(d, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return d.ref !== void 0;
    }
    function yc(d) {
      if (zr.call(d, "key")) {
        var _ = Object.getOwnPropertyDescriptor(d, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return d.key !== void 0;
    }
    function vc(d, _) {
      if (typeof d.ref == "string" && tr.current && _ && tr.current.stateNode !== _) {
        var E = Y(tr.current.type);
        zn[E] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(tr.current.type), d.ref), zn[E] = !0);
      }
    }
    function bc(d, _) {
      {
        var E = function() {
          so || (so = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        E.isReactWarning = !0, Object.defineProperty(d, "key", {
          get: E,
          configurable: !0
        });
      }
    }
    function _c(d, _) {
      {
        var E = function() {
          ao || (ao = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        E.isReactWarning = !0, Object.defineProperty(d, "ref", {
          get: E,
          configurable: !0
        });
      }
    }
    var xc = function(d, _, E, I, Z, Q, F) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: d,
        key: _,
        ref: E,
        props: F,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Mc(d, _, E, I, Z) {
      {
        var Q, F = {}, z = null, pe = null;
        E !== void 0 && (oo(E), z = "" + E), yc(_) && (oo(_.key), z = "" + _.key), wc(_) && (pe = _.ref, vc(_, Z));
        for (Q in _)
          zr.call(_, Q) && !gc.hasOwnProperty(Q) && (F[Q] = _[Q]);
        if (d && d.defaultProps) {
          var ee = d.defaultProps;
          for (Q in ee)
            F[Q] === void 0 && (F[Q] = ee[Q]);
        }
        if (z || pe) {
          var re = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
          z && bc(F, re), pe && _c(F, re);
        }
        return xc(d, z, pe, Z, I, tr.current, F);
      }
    }
    var Fn = y.ReactCurrentOwner, co = y.ReactDebugCurrentFrame;
    function St(d) {
      if (d) {
        var _ = d._owner, E = Rr(d.type, d._source, _ ? _.type : null);
        co.setExtraStackFrame(E);
      } else
        co.setExtraStackFrame(null);
    }
    var Un;
    Un = !1;
    function Zn(d) {
      return typeof d == "object" && d !== null && d.$$typeof === e;
    }
    function lo() {
      {
        if (Fn.current) {
          var d = Y(Fn.current.type);
          if (d)
            return `

Check the render method of \`` + d + "`.";
        }
        return "";
      }
    }
    function Ec(d) {
      {
        if (d !== void 0) {
          var _ = d.fileName.replace(/^.*[\\\/]/, ""), E = d.lineNumber;
          return `

Check your code at ` + _ + ":" + E + ".";
        }
        return "";
      }
    }
    var uo = {};
    function kc(d) {
      {
        var _ = lo();
        if (!_) {
          var E = typeof d == "string" ? d : d.displayName || d.name;
          E && (_ = `

Check the top-level render call using <` + E + ">.");
        }
        return _;
      }
    }
    function po(d, _) {
      {
        if (!d._store || d._store.validated || d.key != null)
          return;
        d._store.validated = !0;
        var E = kc(_);
        if (uo[E])
          return;
        uo[E] = !0;
        var I = "";
        d && d._owner && d._owner !== Fn.current && (I = " It was passed a child from " + Y(d._owner.type) + "."), St(d), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', E, I), St(null);
      }
    }
    function fo(d, _) {
      {
        if (typeof d != "object")
          return;
        if (Rn(d))
          for (var E = 0; E < d.length; E++) {
            var I = d[E];
            Zn(I) && po(I, _);
          }
        else if (Zn(d))
          d._store && (d._store.validated = !0);
        else if (d) {
          var Z = g(d);
          if (typeof Z == "function" && Z !== d.entries)
            for (var Q = Z.call(d), F; !(F = Q.next()).done; )
              Zn(F.value) && po(F.value, _);
        }
      }
    }
    function Cc(d) {
      {
        var _ = d.type;
        if (_ == null || typeof _ == "string")
          return;
        var E;
        if (typeof _ == "function")
          E = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === p))
          E = _.propTypes;
        else
          return;
        if (E) {
          var I = Y(_);
          pc(E, d.props, "prop", I, d);
        } else if (_.PropTypes !== void 0 && !Un) {
          Un = !0;
          var Z = Y(_);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tc(d) {
      {
        for (var _ = Object.keys(d.props), E = 0; E < _.length; E++) {
          var I = _[E];
          if (I !== "children" && I !== "key") {
            St(d), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), St(null);
            break;
          }
        }
        d.ref !== null && (St(d), b("Invalid attribute `ref` supplied to `React.Fragment`."), St(null));
      }
    }
    function ho(d, _, E, I, Z, Q) {
      {
        var F = J(d);
        if (!F) {
          var z = "";
          (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var pe = Ec(Z);
          pe ? z += pe : z += lo();
          var ee;
          d === null ? ee = "null" : Rn(d) ? ee = "array" : d !== void 0 && d.$$typeof === e ? (ee = "<" + (Y(d.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : ee = typeof d, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ee, z);
        }
        var re = Mc(d, _, E, Z, Q);
        if (re == null)
          return re;
        if (F) {
          var Ee = _.children;
          if (Ee !== void 0)
            if (I)
              if (Rn(Ee)) {
                for (var At = 0; At < Ee.length; At++)
                  fo(Ee[At], d);
                Object.freeze && Object.freeze(Ee);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              fo(Ee, d);
        }
        return d === n ? Tc(re) : Cc(re), re;
      }
    }
    function Nc(d, _, E) {
      return ho(d, _, E, !0);
    }
    function Ic(d, _, E) {
      return ho(d, _, E, !1);
    }
    var Oc = Ic, jc = Nc;
    sr.Fragment = n, sr.jsx = Oc, sr.jsxs = jc;
  }()), sr;
}
process.env.NODE_ENV === "production" ? Ii.exports = zf() : Ii.exports = Ff();
var ne = Ii.exports, Uf = Object.defineProperty, Zf = (t, e, r) => e in t ? Uf(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, oi = (t, e, r) => (Zf(t, typeof e != "symbol" ? e + "" : e, r), r);
let Bf = class {
  constructor() {
    oi(this, "current", this.detect()), oi(this, "handoffState", "pending"), oi(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Ge = new Bf(), Ie = (t, e) => {
  Ge.isServer ? ae(t, e) : Dc(t, e);
};
function Je(t) {
  let e = q(t);
  return Ie(() => {
    e.current = t;
  }, [t]), e;
}
let G = function(t) {
  let e = Je(t);
  return P.useCallback((...r) => e.current(...r), [e]);
};
function Dn(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function Ct() {
  let t = [], e = { addEventListener(r, n, i, o) {
    return r.addEventListener(n, i, o), e.add(() => r.removeEventListener(n, i, o));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return e.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return e.requestAnimationFrame(() => e.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return e.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return Dn(() => {
      n.current && r[0]();
    }), e.add(() => {
      n.current = !1;
    });
  }, style(r, n, i) {
    let o = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: i }), this.add(() => {
      Object.assign(r.style, { [n]: o });
    });
  }, group(r) {
    let n = Ct();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return t.push(r), () => {
      let n = t.indexOf(r);
      if (n >= 0)
        for (let i of t.splice(n, 1))
          i();
    };
  }, dispose() {
    for (let r of t.splice(0))
      r();
  } };
  return e;
}
function Gi() {
  let [t] = Te(Ct);
  return ae(() => () => t.dispose(), [t]), t;
}
function Wf() {
  let t = typeof document > "u";
  return "useSyncExternalStore" in at ? ((e) => e.useSyncExternalStore)(at)(() => () => {
  }, () => !1, () => !t) : !1;
}
function Gt() {
  let t = Wf(), [e, r] = at.useState(Ge.isHandoffComplete);
  return e && Ge.isHandoffComplete === !1 && r(!1), at.useEffect(() => {
    e !== !0 && r(!0);
  }, [e]), at.useEffect(() => Ge.handoff(), []), t ? !1 : e;
}
var ls;
let Jt = (ls = P.useId) != null ? ls : function() {
  let t = Gt(), [e, r] = P.useState(t ? () => Ge.nextId() : null);
  return Ie(() => {
    e === null && r(Ge.nextId());
  }, [e]), e != null ? "" + e : void 0;
};
function ue(t, e, ...r) {
  if (t in e) {
    let i = e[t];
    return typeof i == "function" ? i(...r) : i;
  }
  let n = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, ue), n;
}
function Qa(t) {
  return Ge.isServer ? null : t instanceof Node ? t.ownerDocument : t != null && t.hasOwnProperty("current") && t.current instanceof Node ? t.current.ownerDocument : document;
}
let Oi = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var gt = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(gt || {}), Va = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(Va || {}), Yf = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(Yf || {});
function Qf(t = document.body) {
  return t == null ? [] : Array.from(t.querySelectorAll(Oi)).sort((e, r) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Ha = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(Ha || {});
function Vf(t, e = 0) {
  var r;
  return t === ((r = Qa(t)) == null ? void 0 : r.body) ? !1 : ue(e, { 0() {
    return t.matches(Oi);
  }, 1() {
    let n = t;
    for (; n !== null; ) {
      if (n.matches(Oi))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var Hf = ((t) => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(Hf || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (t) => {
  t.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : t.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function _t(t) {
  t == null || t.focus({ preventScroll: !0 });
}
let qf = ["textarea", "input"].join(",");
function Gf(t) {
  var e, r;
  return (r = (e = t == null ? void 0 : t.matches) == null ? void 0 : e.call(t, qf)) != null ? r : !1;
}
function Jf(t, e = (r) => r) {
  return t.slice().sort((r, n) => {
    let i = e(r), o = e(n);
    if (i === null || o === null)
      return 0;
    let s = i.compareDocumentPosition(o);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function rn(t, e, { sorted: r = !0, relativeTo: n = null, skipElements: i = [] } = {}) {
  let o = Array.isArray(t) ? t.length > 0 ? t[0].ownerDocument : document : t.ownerDocument, s = Array.isArray(t) ? r ? Jf(t) : t : Qf(t);
  i.length > 0 && s.length > 1 && (s = s.filter((h) => !i.includes(h))), n = n ?? o.activeElement;
  let a = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, s.indexOf(n)) - 1;
    if (e & 4)
      return Math.max(0, s.indexOf(n)) + 1;
    if (e & 8)
      return s.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = e & 32 ? { preventScroll: !0 } : {}, u = 0, p = s.length, m;
  do {
    if (u >= p || u + p <= 0)
      return 0;
    let h = c + u;
    if (e & 16)
      h = (h + p) % p;
    else {
      if (h < 0)
        return 3;
      if (h >= p)
        return 1;
    }
    m = s[h], m == null || m.focus(l), u += a;
  } while (m !== o.activeElement);
  return e & 6 && Gf(m) && m.select(), 2;
}
function qa() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Kf() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Xf() {
  return qa() || Kf();
}
function Qr(t, e, r) {
  let n = Je(e);
  ae(() => {
    function i(o) {
      n.current(o);
    }
    return document.addEventListener(t, i, r), () => document.removeEventListener(t, i, r);
  }, [t, r]);
}
function Ga(t, e, r) {
  let n = Je(e);
  ae(() => {
    function i(o) {
      n.current(o);
    }
    return window.addEventListener(t, i, r), () => window.removeEventListener(t, i, r);
  }, [t, r]);
}
function eh(t, e, r = !0) {
  let n = q(!1);
  ae(() => {
    requestAnimationFrame(() => {
      n.current = r;
    });
  }, [r]);
  function i(s, a) {
    if (!n.current || s.defaultPrevented)
      return;
    let c = a(s);
    if (c === null || !c.getRootNode().contains(c) || !c.isConnected)
      return;
    let l = function u(p) {
      return typeof p == "function" ? u(p()) : Array.isArray(p) || p instanceof Set ? p : [p];
    }(t);
    for (let u of l) {
      if (u === null)
        continue;
      let p = u instanceof HTMLElement ? u : u.current;
      if (p != null && p.contains(c) || s.composed && s.composedPath().includes(p))
        return;
    }
    return !Vf(c, Ha.Loose) && c.tabIndex !== -1 && s.preventDefault(), e(s, c);
  }
  let o = q(null);
  Qr("pointerdown", (s) => {
    var a, c;
    n.current && (o.current = ((c = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : c[0]) || s.target);
  }, !0), Qr("mousedown", (s) => {
    var a, c;
    n.current && (o.current = ((c = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : c[0]) || s.target);
  }, !0), Qr("click", (s) => {
    Xf() || o.current && (i(s, () => o.current), o.current = null);
  }, !0), Qr("touchend", (s) => i(s, () => s.target instanceof HTMLElement ? s.target : null), !0), Ga("blur", (s) => i(s, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Lr(...t) {
  return ye(() => Qa(...t), [...t]);
}
let Ja = Symbol();
function th(t, e = !0) {
  return Object.assign(t, { [Ja]: e });
}
function Pe(...t) {
  let e = q(t);
  ae(() => {
    e.current = t;
  }, [t]);
  let r = G((n) => {
    for (let i of e.current)
      i != null && (typeof i == "function" ? i(n) : i.current = n);
  });
  return t.every((n) => n == null || (n == null ? void 0 : n[Ja])) ? void 0 : r;
}
function Ji(t, e) {
  let r = q([]), n = G(t);
  ae(() => {
    let i = [...r.current];
    for (let [o, s] of e.entries())
      if (r.current[o] !== s) {
        let a = n(e, i);
        return r.current = e, a;
      }
  }, [n, ...e]);
}
function vn(...t) {
  return Array.from(new Set(t.flatMap((e) => typeof e == "string" ? e.split(" ") : []))).filter(Boolean).join(" ");
}
var bn = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(bn || {}), st = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(st || {});
function je({ ourProps: t, theirProps: e, slot: r, defaultTag: n, features: i, visible: o = !0, name: s, mergeRefs: a }) {
  a = a ?? rh;
  let c = Ka(e, t);
  if (o)
    return Vr(c, r, n, s, a);
  let l = i ?? 0;
  if (l & 2) {
    let { static: u = !1, ...p } = c;
    if (u)
      return Vr(p, r, n, s, a);
  }
  if (l & 1) {
    let { unmount: u = !0, ...p } = c;
    return ue(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Vr({ ...p, hidden: !0, style: { display: "none" } }, r, n, s, a);
    } });
  }
  return Vr(c, r, n, s, a);
}
function Vr(t, e = {}, r, n, i) {
  let { as: o = r, children: s, refName: a = "ref", ...c } = si(t, ["unmount", "static"]), l = t.ref !== void 0 ? { [a]: t.ref } : {}, u = typeof s == "function" ? s(e) : s;
  "className" in c && c.className && typeof c.className == "function" && (c.className = c.className(e));
  let p = {};
  if (e) {
    let m = !1, h = [];
    for (let [w, f] of Object.entries(e))
      typeof f == "boolean" && (m = !0), f === !0 && h.push(w);
    m && (p["data-headlessui-state"] = h.join(" "));
  }
  if (o === Ze && Object.keys(us(c)).length > 0) {
    if (!$c(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(c).map((f) => `  - ${f}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((f) => `  - ${f}`).join(`
`)].join(`
`));
    let m = u.props, h = typeof (m == null ? void 0 : m.className) == "function" ? (...f) => vn(m == null ? void 0 : m.className(...f), c.className) : vn(m == null ? void 0 : m.className, c.className), w = h ? { className: h } : {};
    return Pc(u, Object.assign({}, Ka(u.props, us(si(c, ["ref"]))), p, l, { ref: i(u.ref, l.ref) }, w));
  }
  return Rc(o, Object.assign({}, si(c, ["ref"]), o !== Ze && l, o !== Ze && p), u);
}
function rh(...t) {
  return t.every((e) => e == null) ? void 0 : (e) => {
    for (let r of t)
      r != null && (typeof r == "function" ? r(e) : r.current = e);
  };
}
function Ka(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, r = {};
  for (let n of t)
    for (let i in n)
      i.startsWith("on") && typeof n[i] == "function" ? (r[i] != null || (r[i] = []), r[i].push(n[i])) : e[i] = n[i];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(e, { [n](i, ...o) {
      let s = r[n];
      for (let a of s) {
        if ((i instanceof Event || (i == null ? void 0 : i.nativeEvent) instanceof Event) && i.defaultPrevented)
          return;
        a(i, ...o);
      }
    } });
  return e;
}
function _e(t) {
  var e;
  return Object.assign(Lc(t), { displayName: (e = t.displayName) != null ? e : t.name });
}
function us(t) {
  let e = Object.assign({}, t);
  for (let r in e)
    e[r] === void 0 && delete e[r];
  return e;
}
function si(t, e = []) {
  let r = Object.assign({}, t);
  for (let n of e)
    n in r && delete r[n];
  return r;
}
let nh = "div";
var _n = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(_n || {});
function ih(t, e) {
  var r;
  let { features: n = 1, ...i } = t, o = { ref: e, "aria-hidden": (n & 2) === 2 ? !0 : (r = i["aria-hidden"]) != null ? r : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return je({ ourProps: o, theirProps: i, slot: {}, defaultTag: nh, name: "Hidden" });
}
let ji = _e(ih), Ki = Xe(null);
Ki.displayName = "OpenClosedContext";
var ve = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(ve || {});
function Xi() {
  return Oe(Ki);
}
function oh({ value: t, children: e }) {
  return P.createElement(Ki.Provider, { value: t }, e);
}
function sh(t) {
  function e() {
    document.readyState !== "loading" && (t(), document.removeEventListener("DOMContentLoaded", e));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}
let ot = [];
sh(() => {
  function t(e) {
    e.target instanceof HTMLElement && e.target !== document.body && ot[0] !== e.target && (ot.unshift(e.target), ot = ot.filter((r) => r != null && r.isConnected), ot.splice(10));
  }
  window.addEventListener("click", t, { capture: !0 }), window.addEventListener("mousedown", t, { capture: !0 }), window.addEventListener("focus", t, { capture: !0 }), document.body.addEventListener("click", t, { capture: !0 }), document.body.addEventListener("mousedown", t, { capture: !0 }), document.body.addEventListener("focus", t, { capture: !0 });
});
function ah(t) {
  let e = t.parentElement, r = null;
  for (; e && !(e instanceof HTMLFieldSetElement); )
    e instanceof HTMLLegendElement && (r = e), e = e.parentElement;
  let n = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return n && ch(r) ? !1 : n;
}
function ch(t) {
  if (!t)
    return !1;
  let e = t.previousElementSibling;
  for (; e !== null; ) {
    if (e instanceof HTMLLegendElement)
      return !1;
    e = e.previousElementSibling;
  }
  return !0;
}
var Xa = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(Xa || {});
function ec(t, e, r, n) {
  let i = Je(r);
  ae(() => {
    t = t ?? window;
    function o(s) {
      i.current(s);
    }
    return t.addEventListener(e, o, n), () => t.removeEventListener(e, o, n);
  }, [t, e, n]);
}
function $r() {
  let t = q(!1);
  return Ie(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function tc(t) {
  let e = G(t), r = q(!1);
  ae(() => (r.current = !1, () => {
    r.current = !0, Dn(() => {
      r.current && e();
    });
  }), [e]);
}
var ur = ((t) => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(ur || {});
function lh() {
  let t = q(0);
  return Ga("keydown", (e) => {
    e.key === "Tab" && (t.current = e.shiftKey ? 1 : 0);
  }, !0), t;
}
function rc(t) {
  if (!t)
    return /* @__PURE__ */ new Set();
  if (typeof t == "function")
    return new Set(t());
  let e = /* @__PURE__ */ new Set();
  for (let r of t.current)
    r.current instanceof HTMLElement && e.add(r.current);
  return e;
}
let uh = "div";
var nc = ((t) => (t[t.None = 1] = "None", t[t.InitialFocus = 2] = "InitialFocus", t[t.TabLock = 4] = "TabLock", t[t.FocusLock = 8] = "FocusLock", t[t.RestoreFocus = 16] = "RestoreFocus", t[t.All = 30] = "All", t))(nc || {});
function dh(t, e) {
  let r = q(null), n = Pe(r, e), { initialFocus: i, containers: o, features: s = 30, ...a } = t;
  Gt() || (s = 1);
  let c = Lr(r);
  hh({ ownerDocument: c }, !!(s & 16));
  let l = mh({ ownerDocument: c, container: r, initialFocus: i }, !!(s & 2));
  gh({ ownerDocument: c, container: r, containers: o, previousActiveElement: l }, !!(s & 8));
  let u = lh(), p = G((f) => {
    let g = r.current;
    g && ((y) => y())(() => {
      ue(u.current, { [ur.Forwards]: () => {
        rn(g, gt.First, { skipElements: [f.relatedTarget] });
      }, [ur.Backwards]: () => {
        rn(g, gt.Last, { skipElements: [f.relatedTarget] });
      } });
    });
  }), m = Gi(), h = q(!1), w = { ref: n, onKeyDown(f) {
    f.key == "Tab" && (h.current = !0, m.requestAnimationFrame(() => {
      h.current = !1;
    }));
  }, onBlur(f) {
    let g = rc(o);
    r.current instanceof HTMLElement && g.add(r.current);
    let y = f.relatedTarget;
    y instanceof HTMLElement && y.dataset.headlessuiFocusGuard !== "true" && (ic(g, y) || (h.current ? rn(r.current, ue(u.current, { [ur.Forwards]: () => gt.Next, [ur.Backwards]: () => gt.Previous }) | gt.WrapAround, { relativeTo: f.target }) : f.target instanceof HTMLElement && _t(f.target)));
  } };
  return P.createElement(P.Fragment, null, !!(s & 4) && P.createElement(ji, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: _n.Focusable }), je({ ourProps: w, theirProps: a, defaultTag: uh, name: "FocusTrap" }), !!(s & 4) && P.createElement(ji, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: _n.Focusable }));
}
let ph = _e(dh), ar = Object.assign(ph, { features: nc });
function fh(t = !0) {
  let e = q(ot.slice());
  return Ji(([r], [n]) => {
    n === !0 && r === !1 && Dn(() => {
      e.current.splice(0);
    }), n === !1 && r === !0 && (e.current = ot.slice());
  }, [t, ot, e]), G(() => {
    var r;
    return (r = e.current.find((n) => n != null && n.isConnected)) != null ? r : null;
  });
}
function hh({ ownerDocument: t }, e) {
  let r = fh(e);
  Ji(() => {
    e || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && _t(r());
  }, [e]), tc(() => {
    e && _t(r());
  });
}
function mh({ ownerDocument: t, container: e, initialFocus: r }, n) {
  let i = q(null), o = $r();
  return Ji(() => {
    if (!n)
      return;
    let s = e.current;
    s && Dn(() => {
      if (!o.current)
        return;
      let a = t == null ? void 0 : t.activeElement;
      if (r != null && r.current) {
        if ((r == null ? void 0 : r.current) === a) {
          i.current = a;
          return;
        }
      } else if (s.contains(a)) {
        i.current = a;
        return;
      }
      r != null && r.current ? _t(r.current) : rn(s, gt.First) === Va.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), i.current = t == null ? void 0 : t.activeElement;
    });
  }, [n]), i;
}
function gh({ ownerDocument: t, container: e, containers: r, previousActiveElement: n }, i) {
  let o = $r();
  ec(t == null ? void 0 : t.defaultView, "focus", (s) => {
    if (!i || !o.current)
      return;
    let a = rc(r);
    e.current instanceof HTMLElement && a.add(e.current);
    let c = n.current;
    if (!c)
      return;
    let l = s.target;
    l && l instanceof HTMLElement ? ic(a, l) ? (n.current = l, _t(l)) : (s.preventDefault(), s.stopPropagation(), _t(c)) : _t(n.current);
  }, !0);
}
function ic(t, e) {
  for (let r of t)
    if (r.contains(e))
      return !0;
  return !1;
}
let oc = Xe(!1);
function wh() {
  return Oe(oc);
}
function Si(t) {
  return P.createElement(oc.Provider, { value: t.force }, t.children);
}
function yh(t) {
  let e = wh(), r = Oe(sc), n = Lr(t), [i, o] = Te(() => {
    if (!e && r !== null || Ge.isServer)
      return null;
    let s = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (s)
      return s;
    if (n === null)
      return null;
    let a = n.createElement("div");
    return a.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(a);
  });
  return ae(() => {
    i !== null && (n != null && n.body.contains(i) || n == null || n.body.appendChild(i));
  }, [i, n]), ae(() => {
    e || r !== null && o(r.current);
  }, [r, o, e]), i;
}
let vh = Ze;
function bh(t, e) {
  let r = t, n = q(null), i = Pe(th((u) => {
    n.current = u;
  }), e), o = Lr(n), s = yh(n), [a] = Te(() => {
    var u;
    return Ge.isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
  }), c = Oe(Ai), l = Gt();
  return Ie(() => {
    !s || !a || s.contains(a) || (a.setAttribute("data-headlessui-portal", ""), s.appendChild(a));
  }, [s, a]), Ie(() => {
    if (a && c)
      return c.register(a);
  }, [c, a]), tc(() => {
    var u;
    !s || !a || (a instanceof Node && s.contains(a) && s.removeChild(a), s.childNodes.length <= 0 && ((u = s.parentElement) == null || u.removeChild(s)));
  }), l ? !s || !a ? null : Uc(je({ ourProps: { ref: i }, theirProps: r, defaultTag: vh, name: "Portal" }), a) : null;
}
let _h = Ze, sc = Xe(null);
function xh(t, e) {
  let { target: r, ...n } = t, i = { ref: Pe(e) };
  return P.createElement(sc.Provider, { value: r }, je({ ourProps: i, theirProps: n, defaultTag: _h, name: "Popover.Group" }));
}
let Ai = Xe(null);
function Mh() {
  let t = Oe(Ai), e = q([]), r = G((o) => (e.current.push(o), t && t.register(o), () => n(o))), n = G((o) => {
    let s = e.current.indexOf(o);
    s !== -1 && e.current.splice(s, 1), t && t.unregister(o);
  }), i = ye(() => ({ register: r, unregister: n, portals: e }), [r, n, e]);
  return [e, ye(() => function({ children: o }) {
    return P.createElement(Ai.Provider, { value: i }, o);
  }, [i])];
}
let Eh = _e(bh), kh = _e(xh), Di = Object.assign(Eh, { Group: kh });
function Ch(t, e) {
  return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
}
const Th = typeof Object.is == "function" ? Object.is : Ch, { useState: Nh, useEffect: Ih, useLayoutEffect: Oh, useDebugValue: jh } = at;
function Sh(t, e, r) {
  const n = e(), [{ inst: i }, o] = Nh({ inst: { value: n, getSnapshot: e } });
  return Oh(() => {
    i.value = n, i.getSnapshot = e, ai(i) && o({ inst: i });
  }, [t, n, e]), Ih(() => (ai(i) && o({ inst: i }), t(() => {
    ai(i) && o({ inst: i });
  })), [t]), jh(n), n;
}
function ai(t) {
  const e = t.getSnapshot, r = t.value;
  try {
    const n = e();
    return !Th(r, n);
  } catch {
    return !0;
  }
}
function Ah(t, e, r) {
  return e();
}
const Dh = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Lh = !Dh, $h = Lh ? Ah : Sh, Ph = "useSyncExternalStore" in at ? ((t) => t.useSyncExternalStore)(at) : $h;
function Rh(t) {
  return Ph(t.subscribe, t.getSnapshot, t.getSnapshot);
}
function zh(t, e) {
  let r = t(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(i) {
    return n.add(i), () => n.delete(i);
  }, dispatch(i, ...o) {
    let s = e[i].call(r, ...o);
    s && (r = s, n.forEach((a) => a()));
  } };
}
function Fh() {
  let t;
  return { before({ doc: e }) {
    var r;
    let n = e.documentElement;
    t = ((r = e.defaultView) != null ? r : window).innerWidth - n.clientWidth;
  }, after({ doc: e, d: r }) {
    let n = e.documentElement, i = n.clientWidth - n.offsetWidth, o = t - i;
    r.style(n, "paddingRight", `${o}px`);
  } };
}
function Uh() {
  return qa() ? { before({ doc: t, d: e, meta: r }) {
    function n(i) {
      return r.containers.flatMap((o) => o()).some((o) => o.contains(i));
    }
    e.microTask(() => {
      var i;
      if (window.getComputedStyle(t.documentElement).scrollBehavior !== "auto") {
        let a = Ct();
        a.style(t.documentElement, "scrollBehavior", "auto"), e.add(() => e.microTask(() => a.dispose()));
      }
      let o = (i = window.scrollY) != null ? i : window.pageYOffset, s = null;
      e.addEventListener(t, "click", (a) => {
        if (a.target instanceof HTMLElement)
          try {
            let c = a.target.closest("a");
            if (!c)
              return;
            let { hash: l } = new URL(c.href), u = t.querySelector(l);
            u && !n(u) && (s = u);
          } catch {
          }
      }, !0), e.addEventListener(t, "touchstart", (a) => {
        if (a.target instanceof HTMLElement)
          if (n(a.target)) {
            let c = a.target;
            for (; c.parentElement && n(c.parentElement); )
              c = c.parentElement;
            e.style(c, "overscrollBehavior", "contain");
          } else
            e.style(a.target, "touchAction", "none");
      }), e.addEventListener(t, "touchmove", (a) => {
        if (a.target instanceof HTMLElement)
          if (n(a.target)) {
            let c = a.target;
            for (; c.parentElement && c.dataset.headlessuiPortal !== "" && !(c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth); )
              c = c.parentElement;
            c.dataset.headlessuiPortal === "" && a.preventDefault();
          } else
            a.preventDefault();
      }, { passive: !1 }), e.add(() => {
        var a;
        let c = (a = window.scrollY) != null ? a : window.pageYOffset;
        o !== c && window.scrollTo(0, o), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function Zh() {
  return { before({ doc: t, d: e }) {
    e.style(t.documentElement, "overflow", "hidden");
  } };
}
function Bh(t) {
  let e = {};
  for (let r of t)
    Object.assign(e, r(e));
  return e;
}
let vt = zh(() => /* @__PURE__ */ new Map(), { PUSH(t, e) {
  var r;
  let n = (r = this.get(t)) != null ? r : { doc: t, count: 0, d: Ct(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(e), this.set(t, n), this;
}, POP(t, e) {
  let r = this.get(t);
  return r && (r.count--, r.meta.delete(e)), this;
}, SCROLL_PREVENT({ doc: t, d: e, meta: r }) {
  let n = { doc: t, d: e, meta: Bh(r) }, i = [Uh(), Fh(), Zh()];
  i.forEach(({ before: o }) => o == null ? void 0 : o(n)), i.forEach(({ after: o }) => o == null ? void 0 : o(n));
}, SCROLL_ALLOW({ d: t }) {
  t.dispose();
}, TEARDOWN({ doc: t }) {
  this.delete(t);
} });
vt.subscribe(() => {
  let t = vt.getSnapshot(), e = /* @__PURE__ */ new Map();
  for (let [r] of t)
    e.set(r, r.documentElement.style.overflow);
  for (let r of t.values()) {
    let n = e.get(r.doc) === "hidden", i = r.count !== 0;
    (i && !n || !i && n) && vt.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && vt.dispatch("TEARDOWN", r);
  }
});
function Wh(t, e, r) {
  let n = Rh(vt), i = t ? n.get(t) : void 0, o = i ? i.count > 0 : !1;
  return Ie(() => {
    if (!(!t || !e))
      return vt.dispatch("PUSH", t, r), () => vt.dispatch("POP", t, r);
  }, [e, t]), o;
}
let ci = /* @__PURE__ */ new Map(), cr = /* @__PURE__ */ new Map();
function ds(t, e = !0) {
  Ie(() => {
    var r;
    if (!e)
      return;
    let n = typeof t == "function" ? t() : t.current;
    if (!n)
      return;
    function i() {
      var s;
      if (!n)
        return;
      let a = (s = cr.get(n)) != null ? s : 1;
      if (a === 1 ? cr.delete(n) : cr.set(n, a - 1), a !== 1)
        return;
      let c = ci.get(n);
      c && (c["aria-hidden"] === null ? n.removeAttribute("aria-hidden") : n.setAttribute("aria-hidden", c["aria-hidden"]), n.inert = c.inert, ci.delete(n));
    }
    let o = (r = cr.get(n)) != null ? r : 0;
    return cr.set(n, o + 1), o !== 0 || (ci.set(n, { "aria-hidden": n.getAttribute("aria-hidden"), inert: n.inert }), n.setAttribute("aria-hidden", "true"), n.inert = !0), i;
  }, [t, e]);
}
function Yh({ defaultContainers: t = [], portals: e, mainTreeNodeRef: r } = {}) {
  var n;
  let i = q((n = r == null ? void 0 : r.current) != null ? n : null), o = Lr(i), s = G(() => {
    var a, c, l;
    let u = [];
    for (let p of t)
      p !== null && (p instanceof HTMLElement ? u.push(p) : "current" in p && p.current instanceof HTMLElement && u.push(p.current));
    if (e != null && e.current)
      for (let p of e.current)
        u.push(p);
    for (let p of (a = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? a : [])
      p !== document.body && p !== document.head && p instanceof HTMLElement && p.id !== "headlessui-portal-root" && (p.contains(i.current) || p.contains((l = (c = i.current) == null ? void 0 : c.getRootNode()) == null ? void 0 : l.host) || u.some((m) => p.contains(m)) || u.push(p));
    return u;
  });
  return { resolveContainers: s, contains: G((a) => s().some((c) => c.contains(a))), mainTreeNodeRef: i, MainTreeNode: ye(() => function() {
    return r != null ? null : P.createElement(ji, { features: _n.Hidden, ref: i });
  }, [i, r]) };
}
let eo = Xe(() => {
});
eo.displayName = "StackContext";
var Li = ((t) => (t[t.Add = 0] = "Add", t[t.Remove = 1] = "Remove", t))(Li || {});
function Qh() {
  return Oe(eo);
}
function Vh({ children: t, onUpdate: e, type: r, element: n, enabled: i }) {
  let o = Qh(), s = G((...a) => {
    e == null || e(...a), o(...a);
  });
  return Ie(() => {
    let a = i === void 0 || i === !0;
    return a && s(0, r, n), () => {
      a && s(1, r, n);
    };
  }, [s, r, n, i]), P.createElement(eo.Provider, { value: s }, t);
}
let ac = Xe(null);
function cc() {
  let t = Oe(ac);
  if (t === null) {
    let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, cc), e;
  }
  return t;
}
function Hh() {
  let [t, e] = Te([]);
  return [t.length > 0 ? t.join(" ") : void 0, ye(() => function(r) {
    let n = G((o) => (e((s) => [...s, o]), () => e((s) => {
      let a = s.slice(), c = a.indexOf(o);
      return c !== -1 && a.splice(c, 1), a;
    }))), i = ye(() => ({ register: n, slot: r.slot, name: r.name, props: r.props }), [n, r.slot, r.name, r.props]);
    return P.createElement(ac.Provider, { value: i }, r.children);
  }, [e])];
}
let qh = "p";
function Gh(t, e) {
  let r = Jt(), { id: n = `headlessui-description-${r}`, ...i } = t, o = cc(), s = Pe(e);
  Ie(() => o.register(n), [n, o.register]);
  let a = { ref: s, ...o.props, id: n };
  return je({ ourProps: a, theirProps: i, slot: o.slot || {}, defaultTag: qh, name: o.name || "Description" });
}
let Jh = _e(Gh), Kh = Object.assign(Jh, {});
var Xh = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(Xh || {}), em = ((t) => (t[t.SetTitleId = 0] = "SetTitleId", t))(em || {});
let tm = { 0(t, e) {
  return t.titleId === e.id ? t : { ...t, titleId: e.id };
} }, xn = Xe(null);
xn.displayName = "DialogContext";
function Pr(t) {
  let e = Oe(xn);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Pr), r;
  }
  return e;
}
function rm(t, e, r = () => [document.body]) {
  Wh(t, e, (n) => {
    var i;
    return { containers: [...(i = n.containers) != null ? i : [], r] };
  });
}
function nm(t, e) {
  return ue(e.type, tm, t, e);
}
let im = "div", om = bn.RenderStrategy | bn.Static;
function sm(t, e) {
  let r = Jt(), { id: n = `headlessui-dialog-${r}`, open: i, onClose: o, initialFocus: s, role: a = "dialog", __demoMode: c = !1, ...l } = t, [u, p] = Te(0), m = q(!1);
  a = function() {
    return a === "dialog" || a === "alertdialog" ? a : (m.current || (m.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = Xi();
  i === void 0 && h !== null && (i = (h & ve.Open) === ve.Open);
  let w = q(null), f = Pe(w, e), g = Lr(w), y = t.hasOwnProperty("open") || h !== null, b = t.hasOwnProperty("onClose");
  if (!y && !b)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!y)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!b)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof i != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${i}`);
  if (typeof o != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${o}`);
  let x = i ? 0 : 1, [O, R] = zc(nm, { titleId: null, descriptionId: null, panelRef: Fc() }), S = G(() => o(!1)), W = G((K) => R({ type: 0, id: K })), he = Gt() ? c ? !1 : x === 0 : !1, le = u > 1, J = Oe(xn) !== null, [U, ce] = Mh(), Y = { get current() {
    var K;
    return (K = O.panelRef.current) != null ? K : w.current;
  } }, { resolveContainers: X, mainTreeNodeRef: se, MainTreeNode: me } = Yh({ portals: U, defaultContainers: [Y] }), Re = le ? "parent" : "leaf", mt = h !== null ? (h & ve.Closing) === ve.Closing : !1, Tt = J || mt ? !1 : he, Ye = Ft(() => {
    var K, Me;
    return (Me = Array.from((K = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? K : []).find((ge) => ge.id === "headlessui-portal-root" ? !1 : ge.contains(se.current) && ge instanceof HTMLElement)) != null ? Me : null;
  }, [se]);
  ds(Ye, Tt);
  let tt = le ? !0 : he, Se = Ft(() => {
    var K, Me;
    return (Me = Array.from((K = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? K : []).find((ge) => ge.contains(se.current) && ge instanceof HTMLElement)) != null ? Me : null;
  }, [se]);
  ds(Se, tt), eh(X, S, !(!he || le));
  let xe = !(le || x !== 0);
  ec(g == null ? void 0 : g.defaultView, "keydown", (K) => {
    xe && (K.defaultPrevented || K.key === Xa.Escape && (K.preventDefault(), K.stopPropagation(), S()));
  }), rm(g, !(mt || x !== 0 || J), X), ae(() => {
    if (x !== 0 || !w.current)
      return;
    let K = new ResizeObserver((Me) => {
      for (let ge of Me) {
        let jt = ge.target.getBoundingClientRect();
        jt.x === 0 && jt.y === 0 && jt.width === 0 && jt.height === 0 && S();
      }
    });
    return K.observe(w.current), () => K.disconnect();
  }, [x, w, S]);
  let [Xt, er] = Hh(), Nt = ye(() => [{ dialogState: x, close: S, setTitleId: W }, O], [x, O, S, W]), It = ye(() => ({ open: x === 0 }), [x]), Ot = { ref: f, id: n, role: a, "aria-modal": x === 0 ? !0 : void 0, "aria-labelledby": O.titleId, "aria-describedby": Xt };
  return P.createElement(Vh, { type: "Dialog", enabled: x === 0, element: w, onUpdate: G((K, Me) => {
    Me === "Dialog" && ue(K, { [Li.Add]: () => p((ge) => ge + 1), [Li.Remove]: () => p((ge) => ge - 1) });
  }) }, P.createElement(Si, { force: !0 }, P.createElement(Di, null, P.createElement(xn.Provider, { value: Nt }, P.createElement(Di.Group, { target: w }, P.createElement(Si, { force: !1 }, P.createElement(er, { slot: It, name: "Dialog.Description" }, P.createElement(ar, { initialFocus: s, containers: X, features: he ? ue(Re, { parent: ar.features.RestoreFocus, leaf: ar.features.All & ~ar.features.FocusLock }) : ar.features.None }, P.createElement(ce, null, je({ ourProps: Ot, theirProps: l, slot: It, defaultTag: im, features: om, visible: x === 0, name: "Dialog" }))))))))), P.createElement(me, null));
}
let am = "div";
function cm(t, e) {
  let r = Jt(), { id: n = `headlessui-dialog-overlay-${r}`, ...i } = t, [{ dialogState: o, close: s }] = Pr("Dialog.Overlay"), a = Pe(e), c = G((u) => {
    if (u.target === u.currentTarget) {
      if (ah(u.currentTarget))
        return u.preventDefault();
      u.preventDefault(), u.stopPropagation(), s();
    }
  }), l = ye(() => ({ open: o === 0 }), [o]);
  return je({ ourProps: { ref: a, id: n, "aria-hidden": !0, onClick: c }, theirProps: i, slot: l, defaultTag: am, name: "Dialog.Overlay" });
}
let lm = "div";
function um(t, e) {
  let r = Jt(), { id: n = `headlessui-dialog-backdrop-${r}`, ...i } = t, [{ dialogState: o }, s] = Pr("Dialog.Backdrop"), a = Pe(e);
  ae(() => {
    if (s.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [s.panelRef]);
  let c = ye(() => ({ open: o === 0 }), [o]);
  return P.createElement(Si, { force: !0 }, P.createElement(Di, null, je({ ourProps: { ref: a, id: n, "aria-hidden": !0 }, theirProps: i, slot: c, defaultTag: lm, name: "Dialog.Backdrop" })));
}
let dm = "div";
function pm(t, e) {
  let r = Jt(), { id: n = `headlessui-dialog-panel-${r}`, ...i } = t, [{ dialogState: o }, s] = Pr("Dialog.Panel"), a = Pe(e, s.panelRef), c = ye(() => ({ open: o === 0 }), [o]), l = G((u) => {
    u.stopPropagation();
  });
  return je({ ourProps: { ref: a, id: n, onClick: l }, theirProps: i, slot: c, defaultTag: dm, name: "Dialog.Panel" });
}
let fm = "h2";
function hm(t, e) {
  let r = Jt(), { id: n = `headlessui-dialog-title-${r}`, ...i } = t, [{ dialogState: o, setTitleId: s }] = Pr("Dialog.Title"), a = Pe(e);
  ae(() => (s(n), () => s(null)), [n, s]);
  let c = ye(() => ({ open: o === 0 }), [o]);
  return je({ ourProps: { ref: a, id: n }, theirProps: i, slot: c, defaultTag: fm, name: "Dialog.Title" });
}
let mm = _e(sm), gm = _e(um), wm = _e(pm), ym = _e(cm), vm = _e(hm), li = Object.assign(mm, { Backdrop: gm, Panel: wm, Overlay: ym, Title: vm, Description: Kh });
function bm(t = 0) {
  let [e, r] = Te(t), n = $r(), i = Ft((c) => {
    n.current && r((l) => l | c);
  }, [e, n]), o = Ft((c) => !!(e & c), [e]), s = Ft((c) => {
    n.current && r((l) => l & ~c);
  }, [r, n]), a = Ft((c) => {
    n.current && r((l) => l ^ c);
  }, [r]);
  return { flags: e, addFlag: i, hasFlag: o, removeFlag: s, toggleFlag: a };
}
function _m(t) {
  let e = { called: !1 };
  return (...r) => {
    if (!e.called)
      return e.called = !0, t(...r);
  };
}
function ui(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function di(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
function xm(t, e) {
  let r = Ct();
  if (!t)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: i } = getComputedStyle(t), [o, s] = [n, i].map((c) => {
    let [l = 0] = c.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, p) => p - u);
    return l;
  }), a = o + s;
  if (a !== 0) {
    r.group((l) => {
      l.setTimeout(() => {
        e(), l.dispose();
      }, a), l.addEventListener(t, "transitionrun", (u) => {
        u.target === u.currentTarget && l.dispose();
      });
    });
    let c = r.addEventListener(t, "transitionend", (l) => {
      l.target === l.currentTarget && (e(), c());
    });
  } else
    e();
  return r.add(() => e()), r.dispose;
}
function Mm(t, e, r, n) {
  let i = r ? "enter" : "leave", o = Ct(), s = n !== void 0 ? _m(n) : () => {
  };
  i === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let a = ue(i, { enter: () => e.enter, leave: () => e.leave }), c = ue(i, { enter: () => e.enterTo, leave: () => e.leaveTo }), l = ue(i, { enter: () => e.enterFrom, leave: () => e.leaveFrom });
  return di(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), ui(t, ...e.base, ...a, ...l), o.nextFrame(() => {
    di(t, ...e.base, ...a, ...l), ui(t, ...e.base, ...a, ...c), xm(t, () => (di(t, ...e.base, ...a), ui(t, ...e.base, ...e.entered), s()));
  }), o.dispose;
}
function Em({ immediate: t, container: e, direction: r, classes: n, onStart: i, onStop: o }) {
  let s = $r(), a = Gi(), c = Je(r);
  Ie(() => {
    t && (c.current = "enter");
  }, [t]), Ie(() => {
    let l = Ct();
    a.add(l.dispose);
    let u = e.current;
    if (u && c.current !== "idle" && s.current)
      return l.dispose(), i.current(c.current), l.add(Mm(u, n.current, c.current === "enter", () => {
        l.dispose(), o.current(c.current);
      })), l.dispose;
  }, [r]);
}
function rt(t = "") {
  return t.split(/\s+/).filter((e) => e.length > 1);
}
let Ln = Xe(null);
Ln.displayName = "TransitionContext";
var km = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(km || {});
function Cm() {
  let t = Oe(Ln);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function Tm() {
  let t = Oe($n);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let $n = Xe(null);
$n.displayName = "NestingContext";
function Pn(t) {
  return "children" in t ? Pn(t.children) : t.current.filter(({ el: e }) => e.current !== null).filter(({ state: e }) => e === "visible").length > 0;
}
function lc(t, e) {
  let r = Je(t), n = q([]), i = $r(), o = Gi(), s = G((h, w = st.Hidden) => {
    let f = n.current.findIndex(({ el: g }) => g === h);
    f !== -1 && (ue(w, { [st.Unmount]() {
      n.current.splice(f, 1);
    }, [st.Hidden]() {
      n.current[f].state = "hidden";
    } }), o.microTask(() => {
      var g;
      !Pn(n) && i.current && ((g = r.current) == null || g.call(r));
    }));
  }), a = G((h) => {
    let w = n.current.find(({ el: f }) => f === h);
    return w ? w.state !== "visible" && (w.state = "visible") : n.current.push({ el: h, state: "visible" }), () => s(h, st.Unmount);
  }), c = q([]), l = q(Promise.resolve()), u = q({ enter: [], leave: [], idle: [] }), p = G((h, w, f) => {
    c.current.splice(0), e && (e.chains.current[w] = e.chains.current[w].filter(([g]) => g !== h)), e == null || e.chains.current[w].push([h, new Promise((g) => {
      c.current.push(g);
    })]), e == null || e.chains.current[w].push([h, new Promise((g) => {
      Promise.all(u.current[w].map(([y, b]) => b)).then(() => g());
    })]), w === "enter" ? l.current = l.current.then(() => e == null ? void 0 : e.wait.current).then(() => f(w)) : f(w);
  }), m = G((h, w, f) => {
    Promise.all(u.current[w].splice(0).map(([g, y]) => y)).then(() => {
      var g;
      (g = c.current.shift()) == null || g();
    }).then(() => f(w));
  });
  return ye(() => ({ children: n, register: a, unregister: s, onStart: p, onStop: m, wait: l, chains: u }), [a, s, n, p, m, u, l]);
}
function Nm() {
}
let Im = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ps(t) {
  var e;
  let r = {};
  for (let n of Im)
    r[n] = (e = t[n]) != null ? e : Nm;
  return r;
}
function Om(t) {
  let e = q(ps(t));
  return ae(() => {
    e.current = ps(t);
  }, [t]), e;
}
let jm = "div", uc = bn.RenderStrategy;
function Sm(t, e) {
  var r, n;
  let { beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: a, enter: c, enterFrom: l, enterTo: u, entered: p, leave: m, leaveFrom: h, leaveTo: w, ...f } = t, g = q(null), y = Pe(g, e), b = (r = f.unmount) == null || r ? st.Unmount : st.Hidden, { show: x, appear: O, initial: R } = Cm(), [S, W] = Te(x ? "visible" : "hidden"), he = Tm(), { register: le, unregister: J } = he;
  ae(() => le(g), [le, g]), ae(() => {
    if (b === st.Hidden && g.current) {
      if (x && S !== "visible") {
        W("visible");
        return;
      }
      return ue(S, { hidden: () => J(g), visible: () => le(g) });
    }
  }, [S, g, le, J, x, b]);
  let U = Je({ base: rt(f.className), enter: rt(c), enterFrom: rt(l), enterTo: rt(u), entered: rt(p), leave: rt(m), leaveFrom: rt(h), leaveTo: rt(w) }), ce = Om({ beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: a }), Y = Gt();
  ae(() => {
    if (Y && S === "visible" && g.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [g, S, Y]);
  let X = R && !O, se = O && x && R, me = !Y || X ? "idle" : x ? "enter" : "leave", Re = bm(0), mt = G((xe) => ue(xe, { enter: () => {
    Re.addFlag(ve.Opening), ce.current.beforeEnter();
  }, leave: () => {
    Re.addFlag(ve.Closing), ce.current.beforeLeave();
  }, idle: () => {
  } })), Tt = G((xe) => ue(xe, { enter: () => {
    Re.removeFlag(ve.Opening), ce.current.afterEnter();
  }, leave: () => {
    Re.removeFlag(ve.Closing), ce.current.afterLeave();
  }, idle: () => {
  } })), Ye = lc(() => {
    W("hidden"), J(g);
  }, he), tt = q(!1);
  Em({ immediate: se, container: g, classes: U, direction: me, onStart: Je((xe) => {
    tt.current = !0, Ye.onStart(g, xe, mt);
  }), onStop: Je((xe) => {
    tt.current = !1, Ye.onStop(g, xe, Tt), xe === "leave" && !Pn(Ye) && (W("hidden"), J(g));
  }) });
  let Se = f, Kt = { ref: y };
  return se ? Se = { ...Se, className: vn(f.className, ...U.current.enter, ...U.current.enterFrom) } : tt.current && (Se.className = vn(f.className, (n = g.current) == null ? void 0 : n.className), Se.className === "" && delete Se.className), P.createElement($n.Provider, { value: Ye }, P.createElement(oh, { value: ue(S, { visible: ve.Open, hidden: ve.Closed }) | Re.flags }, je({ ourProps: Kt, theirProps: Se, defaultTag: jm, features: uc, visible: S === "visible", name: "Transition.Child" })));
}
function Am(t, e) {
  let { show: r, appear: n = !1, unmount: i = !0, ...o } = t, s = q(null), a = Pe(s, e);
  Gt();
  let c = Xi();
  if (r === void 0 && c !== null && (r = (c & ve.Open) === ve.Open), ![!0, !1].includes(r))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [l, u] = Te(r ? "visible" : "hidden"), p = lc(() => {
    u("hidden");
  }), [m, h] = Te(!0), w = q([r]);
  Ie(() => {
    m !== !1 && w.current[w.current.length - 1] !== r && (w.current.push(r), h(!1));
  }, [w, r]);
  let f = ye(() => ({ show: r, appear: n, initial: m }), [r, n, m]);
  ae(() => {
    if (r)
      u("visible");
    else if (!Pn(p))
      u("hidden");
    else {
      let x = s.current;
      if (!x)
        return;
      let O = x.getBoundingClientRect();
      O.x === 0 && O.y === 0 && O.width === 0 && O.height === 0 && u("hidden");
    }
  }, [r, p]);
  let g = { unmount: i }, y = G(() => {
    var x;
    m && h(!1), (x = t.beforeEnter) == null || x.call(t);
  }), b = G(() => {
    var x;
    m && h(!1), (x = t.beforeLeave) == null || x.call(t);
  });
  return P.createElement($n.Provider, { value: p }, P.createElement(Ln.Provider, { value: f }, je({ ourProps: { ...g, as: Ze, children: P.createElement(dc, { ref: a, ...g, ...o, beforeEnter: y, beforeLeave: b }) }, theirProps: {}, defaultTag: Ze, features: uc, visible: l === "visible", name: "Transition" })));
}
function Dm(t, e) {
  let r = Oe(Ln) !== null, n = Xi() !== null;
  return P.createElement(P.Fragment, null, !r && n ? P.createElement($i, { ref: e, ...t }) : P.createElement(dc, { ref: e, ...t }));
}
let $i = _e(Am), dc = _e(Sm), Lm = _e(Dm), pi = Object.assign($i, { Child: Lm, Root: $i });
function Cg({ isOpen: t, closeModal: e, value: r, selectedOption: n, handleChange: i, handleChangeInput: o, onConnect: s }) {
  const a = ["argentX", "braavos"];
  return /* @__PURE__ */ ne.jsx(ne.Fragment, { children: /* @__PURE__ */ ne.jsx(pi, { appear: !0, show: t, as: Ze, children: /* @__PURE__ */ ne.jsxs(li, { as: "div", className: "relative z-10", onClose: e, children: [
    /* @__PURE__ */ ne.jsx(
      pi.Child,
      {
        as: Ze,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ ne.jsx("div", { className: "fixed inset-0 bg-black/25" })
      }
    ),
    /* @__PURE__ */ ne.jsx("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ ne.jsx("div", { className: "flex min-h-full items-center justify-center p-4 text-center", children: /* @__PURE__ */ ne.jsx(
      pi.Child,
      {
        as: Ze,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ ne.jsxs(li.Panel, { className: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all", children: [
          /* @__PURE__ */ ne.jsxs("div", { className: "flex items-center justify-between mb-4", children: [
            /* @__PURE__ */ ne.jsx(
              li.Title,
              {
                as: "h3",
                className: "text-lg font-medium leading-6 text-gray-900",
                children: "Connect with tokenbound"
              }
            ),
            /* @__PURE__ */ ne.jsx("div", { onClick: e, className: "text-black cursor-pointer", children: "X" })
          ] }),
          /* @__PURE__ */ ne.jsxs("div", { className: "w-full", children: [
            /* @__PURE__ */ ne.jsx("label", { className: "text-black mb-2 block", htmlFor: "tba-address", children: "Token bound address" }),
            /* @__PURE__ */ ne.jsx(
              "input",
              {
                type: "text",
                placeholder: "TBA ADDRESS",
                id: "tba-address",
                value: r,
                onChange: o,
                className: "w-full border border-gray-300 bg-white text-black rounded px-3 py-2 mb-3 focus:outline-none focus:border-blue-500"
              }
            ),
            /* @__PURE__ */ ne.jsxs(
              "select",
              {
                onChange: i,
                value: n,
                className: "w-full border border-gray-300 bg-white text-black rounded px-3 py-2 mb-3 focus:outline-none focus:border-blue-500",
                children: [
                  /* @__PURE__ */ ne.jsx("option", { value: "id", children: "Select parent wallet" }),
                  a.map((c, l) => /* @__PURE__ */ ne.jsx("option", { value: c, children: c }, l))
                ]
              }
            )
          ] }),
          /* @__PURE__ */ ne.jsx("button", { onClick: s, className: "w-full text-white bg-[#0C0C4F] border-gray-500 outline-none p-2", children: "Connect with tokenbound account" })
        ] })
      }
    ) }) })
  ] }) }) });
}
export {
  Ur as F,
  Wc as L,
  _s as R,
  Cg as T,
  Uo as _,
  Mg as a,
  Eg as u
};
